var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount_no_decimals}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const regex = /\{\{([^}]+)\}\}/g;
  const currencyFormat = format.replace(regex, function (match, key) {
    return '{{' + window.theme.currencyFormat + '}}';
  });
  var formatString = currencyFormat || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key)
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach(callback => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);
let alreadyDelegated = false;
class Popup {
  constructor(element, additionalOverlay) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.headerTransparent = document.body
      .querySelector("#header")
      .classList.contains("Header--Transparent")
      ? true
      : false;

    if (additionalOverlay == true) {
      if (responsive.matchesBreakpoint('lap_and_up')) {
        this.pageOverlayElement = document.querySelector(".localizationOverlay.desktop");

      }
      else
        this.pageOverlayElement = document.querySelector(".localizationOverlay.mobile");
    } else {
      this.pageOverlayElement = document.querySelector(".pageOverlay");
    }
    if (alreadyDelegated == false) {
      this.bindEvents();
    }

  }
  bindEvents() {
    alreadyDelegated = true;

    this.delegateBody.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );

    this.delegateBody.on(
      "drawer:close-other",
      this.closeModal.bind(this)
    );
    this.delegateBody.on(
      "menu:open",
      this.closeModal.bind(this)
    );

    this.delegateBody.on(
      "keydown",
      this.onEsc.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  onEsc(e) {
    if (e.key === 'Escape') {

      this.closeModal(e);
    }
  }

  openModal(e) {
    event.preventDefault();
    event.stopPropagation();

    // Check if the modal is already open
    const isModalOpen = this.activeModal && this.activeModal.getAttribute("aria-hidden") === "false";
    if (isModalOpen) {
      this.closeModal(e);  // Close the modal if it's already open
      return;
    }



    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    this.pageOverlayElement.classList.add("is-visible");

    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.element.dispatchEvent(
        new CustomEvent("close:other", { bubbles: true })
      );

      if (this.headerTransparent)
        document
          .querySelector("#header")
          .classList.remove("Header--Transparent");

    }


    this.activeModal = document.getElementById(
      event.target.closest("[aria-controls]").getAttribute("aria-controls")
    );


    if (e.target.getAttribute('aria-expanded') === 'false') {
      e.target.setAttribute('aria-expanded', 'true');
    }

    if (this.activeModal.getAttribute("aria-hidden") === "false") return;
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.getBoundingClientRect(); // reflow



    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    requestAnimationFrame(() => {

      this.activeModal.setAttribute("aria-expanded", "true");
    });

    const focus = this.activeModal.querySelector("[data-scrollable]");

    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);

    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
  }

  closeModal(e) {
    e.preventDefault();

    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );

    if (!this.activeModal) return;

    if (this.myCursor) {
      this.myCursor.destroy();
    }

    const handleModalClose = (e) => {
      if (this.activeModal.getAttribute("aria-expanded") === "false" && this.activeModal.getAttribute("aria-hidden") === "false") {
        this.activeModal.setAttribute("aria-hidden", "true");
        bodyScrollLock.enableBodyScroll(focus);
      };
    }
    if (!this.activeModal) return;

    this.element.dispatchEvent(
      new CustomEvent("close:language", { bubbles: true })
    );

    this.activeModal.setAttribute("aria-expanded", "false");
    if (this.activeModal.classList.contains('account__popup')) {
      this.activeModal.addEventListener('animationend', handleModalClose, { once: true });
    } else {
      this.activeModal.addEventListener('transitionend', handleModalClose, { once: true });
    }

    if (this.headerTransparent && responsive.matchesBreakpoint('lap_and_up'))
      document
        .querySelector("#header")
        .classList.add("Header--Transparent");

    const activeBtn = document.body.querySelector('.RevolutionSelectbox--Button[aria-expanded="true"]');
    if (activeBtn) {
      activeBtn.setAttribute('aria-expanded', 'false');
    }

    const focus = this.activeModal.querySelector("[data-scrollable]");
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );



    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
    this.applyColorScheme();
  }

  applyColorScheme() {
    const productModule = document.querySelector('.product-module');
    const colorGroupClass = Array.from(productModule.classList).find(className => className.includes('colorGroup'));
    document.querySelector('.pswp').classList.add(colorGroupClass);
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".pm__product-slider--image",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );

    this.onPointerUpBinder = this.onPointerUp.bind(this);
    this.onPointerDownBinder = this.onPointerDown.bind(this);
    responsive.addBreakpointListener("lap_and_up");
    this.delegateRoot.on(
      "breakpoint:lap_and_up",
      this.toggleMoveZoom.bind(this)
    );
    this.toggleMoveZoom();

    if (responsive.matchesBreakpoint('pocket') && document.querySelector('[data-zoom-type="image"]')) {
      this.delegateElement.on(
        "click",
        '.pm__product-slider--image',
        this.initPhotoSwipeFromPhotoTap.bind(this)
      );
    }
  }

  toggleMoveZoom(e) {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.delegateRoot.on(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.on("pointerup", "[data-move]", this.onPointerUpBinder);
    } else {
      this.delegateRoot.off(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.off("pointerup", "[data-move]", this.onPointerUpBinder);
    }
  }

  onPointerDown(e) {
    this.timeout = setTimeout(() => {
      e.target.closest(".pswp__container")?.classList.add("move");
    }, 100);
  }

  onPointerUp(e) {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
    e.target.closest(".pswp__container")?.classList.remove("move");
  }

  photoswiperClose() {
    if (this.photoSwipeInstance) {
      this.photoSwipeInstance.close;
    }
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  sortImageArray(images) {
    return images.sort((a, b) => {
      const positionA = parseInt(a.closest(".pm__product-slider-element").getAttribute("data-image-position"));
      const positionB = parseInt(b.closest(".pm__product-slider-element").getAttribute("data-image-position"));
      return positionA - positionB;
    });
  }

  initPhotoSwipeFromPhotoTap(e) {
    if (e.target.closest('[data-action="open-product-zoom"]') || e.target.closest('.pm__product-highlight')) return;
    e.target.closest('.pm__product-slider-cell').querySelector('[data-action="open-product-zoom"]').click();
  }

  initPhotoSwipe(event, target) {
    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.querySelectorAll('.pm__product-slider-cell').forEach(function (item) {
        if (
          item.classList.contains("pm__product-slider-cell--zoom")
        ) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
    } else {
      images.push(
        document.querySelector(".pm__product-slider-image")
      );
    }

    const imagePosition = parseInt(
      target
        .nextElementSibling
        .getAttribute("data-image-position")
    );

    images = this.sortImageArray(images);

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(imagePosition)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (
      responsive.matchesBreakpoint("pocket") ||
      event.target.closest(".pm__product-highlight")
    ) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    var images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (
        item.classList.contains("pm__product-slider-cell--zoom") &&
        item.querySelector("img")
      ) {
        images.push(item.querySelector("img"));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(
      target
        .querySelector(".pm__product-slider-element")
        .getAttribute("data-image-position")
    );

    images = this.sortImageArray(images);

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      imagePosition
    );
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map((image) => {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      const maxWidth = parseInt(image.getAttribute("data-max-width"));
      const maxHeight = parseInt(image.getAttribute("data-max-height"));

      let initialHeight = Math.min(maxHeight, viewportHeight);
      let initialWidth = Math.min(maxWidth, viewportWidth);

      let initialZoomLevel = 0.65;
      const aspectRatio = maxWidth / maxHeight;
      initialWidth = initialHeight * aspectRatio;
      if (!responsive.matchesBreakpoint("phone")) {
        initialZoomLevel = Math.min(maxWidth, viewportWidth) / initialWidth;
      }

      return {
        msrc: image.currentSrc || image.src,
        w: initialWidth,
        h: initialHeight,
        initialZoomLevel: initialZoomLevel,
        initZoomLevel: initialZoomLevel,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return item.initZoomLevel;
          } else {
            return item.initialZoomLevel < 0.7 ? 1.5 : 1.5;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".pm__product-slider-cell--zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      (e) => {
        this.photoSwipeInstance.prev();
        e.target.classList.add('scale-animation');
        setTimeout(() => {
          e.target.classList.remove("scale-animation");
        }, 200);
      }
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      (e) => {
        this.photoSwipeInstance.next();
        e.target.classList.add('scale-animation');
        setTimeout(() => {
          e.target.classList.remove("scale-animation");
        }, 200);
      }
    );
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.delegateRoot.off(
      "pointerdown",
      "[data-move]",
      this.onPointerDownBinder
    );
    this.delegateRoot.off("pointerup", "[data-move]", this.onPointerUpBinder);
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;

    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );
    this.languageSelector = this.element.classList.contains(
      "RevolutionSelectbox--Selectors"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
      ".RevolutionSelectbox--Button"
    );


    this.headerTransparent = document.body
      .querySelector("#header")
      .classList.contains("Header--Transparent")
      ? true
      : false;


    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    if (!this.element.classList.contains("dropdownSelector")) {
      this.initSelectbox();
    } else {
      this.element.style.display = "block";
    }
  }

  bindEvents() {
    this.closeListener = this.closeDropdown.bind(this);
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.domDelegate.on(
      "keydown",
      "[data-action=selectbox-change]",
      onEnter(this.selectboxChange.bind(this))
    );


    if (this.element.classList.contains('rs-country__selectbox')) {
      this.delegateBody.on("close:language", this.onClickOutsideListener);
    }
    this.delegateBody.on("drawer:close-other", this.closeListener);
    this.delegateBody.on("menu:open", this.closeListener);
    this.domDelegate.on("click", "body", this.onClickOutsideListener);


    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
  }

  findAndScrollToMatch(contentElement, searchQuery) {
    const items = Array.from(contentElement.querySelectorAll(".RevolutionSelectbox--Item"));

    const matchedItem = items.find(item => {
      const itemText = item.textContent.toLowerCase().trim();
      return itemText.startsWith(searchQuery.trim());
    });

    if (matchedItem) {
      matchedItem.focus();
    }
  }

  initSearchWithinDropdown(contentElement) {
    let searchQuery = "";

    this.keydownListener = (event) => {
      if (!this.resetQuery) {
        this.resetQuery = setTimeout(() => {
          searchQuery = "";
          this.resetQuery = null;
        }, 1000);
      }

      searchQuery += event.key.toLowerCase();
      if (searchQuery.length > 0) {
        this.findAndScrollToMatch(contentElement, searchQuery);
      }
    };

    window.addEventListener("keydown", this.keydownListener);
  }

  selectboxChange() {
    const value = event.target.getAttribute("data-value");
    const selectboxID = event.target.getAttribute("data-selectboxid");
    let innerContent = event.target.innerHTML;
    const selEl = this.element.querySelector("#" + selectboxID);


    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if (this.mainButton.querySelector('.revolution-selectbox__flag')) {
      this.mainButton.querySelector('.revolution-selectbox__flag').remove();
    }

    if (this.element.classList.contains("dropdownSelector")) {
      const selectedItem = this.element.querySelector('.RevolutionSelectbox--Item[selected="selected"]');
      if (selectedItem) {
        selectedItem.removeAttribute("selected");
      }
      event.target.setAttribute("selected", "selected");
    }

    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl.value = value;

    }

    if (event.target.dataset.selectboxid == 'country-selector__country-code') {
      this.element.dispatchEvent(
        new CustomEvent("change:countrySelector", {
          bubbles: true,
          detail: {
            currency: event.target.dataset.currency,
            country: event.target.value,
            languages: event.target.dataset.languages
          },
        })
      );

    }


    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }



  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    var value = event.target.closest("[data-value]").getAttribute("data-value");
    var dataName = event.target
      .closest("[data-name]")
      .getAttribute("data-name");
    this.selectbox.value = value;

    this.closeDropdown(this.element);

    this.element.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    if (!this.mainDropdown) return;
    const selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem && this.connectedSelect != 'country_code') {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);

    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {

    const closestSelectbox = target.closest('.rs-country__selectbox');
    if (closestSelectbox) {
      closestSelectbox.setAttribute('aria-expanded', 'true')
    }
    // Dispatch "close:search" and "menu:close" events on the element.
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );




    if (this.changeOverlay) {
      var focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));



    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });



    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      const headerOverlay = document.querySelector(".header-overlay");
      if (headerOverlay) {
        headerOverlay.classList.add("is-visible");
      }
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );

      trapFocus(this.mainDropdown);
    }

    if (this.element.closest(".focusable.country-selector")) {
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );
    contentElement.style.display = "block";
    contentElement.style.visibility = 'hidden';


    requestAnimationFrame(() => {
      contentElement.style.height = '';
      const height = contentElement.offsetHeight;
      contentElement.style.height = '0';
      contentElement.style.visibility = 'visible';
      requestAnimationFrame(() => {
        contentElement.style.height = `${height}px`;
      });
    });


    requestAnimationFrame(() => {
      target.setAttribute("aria-expanded", "true");
    });

    if (this.popover) {
      requestAnimationFrame(() => {
        contentElement.setAttribute("aria-hidden", "false");
      });
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }


    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
    this.initSearchWithinDropdown(contentElement);
  }

  closeDropdown(target) {

    if (this.isOpen == false) { return; }
    if (this.changeOverlay) {
      var focus = this.element.querySelector("[data-scrollable]");

      bodyScrollLock.enableBodyScroll(focus, bodyScrollLockOptions);
    }
    const closestSelectbox = target.closest('.rs-country__selectbox');
    if (closestSelectbox) {
      closestSelectbox.setAttribute('aria-expanded', 'false')
    }

    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    closestDropdown.querySelector(
      ".RevolutionSelectbox--Content"
    ).style.height = "0px";
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 301);

    if (this.keydownListener) {
      window.removeEventListener("keydown", this.keydownListener);
      this.keydownListener = null;
    }

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      const headerOverlay = document.querySelector(".header-overlay");
      if (headerOverlay) {
        headerOverlay.classList.remove("is-visible");
      }
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );
    }
    if (this.myCursor) {

      this.myCursor.destroy();
    }

    if (this.element.closest("#modal-country") && responsive.matchesBreakpoint('pocket')) {
      const focus = this.element.querySelector("[data-scrollable]");

      bodyScrollLock.enableBodyScroll(focus);
    }

    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

var modelImgSrc;
class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
  }

  pdpValidation(target) {
    let checkboxesChecked = true;
    let inputsPopulated = true
    
    if (!target || !target.closest('[data-product-form]')) return true;
    
    const variantSelector = document.querySelector('variant-selects');
    if (!variantSelector) return true;
    
    const requiredCheckboxes = [...variantSelector.querySelectorAll('.pm__checkbox-input[required]')];
    const allChecked = requiredCheckboxes.every(checkbox => checkbox.checked);
    
    // are all variants selected
    if (requiredCheckboxes.length > 0) {
      if (allChecked) {
        variantSelector.classList.remove('checkbox-error');
        const errorElements = variantSelector.querySelectorAll('.pm__error');
        if (errorElements.length > 0) errorElements[errorElements.length - 1].setAttribute('aria-hidden', true);
        checkboxesChecked = true;
      } else {
        variantSelector.classList.add('checkbox-error');
        const errorElements = variantSelector.querySelectorAll('.pm__error');
        if (errorElements.length > 0) errorElements[errorElements.length - 1].setAttribute('aria-hidden', false);
        const lastErrorSpan = errorElements[errorElements.length - 1];
        lastErrorSpan.parentElement.scrollIntoView();
        checkboxesChecked = false;
      }
    }
    
    const requiredInputs = [...variantSelector.querySelectorAll('[aria-hidden="false"] .pm__property-input')]
    const emptyInputs = requiredInputs.filter(input => !input.value.trim());
    
    // are all required inputs filled
    if (requiredInputs.length > 0) {
      if (emptyInputs.length > 0) {
        emptyInputs.forEach(input => input.nextElementSibling.setAttribute('aria-hidden', false));
        inputsPopulated = false;
        
        const lastEmptyInput = emptyInputs[emptyInputs.length - 1];
        lastEmptyInput.scrollIntoView();
      } else {
        requiredInputs.forEach(input => {
          input.nextElementSibling.setAttribute('aria-hidden', true);
          input.parentElement.querySelectorAll('.pm__property-input-hidden').forEach(propertyInput => propertyInput.value = input.value);
        });
        
        inputsPopulated = true;
      }
    }
    
    // if no required checkboxes or inputs, skip validation
    if (!requiredCheckboxes.length && !requiredInputs.length) return true;
    
    return checkboxesChecked && inputsPopulated
  }

  storeImage() {
    return;

    const studioViewer = document.querySelector('studio-viewer');
    if (!studioViewer) return;

    const customInput = document.querySelector('.pm__custom-input');

    const randomNumber = Math.floor(new Date().getTime() + Math.random() * 10);
    customInput.value = randomNumber;

    try {
      studioViewer.createScreenshotBlob();

      setTimeout(async () => {
        const img = new Image();
        img.src = modelImgSrc;

        let height = 270 / 0.8;
        if (responsive.matchesBreakpoint("lap_and_up")) {
          height = 270;
        }

          // Create the ImageBitmap and resize the image using createImageBitmap
          const imageBitmap = await createImageBitmap(img, {
            resizeWidth: 270,  // Resize width to 108px
            resizeHeight: height, // Resize height to 135px
            resizeQuality: 'high' // Use high quality for resizing
          });

          // Create a canvas to draw the resized image
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // Set the canvas size to match the resized image dimensions
          canvas.width = imageBitmap.width;
          canvas.height = imageBitmap.height;

          // Draw the resized image onto the canvas
          ctx.drawImage(imageBitmap, 0, 0);

          // Convert the resized image to a base64 string
          const resizedImageBase64 = canvas.toDataURL('image/png');

          // Retrieve existing data from localStorage, or initialize it
          let storedData = JSON.parse(localStorage.getItem('imageData')) || {};

          // Store the resized image in localStorage under the random number key
          storedData[randomNumber] = resizedImageBase64;

          // Save the updated data back to localStorage
          localStorage.setItem('imageData', JSON.stringify(storedData));
        
      }, 50);
    } catch(error) {
      console.error('Error resizing and storing image:', error);
    }
  }

  getImgUrl(target) {
    const wrapper = target.closest('product-component');
    const designYourOwn = document.getElementById('js-design-your-own').value === 'true';
    const studioViewer = wrapper?.querySelector("studio-viewer");

    if (!designYourOwn) {
      console.info('Product Added: Shopify Image used: DYO TAG do not exist');
      return null;
    }

    if (!studioViewer) {
      const atc = target.closest('[data-action="add-to-cart"]');
      
      if (atc.classList.contains('pm__atc-button--main'))
        document.querySelector('studio-viewer');
    }
    
    const imageUrl = studioViewer?.getImageUrl();

    return this.resizeCartItemImage(imageUrl);
  }

  resizeCartItemImage(imageUrl) {
    if (!imageUrl) return null;

    const urlHelper = new URL(imageUrl);
    urlHelper.searchParams.set('width', '200');
    urlHelper.searchParams.set('height', '200');

    return urlHelper.toString();
  }

  async addToCart(e, target) {
    e.preventDefault();

    if (!this.pdpValidation(target)) return;

    const addToCartButton = e.target;
    const formElement = addToCartButton.closest('form');
    if (!formElement) return;

    // Start loader and disable button
    this.pageLoader.style.width = '100%';
    addToCartButton.disabled = true;

    // Ensure variant id is enabled before serialize
    const idInput = formElement.querySelector('[name="id"]');
    idInput?.removeAttribute('disabled');

    // Serialize form (uses your existing Form helper)
    const formHelper = new Form();
    const payload = formHelper.serialize(formElement);

    let customImg = this.getImgUrl(target);
    
    const customDYOImage = this.resizeCartItemImage(document.querySelector('[data-custom-dyo-image-src]')?.value);
    if (customDYOImage) {
        customImg = customDYOImage;
    }

    if (customImg) {
      payload.properties = payload.properties || {};
      payload.properties['_custom_img'] = customImg;
    }

    try {
      const response = await fetch(`${window.routes.localeRootUrl}/cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        // Try to parse Shopify error JSON; fall back to a generic message
        const content = await response.json().catch(() => ({}));
        this.showAddToCartError(content?.description || 'Unable to add to cart.', addToCartButton);
        return;
      }

      // Success paths
      if (window.theme.cartMode === 'page') {
        window.location.href = window.routes.cart_page_url;
        return;
      }

      if (window.location.href.includes('/cart')) {
        window.location.reload();
        return;
      }

      // Re-enable button for ajax drawer/mini-cart flows
      addToCartButton.disabled = false;

      // Fire event for any listeners (e.g., open mini-cart)
      this.element.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: payload.id,
            quantity: payload.quantity
          }
        })
      );

      // A11y announce
      announceToLiveRegion('itemAdded');
    } catch (err) {
      this.showAddToCartError('Network error. Please try again.', addToCartButton);
    } finally {
      // Reset loader animation and restore id input state just in case
      this.resetLoader();
      if (idInput && idInput.disabled === true) {
        idInput.disabled = false;
      }
    }
  }

  resetLoader() {
    const pl = this.pageLoader;
    if (!pl) return;

    // Mirror your original left/right swap animation
    pl.style.left = 'unset';
    pl.style.right = '0px';
    pl.style.width = '0%';
    setTimeout(() => {
      pl.style.left = '0px';
      pl.style.right = 'unset';
    }, 550);
}

  showAddToCartError(message, buttonEl) {
    const errorContainer = this.element.querySelector('.ProductForm--Error');

    if (errorContainer) {
      errorContainer.classList.add('visible');
      setTimeout(() => errorContainer.classList.remove('visible'), 2500);
    } else {
      const errorMessageElement = document.createElement('span');
      errorMessageElement.className = 'u-p4 accent';
      errorMessageElement.innerHTML = message;
      buttonEl?.insertAdjacentElement('afterend', errorMessageElement);
      setTimeout(() => errorMessageElement.remove(), 2500);
    }

    // Ensure UI is usable again
    buttonEl?.removeAttribute('disabled');
    this.resetLoader();
  }
}

/*GLOBAL FUNCTIONS */
// Function to handle the Enter key on labels
function handleLabelEnter(e) {
  // Check if the pressed key is "Enter"
  if (e.key === "Enter" || e.keyCode === 13) {
    e.preventDefault(); // Prevent any default behavior (like form submission)
    // Trigger the click event on the label
    e.target.click();
  }
}

// Select all label elements and ensure they are focusable
document.querySelectorAll("label").forEach((label) => {
  // If the label isn't naturally focusable, add a tabindex attribute
  if (!label.hasAttribute("tabindex")) {
    label.setAttribute("tabindex", "0");
  }
  // Attach the keydown event listener to handle the Enter key
  label.addEventListener("keydown", handleLabelEnter);
});


function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}


class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.sortFilter = document.querySelector(".collection__sort-drawer");
    this.sortButton = document.querySelector(".collection__sort-button");
    this.collectionFilter = document.querySelector(".collection__filter-drawer");
    this.filterButton = document.querySelector(".filter-bar__filter-button");
    this.termsArrow = document.querySelector("terms-and-conditions .svg__arrow-down");

    this.bindEvents();
    this.savedScrollY = null;


  }


  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=toggle-sort]",
      this.toggleSort.bind(this)
    );

    this.domDelegate.on(
      "pointerdown",
      ".jdgm-paginate__page ",
      this.handleReviewPagination.bind(this)
    );

    this.domDelegate.on(
      "keydown",
      "[data-action=toggle-dropdown]",
      onEscape((event) => {
        const button = event.target.closest("[data-action=toggle-dropdown]");
        const dropdown = button.closest(".Dropdown"); 
        if (!dropdown) return;
    
        this.closeDropdown(dropdown, false, false, button);
      })
    );
    this.domDelegate.on(
      "keydown",
      "[data-action=toggle-sort]",
      onEscape((event) => {
        const isExpanded = this.sortFilter?.getAttribute("aria-expanded") === "true";
        if (isExpanded) {
          this.toggleSort();
        }
      })
    );
    
    
    let selector;
    switch (this.breakpoint) {
      case "desktop":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
    this.onClickOutsideBinder = this.onClickOutside.bind(this);

    document.addEventListener("DOMContentLoaded", this.handleReviewDropdown.bind(this));

    
  }

  handleReviewDropdown() {
    const dropdownsArray = Array.from(this.allDropdowns);
    const hasReviewDropdown = dropdownsArray.some(dropdown =>
      dropdown.classList.contains("pm__dropdown--reviews")
    );
  
    if (hasReviewDropdown) {
      dropdownsArray.forEach(dropdown => {
        if(dropdown.classList.contains("pm__dropdown")){

          dropdown.classList.add("do-not-close");
        }
      });
    }
  }

  handleReviewPagination() {
    jdgm.scrollTo = () => {}
  }

  toggleSort() {
    if (this.filterButton && this.filterButton.getAttribute("aria-expanded") == "true") {
      this.filterButton.click();
    }

    if (responsive.matchesBreakpoint('pocket')) {
      if (this.sortFilter.getAttribute("aria-expanded") == "true") {
        new RevolutionAnimation(this.sortFilter, "true").slideUp();
      } else {
        new RevolutionAnimation(this.sortFilter, "true").slideDown();
      }
    }

    if (this.sortFilter.getAttribute("aria-expanded") == "true") {
      if (!responsive.matchesBreakpoint('pocket')) {
        bodyScrollLock.enableBodyScroll(document.querySelector('.collection__sort-drawer'), bodyScrollLockOptions);
      }
      this.domDelegate.off("click", "body", this.onClickOutsideBinder);
    } else {
      this.drContent = this.sortFilter;
      this.domDelegate.on("click", "body", this.onClickOutsideBinder);
      if (!responsive.matchesBreakpoint('pocket')) {
        bodyScrollLock.disableBodyScroll(document.querySelector('.collection__sort-drawer'), bodyScrollLockOptions);
      }
    }
    
    if (this.sortFilter) {
      this.sortFilter.setAttribute("aria-expanded", this.sortFilter.getAttribute("aria-expanded") == "false" ? "true" : "false");
    }

    if (responsive.matchesBreakpoint('lap_and_up')) {
      if (this.collectionFilter.getAttribute("aria-hidden") == "false") {
        this.collectionFilter.setAttribute("aria-hidden", "true");
        this.collectionFilter.style.height = 0;
      }
    }

    if (this.sortButton)
      this.sortButton.setAttribute("aria-expanded", this.sortButton.getAttribute("aria-expanded") == "false" ? "true" : "false"
      );

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height" || event.propertyName === "opacity") {
        this.sortFilter.setAttribute("aria-hidden", this.sortFilter.getAttribute("aria-hidden") == "false" ? "true" : "false");
        this.sortFilter.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.sortFilter.addEventListener("transitionend", transitionEndHandler);
    }
  }

  onClickOutside(e) {
    const withinBoundaries = e.composedPath().includes(this.drContent);
    if (!withinBoundaries) {
      if (this.drContent == this.sortFilter) {
        this.toggleSort();
      } else {
        this.closeDropdown(document.querySelector('.collection__overlay'));
      }
    }
  }

  openDropdown(elem, target) {

    if (this.sortButton && this.sortButton.getAttribute("aria-expanded") == "true") {
      this.sortButton.click();
    }
    if (this.lock) return;

    this.lock = true;


    // Open the dropdown by setting appropriate attributes and performing animation
    let DropdownButton = elem.querySelector(".Dropdown--Button");
    let DropdownContent = elem.querySelector(".Dropdown--Content");

    if(elem.classList.contains("pm__dropdown--reviews")){
      this.savedScrollY = window.scrollY;
    }

    if (target && target.hasAttribute('data-target')) {
      DropdownButton = target;
      DropdownContent = elem.querySelector(`.${target.getAttribute('data-target')}`);
    }

    if (this.termsArrow) {
      this.termsArrow.classList.add("rotate");
    }

    this.allDropdowns.forEach((dropdown) => {

      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close") &&
        !dropdown.classList.contains("c__dropdown") &&
        !dropdown.contains(elem)
      ) {
        this.closeDropdown(dropdown, true);

         // 🔹 If we previously saved scroll (from Reviews dropdown), restore it now
      if (this.savedScrollY !== null) {
        setTimeout(() => {
          window.scrollTo(0, this.savedScrollY);
          console.log("window final posiiton" , window.scrollY)
          this.savedScrollY = null;
        }, 150); // adjust if Judge.me loads slower
      }
      } else if (target && target.hasAttribute('data-target') && dropdown.classList.contains('c__dropdown') && !dropdown.classList.contains("do-not-close")) {

        const toClose = dropdown.querySelector(`[aria-expanded="true"]`);
        if (toClose) {
          const toCloseId = toClose.getAttribute('data-target');
          const toCloseDropdown = document.querySelector(`.${toCloseId}`);



          if (toCloseDropdown && toCloseDropdown !== DropdownContent) {

            this.closeDropdown(dropdown, true, false, toClose);


          // 🔹 Restore scroll here too if needed
          if (this.savedScrollY !== null) {
            setTimeout(() => {
              window.scrollTo(0, this.savedScrollY);
              console.log("window final posiiton 2" , window.scrollY)

              this.savedScrollY = null;
            }, 150);
          }

          }
        }
      }
    });

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height" || event.propertyName === "opacity") {
        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    DropdownContent.setAttribute("aria-expanded", "true");
    DropdownButton.setAttribute("aria-expanded", "true");
    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeAllDropdowns(namespace) {
    namespace.querySelectorAll(".Dropdown").forEach((dropdown) => {
      if (
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });
  }

  closeDropdown(elem, ignore, leaveOpen, target) {
    if (leaveOpen) return;
    if (this.lock && !ignore) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    let DropdownButton = elem.querySelector(".Dropdown--Button");
    let DropdownContent = elem.querySelector(".Dropdown--Content");

    if (target && target.hasAttribute('data-target')) {
      DropdownButton = target;
      DropdownContent = elem.querySelector(`.${target.getAttribute('data-target')}`);
    }

    if (this.termsArrow) {
      this.termsArrow.classList.remove("rotate");
    }

    if (elem.classList.contains('collection__overlay')) {
      this.domDelegate.off("click", "body", this.onClickOutsideBinder);
      if (!responsive.matchesBreakpoint('pocket')) {
        bodyScrollLock.clearAllBodyScrollLocks();
      }
    }

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height" || event.propertyName === "opacity") {
        if (DropdownContent.getAttribute("aria-hidden") == "false") {
          DropdownContent.setAttribute("aria-hidden", "true");
        }

        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
    DropdownContent.setAttribute("aria-expanded", "false");
  }

  toggleDropdown(event, target) {

    event.preventDefault();

    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";
    let leaveOpen = false;
    if (isOpen && event && event.explicitOriginalTarget && event.explicitOriginalTarget.classList.contains('pm__rating-link')) leaveOpen = true;
    const parentElement = mainDropdown.parentElement;
    if (parentElement && parentElement.classList.contains('sideBar--DropdownContainer')) { //Trigger reflow for Chrome overflow bug
      parentElement.style.overflow = 'hidden';
      setTimeout(function () {
        parentElement.style.overflow = 'visible';
      }, 300)
    }

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target, leaveOpen, target);
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);
      }
    }
  }
 



}

const allDropdowns = new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper, config) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.config = config || null;
    this.initialConfig = this.config || JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }
}


class ProductCache {
  constructor() {
    if (!ProductCache.instance) {
      this.cache = new Map();
      ProductCache.instance = this;
    }
    return ProductCache.instance;
  }

  addProducts(html) {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    const allProducts = tempElement.querySelectorAll(".recent__item");

    allProducts.forEach((product) => {

      product.classList.remove("recent__item");
      product.classList.add('favorites-item');
      product.querySelector('.toggle-favorites').setAttribute('state', 'active');
      const id = product.getAttribute("data-id");
      if (id && !this.cache.has(id)) {
        this.cache.set(id, product.cloneNode(true));
      }
    });

    // Notify listeners when products are added

    this.dispatchCacheUpdated();
  }

  removeProduct(productId) {
    this.cache.delete(productId);
    this.dispatchCacheUpdated();
  }

  getProducts() {
    return Array.from(this.cache.values());
  }

  clear() {
    this.cache.clear();
    this.dispatchCacheUpdated();
  }

  async loadFromStorage() {
    const favoriteIds = JSON.parse(localStorage.getItem("productFavorites") || "[]");

    if (favoriteIds.length === 0) {

      this.dispatchCacheUpdated();
      return;
    }



    const chunkSize = 10;
    const idChunks = [];

    // Split favoriteIds into chunks of 10
    for (let i = 0; i < favoriteIds.length; i += chunkSize) {
      idChunks.push(favoriteIds.slice(i, i + chunkSize));
    }

    try {
      // Make multiple requests using Promise.all
      const responses = await Promise.all(
        idChunks.map(async (chunk) => {
          const queryString = chunk.map((id) => `id:${id}`).join(" OR ");
          const response = await fetch(
            `${window.routes.localeRootUrl}/search?view=recently&type=product&q=${queryString}`
          );
          return response.text();
        })
      );

      // Combine all responses and add to cache
      responses.forEach((html) => this.addProducts(html));

      // Dispatch event after cache is fully loaded


    } catch (error) {
      console.error("Error re-caching products:", error);
    }
  }

  dispatchCacheUpdated() {
    document.dispatchEvent(new CustomEvent("cache:updated", { detail: { cacheSize: this.cache.size } }));
  }
}

// Initialize cache globally
const favoritesCache = new ProductCache();



class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pdpOverlayId = this.element.getAttribute('data-drawer-id') || null;
    this.pageOverlayElement = document.querySelector('.pageOverlay');
    this.pdpDrawerOverlay = this.pdpOverlayId ? document.querySelector(`#${this.pdpOverlayId}`) : null;

    this.headerTransparent = document.body
      .querySelector("#header")
      .classList.contains("Header--Transparent")
      ? true
      : false;


    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;


    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );

    this._closeListener = this.closeDrawer.bind(this);

    this.delegateBody.on(
      "keydown",
      this.closeDrawerEsc.bind(this)
    );

    this.delegateBody.on("drawer:close-other", this._closeListener);
  }

  closeDrawerEsc(e) {
    if (e.key !== "Escape") return;

    if (this.isOpen) {
      this.closeDrawer(e);
    }
  }


  toggleDrawer(event) {
    event.preventDefault();


    if (this.isTranslating) {
      return;
    }
    this.isOpen ? this.closeDrawer(event) : this.openDrawer(event);
  }

  openDrawer(e) {
    if (this.isOpen) {
      return;
    }

    dynamicVars.syncHeight();

    this.isTranslating = true;

    if (this.headerTransparent) {
      document.body
        .querySelector("#header")
        .classList.remove("Header--Transparent");
    }


    this.headerScrolled = document.body
      .querySelector("#header")
      .classList.contains("header--scrolled")
      ? true
      : false;


    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent("open:sidecart", { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    this.transitionStartedListener = this.translateTransitionStarted.bind(this);
    this.element.addEventListener("transitionend", this.transitionStartedListener);

    if (this.element.getAttribute("id") == "product-card-popup") {
      this.element.dispatchEvent(
        new CustomEvent("product-card-drawer:open", {
          bubbles: true,
          detail: {
            product: event.target.dataset.productId,
          },
        })
      );
    }

    if (this.element.getAttribute("id") == "product-detail__drawer") {
      this.element.dispatchEvent(
        new CustomEvent("product-detail__drawer:change-slide", {
          bubbles: true,
          detail: {
            buttonIndex: event.target.dataset.index,
          },
        })
      );
    }


    if (this.element.getAttribute("id") == "Drawer") {
      this.element.parentElement.style.display = "block";
      this.hamburger = document.body.querySelector(".header-hamburger-btn");
      this.hamburger.classList.add("is-active");
      this.pageOverlayElement = null;


      requestAnimationFrame(() => {
        this.element.parentElement.querySelector('.Drawer--Footer').setAttribute('aria-hidden', 'false');
      });

    }
    this.element.setAttribute("aria-hidden", "false");
    this.element.offsetHeight;

    if ((this.element.id === "collection__sort-drawer" || this.element.id === "collection__filter-drawer") && responsive.matchesBreakpoint("lap_and_up")) {
      this.pageOverlayElement.style.opacity = 0;
    }



    requestAnimationFrame(() => {
      this.element.setAttribute('aria-expanded', 'true');
      if (this.pageOverlayElement && !this.pdpOverlayId) {
        this.pageOverlayElement.classList.add('is-visible');
        this.pageOverlayElement.addEventListener('click', this._closeListener);
      }

      if (this.pdpOverlayId && this.pdpDrawerOverlay) {
        this.pdpDrawerOverlay.classList.add('is-visible');
        this.pdpDrawerOverlay.addEventListener('click', this._closeListener);
      }

      trapFocus(this.element);
    });



    if (this.element.getAttribute("data-id") == "cart-drawer") {
      this.headerHeightCart = this.element.querySelector(".Drawer--Header")?.offsetHeight || 0;
      this.footerHeightCart = this.element.querySelector(".Drawer--Footer")?.offsetHeight || 0;
      document.documentElement.style.setProperty(
        "--cart-footer-height",
        `${this.footerHeightCart}px`
      );
      document.documentElement.style.setProperty(
        "--cart-header-height",
        `${this.headerHeightCart}px`
      );
    }

    if (this.element.classList.contains('pm__drawer')) {
      const headerHeight = this.element.querySelector(".Drawer--Header")?.offsetHeight || 0;
      document.documentElement.style.setProperty(
        "--pm-drawer-header-height",
        `${headerHeight}px`
      );
    }

    const focus = this.element.querySelector("[data-scrollable]");

    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");
    this.isOpen = true;



    if (this.element.getAttribute("id") == "product-card-popup") {
      this.pageOverlayElement.style.opacity = 0.1;
    }

    this.onOpen(e);

    return false;
  }

  closeDrawer() {
    if (!this.isOpen) {
      return;
    }

    this.isTranslating = true;

    this.element.dispatchEvent(
      new CustomEvent("sidebar-drawer:close", {
        bubbles: true,
      })
    );

    this.transitionEndedListener = this.translateTransitionEnded.bind(this);
    this.element.addEventListener("transitionend", this.transitionEndedListener);

    this.element.setAttribute('aria-expanded', 'false');
    if (this.pageOverlayElement && !this.pdpOverlayId) {
      this.pageOverlayElement.classList.remove('is-visible');
      this.pageOverlayElement.removeEventListener('click', this._closeListener);
    }

    if (this.pdpOverlayId && this.pdpDrawerOverlay) {
      this.pdpDrawerOverlay.classList.remove('is-visible');
      this.pdpDrawerOverlay.removeEventListener('click', this._closeListener);
    }

    if (this.element.getAttribute('id') == 'product-card-popup') {
      this.pageOverlayElement.style.opacity = 0;
    }


    if (this.element.id == 'Drawer') {
      this.hamburger.classList.remove("is-active");
      this.element.parentElement.querySelector('.Drawer--Footer').setAttribute('aria-hidden', 'true');

    }

    if (this.element.getAttribute("id") == "product-detail__drawer") {
      this.element.dispatchEvent(
        new CustomEvent("product-detail__drawer:close", {
          bubbles: true
        })
      );
    }

    if (this.headerTransparent && !this.headerScrolled) {
      document.body
        .querySelector("#header")
        .classList.add("Header--Transparent");
    } else if (this.headerScrolled) {
      document.body
        .querySelector("#header")
        .classList.remove("Header--Transparent");
    }

    
    bodyScrollLock.enableBodyScroll(focus, bodyScrollLockOptions);

    document.body.classList.remove("scrollLock");
  }

  translateTransitionStarted() {
    if (event.propertyName == "transform" || event.propertyName == 'opacity') {
      this.isTranslating = false;

    }
  }

  translateTransitionEnded() {

    if (event.propertyName == "transform" || event.propertyName == 'opacity') {
      this.element.setAttribute('aria-hidden', 'true');

      if (this.element.id == 'Drawer') {
        this.element.parentElement.style.display = "none";
      }

      removeTrapFocus(this.element);
      const focus = this.element.querySelector("[data-scrollable]");
      if (!document.body.classList.contains('scrollLock')) {
        bodyScrollLock.clearAllBodyScrollLocks();
      }
      this.onClose();

      this.isOpen = false;

      this.isTranslating = false;

      this.element.removeEventListener(
        "transitionend",
        this.transitionEndedListener
      );
    }
  }

}

class swiperSlider {
  constructor(swiper, element) {
    this.element = element;
    this.swiper = swiper;
    this.nextButton = this.element.querySelector(".swiper-button-next");
    this.prevButton = this.element.querySelector(".swiper-button-prev");
    // this.initScrollbar();
  }

  initScrollbar() {
    const scrollbar = this.element.querySelector(".swiper-scrollbar");
    if (!scrollbar) return;

    const customScroll = scrollbar.querySelector(".swiper-scrollbar-drag");
    let progressInitial = this.calculateProgressInitial(this.swiper);

    // Show left arrow on next click, drag or touch move
    this.nextButton.addEventListener("click", () => {
      this.prevButton.classList.add("is-visible");
    });

    this.swiper.on("touchMove", () => {
      this.prevButton.classList.add("is-visible");
    });

    this.swiper.on("sliderMove", () => {
      this.prevButton.classList.add("is-visible");
    });

    // Set initial scroll custom width
    requestAnimationFrame(() => {
      if (!this.swiper.params.loop) {
        progressInitial = (1 / (this.swiper.slides.length)) / 2
      }



      const correctWidth = `${progressInitial * 100}%`;

      setTimeout(() => { customScroll.style.width = correctWidth; }, 1000);

    });



    // Variable for storing changed width on slideChange
    let setWidth;

    // Event handlers to update the scrollbar position as the swiper slides
    this.swiper.on("setTranslate", () => {

      customScroll.style.transform = "translate3d(0px, 0px, 0px)";
      if (setWidth) {
        customScroll.style.width = setWidth;
      }
    });

    this.swiper.on('slideChange', () => {
      let customProgress = 1 / (this.swiper.slides.length);

      if (this.swiper.params.loop) {
        if (this.swiper.realIndex === 0) {
          customProgress = 1 / (this.swiper.slides.length);
        }
        else {
          customProgress = (this.swiper.realIndex + 1) / (this.swiper.slides.length);
        }
      } else {
        if (this.swiper.realIndex === 0) {
          customProgress = (1 / (this.swiper.slides.length)) / 2;
        } else {
          customProgress = this.swiper.progress;
        }
      }

      // Update the scroll width based on custom progress
      const updatedScrollWidth = `${customProgress * 100}%`;
      customScroll.style.width = updatedScrollWidth;
      setWidth = customScroll.style.width;
    });
  }

  calculateProgressInitial(swiper) {
    const slideCount = swiper.slides.length;
    if (slideCount <= 1) {
      return 0;
    }
    return 1 / slideCount;
  }
}


class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    responsive.addResizeListener(this, this.sync.bind(this));
  }

  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }
}

const dynamicVars = new dynamicVariables();
class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.hasAttribute && node.hasAttribute("data-animation")) {
                this.animateElement(node, this.integer);
                this.integer = this.integer + 1;
              }
              const newContentToAnimate = node.querySelectorAll("[data-animation]");
              newContentToAnimate.forEach((item) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    if (!this.element) return;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
    this.element.setAttribute("aria-hidden", true);
  }

  slideDown() {
    if (!this.element) return;
    if (this.element.style.height === "auto") {
      return;
    }
    this.element.style.pointerEvents = "none";
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);

    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === "height") {
        _this.element.style.pointerEvents = "all";
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };
    this.element.addEventListener("transitionend", transitionEnded);
  }

  elementScaleOut(elements) {
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    elements.forEach((element, index) => {
      if (element.hasAttribute("data-loaded")) {
        return;
      }
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };
      setTimeout(() => {
        const animation = element.animate(keyframes, animationOptions);
        animation.finished.then(() => {
          if (!element.hasAttribute("always-animate")) {
            element.setAttribute("data-loaded", "true");
          }
        }).catch(error => console.error("Animation failed for elementScaleOut:", error, element));
      }, animationDelay * index);
    });
  }

  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        const animation = item.animate(elementMove, {
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
        animation.finished.then(() => {
          if (!item.hasAttribute("always-animate")) {
            item.setAttribute("data-loaded", "true");
          }
        }).catch(error => console.error("Animation failed for elementScaleIn:", error, item));
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFadeIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          { opacity: "0" },
          { opacity: "1" },
        ];
        let animation = item.animate(elementMove, {
          duration: 750,
          easing: "ease",
          fill: "forwards",
        });
        animation.finished.then(() => {
          if (!item.hasAttribute("always-animate")) {
            item.setAttribute("data-loaded", "true");
          }
        }).catch(error => console.error("Animation failed for first elementFadeIn:", error, item));
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementImageReveal(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      const keyframes = [
        {
          transform: "scale(1.2)",
          opacity: "0",
          clipPath: "polygon(0 0,100% 0,100% 0,0 0)"
        },
        {
          transform: "scale(1)",
          opacity: "1",
          clipPath: "polygon(0 0,100% 0,100% 100%,0 100%)"
        }
      ];
      const animationOptions = {
        duration: 1200,
        easing: "cubic-bezier(0.25,0.46,0.45,0.94)",
        fill: "forwards"
      };
      const animation = item.animate(keyframes, animationOptions);
      animation.finished.then(() => {
        if (!item.hasAttribute("always-animate")) {
          item.setAttribute("data-loaded", "true");
        }
      }).catch(error => console.error("Animation failed for elementImageReveal:", error, item));
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        const animation = item.animate(elementMove, {
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        animation.finished.then(() => {
          if (!item.hasAttribute("always-animate")) {
            item.setAttribute("data-loaded", "true");
          }
        }).catch(error => console.error("Animation failed for elementFromTop:", error, item));
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        const animation = item.animate(elementMove, {
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        animation.finished.then(() => {
          if (!item.hasAttribute("always-animate")) {
            item.setAttribute("data-loaded", "true");
          }
        }).catch(error => console.error("Animation failed for elementFromBottom:", error, item));
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        const animation = item.animate(elementMove, {
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        animation.finished.then(() => {
          if (!item.hasAttribute("always-animate")) {
            item.setAttribute("data-loaded", "true");
          }
        }).catch(error => console.error("Animation failed for elementFromRight:", error, item));
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        const animation = item.animate(elementMove, {
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        animation.finished.then(() => {
          if (!item.hasAttribute("always-animate")) {
            item.setAttribute("data-loaded", "true");
          }
        }).catch(error => console.error("Animation failed for elementFromLeft:", error, item));
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        const animation = item.animate(elementMove, {
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        animation.finished.then(() => {
          if (!item.hasAttribute("always-animate")) {
            item.setAttribute("data-loaded", "true");
          }
        }).catch(error => console.error("Animation failed for elementFromRightBig:", error, item));
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        const animation = item.animate(elementMove, {
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        animation.finished.then(() => {
          if (!item.hasAttribute("always-animate")) {
            item.setAttribute("data-loaded", "true");
          }
        }).catch(error => console.error("Animation failed for elementFromLeftBig:", error, item));
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementReveal(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          { opacity: "0" },
          { opacity: "1" }
        ];
        const animation = item.animate(elementMove, {
          duration: 300,
          easing: "cubic-bezier(0.25, 0.1, 0.25, 1)",
          fill: "forwards"
        });
        animation.finished.then(() => {
          if (!item.hasAttribute("always-animate")) {
            item.setAttribute("data-loaded", "true");
          }
        }).catch(error => console.error("Animation failed for elementReveal:", error, item));
      }, window.theme.animationBetweenElements * i);
    });
  }

  elementFadeIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          { opacity: "0" },
          { opacity: "1" },
        ];
        const animation = item.animate(elementMove, {
          duration: 1000,
          easing: "cubic-bezier(.16,1.08,.38,.98)",
          fill: "forwards",
        });
        animation.finished.then(() => {
          if (!item.hasAttribute("always-animate")) {
            item.setAttribute("data-loaded", "true");
          }
        }).catch(error => console.error("Animation failed for second elementFadeIn:", error, item));
      }, window.theme.animationBetweenElements * i);
    });
  }

  animateElement(animatedItem, index) {
    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const currentObserverIndex = options.integer;
        const elementsToAnimate = [];
        results.forEach((result) => {
          if (result.isIntersecting || result.intersectionRatio > 0) {
            elementsToAnimate.push(result.target);
            if (!result.target.hasAttribute("always-animate")) {
                 this.intersectionObserver[currentObserverIndex].unobserve(result.target);
            }
          }
        });

        if (elementsToAnimate.length === 0) {
          return;
        }

        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          elementScaleOut: 'elementScaleOut',
          elementReveal: 'elementReveal',
          elementFadeIn: "elementFadeIn",
          elementImageReveal: "elementImageReveal"
        };
        const animationMethodName = animations[options.type];
        if (animationMethodName && typeof this[animationMethodName] === 'function') {
          this[animationMethodName](elementsToAnimate);
        }
      },
      { threshold: 0.15 }
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }
    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme && window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation(null, false);
  });
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.delegateElement.on("click", "button", this.onButtonClick.bind(this));
    this.delegateElement.on("input", "input", this.onInput.bind(this));
  }

  onInput() {
    this.input.dispatchEvent(this.changeEvent);
    this.toggleAddButton();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (this.input.value > 1) {
      this.element.classList.add('active')
    } else {
      this.element.classList.remove('active')
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    this.toggleAddButton();
  }


  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelectorAll(".pm__atc-button--main"),
      addButtonInner = document.querySelectorAll(".pm__atc-button--main .ButtonText"),
      quantityEl = document.querySelector(".pm__quantity-input"),
      altButtons = document.querySelectorAll(".pm__alt-atc-button");

    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (selectedVariant?.available == false) {
      addButton.forEach(button => button.setAttribute("disabled", "disabled"));
      addButtonInner?.forEach((btn) => {
        btn.innerHTML = window.variantStrings.soldOut;
      });
      altButtons.forEach(button => button.setAttribute("disabled", ""));
    } else {
      let price = this.options['price'];
      if (selectedVariant) {
        price = selectedVariant?.price;
      }
      altButtons.forEach(button => button.removeAttribute("disabled"));
      addButton.forEach(button => button.removeAttribute("disabled"));
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='pm__atc-price u-pb1' data-la-dn-price> - " +
          Shopify.formatMoney(
            price * quantity,
            window.theme.moneyFormat
          ) +
          "</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner?.forEach((btn) => {
        const isBuyButton = btn.getAttribute('data-buy-button') === 'true';
        if (isBuyButton) {
          btn.innerHTML = window.variantStrings.addToCartRichText + priceElement;
        } else {
          btn.innerHTML = window.variantStrings.addToCart + priceElement;
        }
      });

       
    }
  }


}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector('.component-countDownWrapper');

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}', '<span class="u-pb6 component-countDown">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;


    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date') {
      countDate = new Date(this.options.countdownDate);
    }



    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;


    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);


    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes) && this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference - 1;
    } else if (this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }


    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);


class FavoritesDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.cache = favoritesCache; // Use the shared cache instance
  }

  async connectedCallback() {

    const favorites = this.getFavorites();

    this.favPopulated = document.querySelectorAll(".header__favorites--populated");
    if (favorites.length > 0) {


      this.updateFavoritesAcrossSite();
      // Load cached products on page load
      await this.cache.loadFromStorage();
    }
    this.favoritesDrawer = new Drawer(this.element, {
      onClose: () => {
        this.open = false;
        this.previousLocalStorageValue = localStorage.getItem("productFavorites");
      },
      onOpen: () => {
        if (this.previousLocalStorageValue !== localStorage.getItem("productFavorites") && favorites.length > 0) {
          this.renderProducts();
        }
        this.open = true;
      },
    });

    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.element.getAttribute("data-settings"));


    this.contentElement = document.querySelector(".favorites__content");
    this.loader = this.element.querySelector(".spinningLoader");

    this.previousLocalStorageValue = localStorage.getItem("productFavorites");

    this.bindEvents();
    if (favorites.length > 0) {
      this.renderProducts();
    }
    this.initCarousel();
  }

  bindEvents() {
    this.updateFavoritesListener = this.updateFavoritesAcrossSite.bind(this);
    document.addEventListener("update-favorites", this.updateFavoritesListener);

    this.delegateBody.on("click", '[data-action="toggle-favorites"]', this.toggleFavorite.bind(this));
    this.delegateBody.on("keydown", '[data-action="toggle-favorites"]', this.toggleFavorite.bind(this));
  }

  async toggleFavorite(e) {
    if (e.key && e.key !== "Enter") return;
    e.preventDefault();

    const productId = e.target.parentElement.getAttribute("data-id") || e.target.getAttribute("data-id");
    if (!productId) return;

    const favorites = this.getFavorites();
    const isFavorite = favorites.includes(productId);

    if (isFavorite) {
      this.removeProduct(productId);
      announceToLiveRegion('favoritesRemoved');
    } else {
      await this.addProduct(productId);
      announceToLiveRegion('favoritesAdded');
    }
  }

  async addProduct(productId) {
    let favorites = this.getFavorites();

    if (!favorites.includes(productId)) {
      favorites.unshift(productId);
      this.saveFavorites(favorites);

      // Fetch and add product to cache
      const productHtml = await this.fetchProductHtml(productId);
      if (productHtml) {
        this.cache.addProducts(productHtml);
        this.renderProducts(); // Refresh UI
      }
    }
  }

  async fetchProductHtml(productId) {
    try {
      const response = await fetch(`${window.routes.localeRootUrl}/search?view=recently&type=product&q=id:${productId}`);
      return await response.text();
    } catch (error) {
      console.error("Error fetching product:", error);
      return null;
    }
  }

  removeProduct(productId) {
    let favorites = this.getFavorites();
    favorites = favorites.filter((id) => id !== productId);

    this.saveFavorites(favorites);
    this.cache.removeProduct(productId); // Remove from cache

    this.renderProducts(); // Refresh UI
  }

  renderProducts() {
    const cachedProducts = this.cache.getProducts();

    this.contentElement.innerHTML = ""; // Clear existing content
    this.contentElement.classList.add('favorites-grid');
    if (cachedProducts.length > 0) {
      cachedProducts.forEach((product) => {
        this.contentElement.appendChild(product.cloneNode(true));
      });
    } else {
      this.fetchAndRenderFavorites(); // Fetch if cache is empty
    }
  }

  async fetchAndRenderFavorites() {
    try {
      const response = await fetch("/?section_id=saved");
      const html = await response.text();
      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      this.contentElement.innerHTML = tempElement.querySelector('.favorites__content').innerHTML;
      this.contentElement.classList.remove('favorites-grid');

      this.initCarousel();
    } catch (error) {
      console.error("Error fetching main favorites section:", error);
    }
  }

  saveFavorites(items) {
    localStorage.setItem("productFavorites", JSON.stringify(items.slice(0, 50)));
    this.updateFavoritesAcrossSite();
  }

  getFavorites() {
    return JSON.parse(localStorage.getItem("productFavorites") || "[]").filter((id) => id !== null);
  }

  updateFavoritesAcrossSite() {
    const items = this.getFavorites();
    const favoritesButtons = [...document.querySelectorAll('[data-action="toggle-favorites"]')];

    this.favPopulated.forEach((item) => {
      item.style.opacity = items.length > 0 ? "1" : "0";
    });

    favoritesButtons.forEach((item) => {
      const myID = item.getAttribute("data-id");
      const exists = items.includes(myID);
      item.setAttribute("state", exists ? "active" : "not-active");
    });
  }

  initCarousel() {

    const slidesPerViewD = 3.295;
    const slidesPerViewM = 2.14;



    new Swiper('.favorites__recommendations-swiper', {
      slidesPerView: slidesPerViewM,
      spaceBetween: 2,
      slidesOffsetBefore: 12,
      slidesOffsetAfter: 12,
      allowTouchMove: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar"
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: ".cart__swiper--next",
        prevEl: ".cart__swiper--prev"
      },
      breakpoints: {
        1025: {
          slidesPerView: slidesPerViewD,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        }
      }
    });

  }
}

customElements.define("favorites-drawer", FavoritesDrawer);


var stateWasEmpty = true;
class cartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.focusElement = false;
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.alreadyEntered = false;
        this.onClose();
      },
      onOpen: () => {
        this.isOpen = true;

        if (this.alreadyEntered == false) {
          this.onOpen();
        }
       
      },
    });
    this.loader = this.element.querySelector(".itemLoader");

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.breakpoint = responsive.getCurrentBreakpoint();

    this.alreadyEntered = false;
    new AddToCart(this.element);
    this.element.querySelectorAll('[data-property]').forEach(el => this.updateItemImage(el));
    this.cleanUpLocalStorage();
    this.loadRecommendations();


    this.bindEvents();
  }

  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);


      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".cart-item__quantity",
        this.updateItemQuantity.bind(this)
      );


      document.addEventListener("cache:updated", this.loadFavorites.bind(this));


      window.theme.listener = "true";
    }
  }

  onOpen() {
    const content = this.element.querySelector(".cart-drawer__content");
    const fromTop = content.getBoundingClientRect().top;
    document.documentElement.style.setProperty(
      "--cart-drawer__header-height",
      fromTop + "px"
    );

    if (this.element.querySelector(".cart-drawer__footer")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__footer-height",
        this.element.querySelector(".cart-drawer__footer").offsetHeight + "px"
      );
    }

    if (this.options["showRecommendations"] && this.alreadyEntered == false) {
      this.loadRecommendations();
    }

    this.alreadyEntered = true;

  }

  onClose() {
    if (this.breakpoint == 'desktop' && this.recommendationContainer) {
      this.recommendationContainer.setAttribute("aria-expanded", "false");
      this.recommendationContainer = null;
    }
  }



  handleTransitionEnd(target) {
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    this.recommendationContainer.removeEventListener(
      "transitionend",
      this.transitionEndHandler
    );
  }

  async updateItemQuantity(event, target) {
    event.preventDefault();
    const cartItem = target.closest(".cart-item");
    const itemLoader = cartItem.querySelector(".itemLoader");
    itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }

    const payload = {
      id: target.getAttribute("data-line-id"),
      quantity: quantity,
    };

    if (quantity === 0) {
      const id = cartItem.dataset.id;
      this.removedId = id;
      const nextItem = cartItem.nextElementSibling;
      const height = cartItem.offsetHeight;
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      setTimeout(() => {
        cartItem.remove();
        if (!nextItem) {
          return;
        }
        nextItem.classList.add("repo--top");
        setTimeout(() => {
          nextItem.classList.remove("repo--top");
        }, 350);
      }, 350);
    }

    try {
      const response = await fetch(
        `${window.routes.localeRootUrl}/cart/change.js`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
        this.cartIds = [];
      }
      if (quantity == 0 && data.item_count > 0) {
        stateWasEmpty = true;
        
           // ✅ Announce item removal
           announceToLiveRegion('itemRemoved');

        if (this.options.showRecommendations) {
          this.options["productId"] = data.items[0].product_id;
          this.renderCart(false, false, false, null, true);
          return;
        }
      }
      if (data.item_count > 0 && quantity > 0) {
        this.renderCart(target.getAttribute("data-id"), true);

        // ✅ Announce quantity update
        announceToLiveRegion('quantityUpdated');
      }

    } catch (error) {
      console.error("Failed to update item quantity:", error);
      // Optionally, show an error message to the user
    }
  }

  onProductAdded() {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }

    if (window.theme.cartCount == 0 && this.isOpen == true) {
      this.loader.classList.add("is-visible");
    }


    this.renderCart(false, false, true, details).then(() => {
      if (this.element.hasAttribute('data-open-drawer') && this.isOpen == false) {

        this.isOpen = true;
        this.onOpen();
        this.alreadyEntered = true;
        this.drawer.openDrawer();


      }
    });
  }

  renderCart(lineNumber, quantityChange, productAdd, productAddEvent, updateCount) {
    this.pageLoader.style.width = 90 + "%";
    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount
        );

      });
    });
  }

  replaceContent(
    html,
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount
  ) {


    // Prepare the page loader animation
    this.pageLoader.classList.add("is-visible");

    setTimeout(() => {
      this.pageLoader.classList.remove("is-visible");
    }, 300);




    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Extract options and update cart count
    const newOptions = JSON.parse(
      tempElement.querySelector("#cart-drawer").getAttribute("data-settings")
    );
    this.options = newOptions;

    if (tempElement.querySelector("[data-ids]")) {
      this.cartIds = tempElement
        .querySelector("[data-ids]")
        .dataset.ids.split(",")
        .filter((item) => item !== "");
      if (updateCount) {
        this.cartIds = this.cartIds.filter((item) => item !== this.removeId);
        this.removeid = null;
        this.loadRecommendations();
      }
    }


    const itemCount = newOptions.itemCount;
    window.theme.cartCount = parseInt(itemCount);
    const countEl = document.querySelector('.cart__count');
    countEl.textContent = itemCount;
    window.theme.cartCount === 0 ? countEl.parentElement.classList.remove('show-count') : countEl.parentElement.classList.add('show-count');


    if (updateCount) {
      this.updateCartFooter(tempElement);
      return;
    }

    if (lineNumber && tempElement.querySelector(`#${lineNumber}`)) {
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && stateWasEmpty == false && lineNumber) {
      this.addContent(tempElement, lineNumber);
    } else {
      this.replaceCartContent(tempElement);
    }

    this.loadMembership();
    this.updateCartFooter(tempElement);

    this.element.dispatchEvent(
      new CustomEvent("cart:render", { bubbles: true })
    );



    if (itemCount == 0) {
      stateWasEmpty = true;
    } else {
      stateWasEmpty = false;
    }

    // Additional actions after a brief delay

    setTimeout(() => {
      if (
        this.options.showRecommendations &&
        !quantityChange &&
        this.isOpen == true
      ) {
        if (window.theme.cartCount == 0) {
          this.loadFavorites();
        }
        this.loadRecommendations();
      }

      if (this.element.hasAttribute('data-open-drawer')) {
        bodyScrollLock.clearAllBodyScrollLocks();
        this.focusElement = this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(this.focusElement, bodyScrollLockOptions);
      }

    }, 500);
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = document.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__info `
    );
    const oldCartItemInfo = cartItemParent.querySelector(`#${lineNumber} .cart-item__info`);


    if (!cartItemParent) {
      this.element
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.querySelector('.cart-item__inner').replaceChild(
        newCartItemInfo,
        oldCartItemInfo
      );
    } else if (cartItemParent) {
      this.removeCartItem(cartItemParent);
    }
  }

  updateItemImage(item) {
    const id = item.dataset.property;
    let storedData = JSON.parse(localStorage.getItem('imageData')) || {};
    if (storedData.hasOwnProperty(id)) {
      const img = item.querySelector('.AspectRatio img');
      img.src = storedData[id];
      img.removeAttribute('srcset');
    }
  }

  cleanUpLocalStorage() {
    let storedData = JSON.parse(localStorage.getItem('imageData')) || {};

    // Get all items with data-property and check their ids
    const idsInDom = Array.from(this.element.querySelectorAll('[data-property]'))
      .map(el => el.dataset.property);

    // Iterate over the stored data and remove items whose ids do not exist in the DOM
    Object.keys(storedData).forEach(id => {
      if (!idsInDom.includes(id)) {
        // If the id doesn't exist in the DOM, remove it from localStorage
        delete storedData[id];
      }
    });

    // Update localStorage with the cleaned data
    localStorage.setItem('imageData', JSON.stringify(storedData));


  }


  addContent(tempElement, lineNumber) {

    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__content").scrollTop = 0;
    }
    const itemToAdd = tempElement.querySelector(
      `#${lineNumber}`
    );
    const cartWrapper = this.element.querySelector(".cart-drawer__items");

    const firstItem = cartWrapper.firstElementChild;
    if (cartWrapper.querySelector(`#${lineNumber}`)) {
      this.updateCartItem(`${lineNumber}`, tempElement);
    } else {
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty(
        "--repositioning_value",
        `${height}px`
      );
      firstItem.classList.add("repo--bottom");
      this.loader.classList.remove("is-visible");

      this.updateItemImage(itemToAdd);

      setTimeout(() => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
        firstItem.classList.remove("repo--bottom");

        setTimeout(() => {
          itemToAdd.classList.remove("repo--adding");
        }, 350);
      }, 350);
    }
  }

  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 16;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }

  updateCartFooter(tempElement) {


    const itemCount = this.options.itemCount;
    if (itemCount > 0) {
      const footerParent = document.querySelector(".cart-drawer__footer");

      const newFooterTotals = tempElement.querySelector(".cd__totals");
      const oldFooterTotals = document.querySelector(".cd__totals");

      if (!footerParent || !newFooterTotals) return;
      if (oldFooterTotals) {
        footerParent.replaceChild(
          newFooterTotals,
          document.querySelector(".cd__totals")
        );
      } else {
        footerParent.prepend(newFooterTotals);
      }

      const newShippingBar = tempElement.querySelector(
        ".cart-drawer__shipping-progress-bar"
      );
      if (newShippingBar) {
        const currentShippingBar = document.querySelector(
          ".cart-drawer__shipping-progress-bar"
        );
        if (currentShippingBar) {
          let percent = newShippingBar.dataset.percent;
          if (percent > 100) {
            percent = 100;
          }
          currentShippingBar.dataset.percent = percent;
          currentShippingBar.style.width = `${percent}%`;
          if (percent == 100) {
            currentShippingBar.classList.add("done");
            currentShippingBar.classList.remove("active");
          } else {
            currentShippingBar.classList.remove("done");
            currentShippingBar.classList.add("active");
          }
          this.element.querySelector(".cart-drawer__shipping-text").innerHTML =
            tempElement.querySelector(".cart-drawer__shipping-text").innerHTML;
        } else {
          const headerParent = this.element.querySelector(
            ".cart-drawer__header"
          );
          headerParent.appendChild(
            tempElement.querySelector(".cart-drawer__shipping")
          );
        }
      }

    } else {
      this.clearCartFooter(tempElement);
      stateWasEmpty = true;
    }

    if (this.element.querySelector(".cart-drawer__footer")) {
      document.documentElement.style.setProperty(
        "--cart-drawer__footer-height",
        this.element.querySelector(".cart-drawer__footer").offsetHeight + "px"
      );

    }

  }

  clearCartFooter(tempElement) {

    if (!tempElement.querySelector(".cart-drawer__wrapper")) return;
    if (document.querySelector(".cart-drawer__footer")) {
      document
        .querySelector(".cart-drawer__footer")
        .classList.add("removing");
    }

    const wrapperParent = this.element.querySelector(".cart-drawer__wrapper");
    if (wrapperParent) {
      wrapperParent.innerHTML = tempElement.querySelector(
        ".cart-drawer__wrapper"
      ).innerHTML;
    }
  }

  replaceCartContent(tempElement) {

    const cartWrapperParent = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
      ".cart-drawer__content"
    ).scrollTop;

    tempElement.querySelectorAll('[data-property]').forEach(el => this.updateItemImage(el));


    cartWrapperParent.replaceChild(
      tempElement.querySelector(".cart-drawer__wrapper"),
      this.element.querySelector(".cart-drawer__wrapper")
    );
    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__content").scrollTop =
      currentScrollPosition;

    setTimeout(() => {
      if (this.element.hasAttribute('data-open-drawer')) {
        bodyScrollLock.clearAllBodyScrollLocks();
        bodyScrollLock.disableBodyScroll(cartWrapperParent.querySelector('.cart-drawer__content'), bodyScrollLockOptions);
      }
      const content = this.element.querySelector(".cart-drawer__content");
      const fromTop = content.getBoundingClientRect().top;
      document.documentElement.style.setProperty(
        "--cart-drawer__header-height",
        fromTop + "px"
      );
      if (cartWrapperParent.querySelector(".cart-drawer__footer")) {
        document.documentElement.style.setProperty(
          "--cart-drawer__footer-height",
          cartWrapperParent.querySelector(".cart-drawer__footer").offsetHeight + "px"
        );
      }
    }, 100);
  }

  loadFavorites() {
    if (window.theme.cartCount != 0) return;

    const cachedProducts = favoritesCache.getProducts();

    const favoritesWrapper = this.element.querySelector('.cart-drawer__favorites-wrapper');

    const favoritesCart = favoritesWrapper.querySelector('.swiper-wrapper');
    favoritesCart.innerHTML = "";
    if (cachedProducts.length > 0) {
      cachedProducts.forEach((product) => {
        favoritesCart.appendChild(product.cloneNode(true));
      });
      this.initializeSwiper('.cart-drawer__favorites');
      favoritesWrapper.style.display = "block";
    } else {
      favoritesWrapper.style.display = "none";
    }
  }

  loadRecommendations() {
    let recommendationsContainer = this.element.querySelector(
      ".cart-drawer__recommendations"
    );

    if (this.recommendationLoading == true) return;
    this.recommendationLoading = true;


    if (!recommendationsContainer) {
      this.recommendationLoading = false;
      return;
    }
    const productId = this.options["productId"];
    const baseUrl = window.routes.localeRootUrl;
    let url;

    // Determine the URL based on whether a product ID is present
    if (!productId) {
      url = "?section_id=helper-recommendations";
    } else {
      let limit = this.element.getAttribute('product-limit');
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&l${limit}&intent=${this.options["intent"]}`;
    }

    recommendationsContainer.classList.remove("transition--done");
    if (this.recommendationsOpen == true) {
      recommendationsContainer.classList.add("transition");
    }

    return fetch(url)
      .then((response) => response.text())
      .then((content) => {
        this.recommendationLoading = false;
        const container = document.createElement("div");
        container.innerHTML = content;


        let recommendedIds = null;
        if (container.querySelector(".cart-drawer__rec-item")) {
          recommendedIds = [
            ...container.querySelectorAll(".cart-drawer__rec-item"),
          ].map((item) => item.dataset.id);
        }

        if (!recommendedIds) {
          recommendationsContainer.style.display = 'none';
        } else {
          recommendationsContainer.style.display = 'block';
        }

        if (!this.cartIds) {
          if (recommendationsContainer.dataset.ids) {
            this.cartIds = recommendationsContainer.dataset.ids
              .split(",")
              .filter((item) => item !== "");
          }
        }

        if (this.cartIds && recommendedIds) {
          const hasCommonItem = this.cartIds.some((item) =>
            recommendedIds.includes(item)
          );
          if (hasCommonItem) {
            return;
          }
        }

        let recommendationsHTML = container.querySelector(
          ".cart-drawer__upsell"
        )?.innerHTML;



        if (recommendationsHTML) {
          recommendationsContainer.innerHTML = recommendationsHTML;
          document.dispatchEvent(new CustomEvent('update-favorites'));
          this.initializeSwiper('.cart-drawer__recommendations .swiper');
        }

        if (this.element.querySelector(".cart-drawer__footer")) {
          document.documentElement.style.setProperty(
            "--cart-drawer__footer-height",
            this.element.querySelector(".cart-drawer__footer").offsetHeight + "px"
          );
        }


        new AddToCart(this.element);
      })
      .catch((error) => {
        this.recommendationLoading = false;
        console.error("Failed to load recommendations:", error);
      });
  }

  handleTransitionRec(target, container) {
    if (event.propertyName !== "transform") return;
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    container.classList.remove("transition");
    this.recommendationsOpen = false;
    this.el.removeEventListener("transitionend", this.transitionRecEnd);
  }


  initializeSwiper(element) {
    let slidesPerViewM = "auto";
    let slidesPerViewD = "auto";

    if (window.theme.cartCount == 0) {
      slidesPerViewD = 3.295;
      slidesPerViewM = 2.14;
    }

    new Swiper(element, {
      slidesPerView: slidesPerViewM,
      spaceBetween: 2,
      slidesOffsetBefore: 12,
      slidesOffsetAfter: 12,
      allowTouchMove: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar"
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: ".cart__swiper--next",
        prevEl: ".cart__swiper--prev"
      },
      breakpoints: {
        1025: {
          slidesPerView: slidesPerViewD,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        }
      }
    });
  }

  /* fetch the container of the membership then get the data from the section settings then append it use html as its came from richtext */
  loadMembership() {
    const membershipContainerElement = document.querySelector(
      '#jsMembershipContainer',
    );

    if (membershipContainerElement && window.cartDrawerSettings) {
      membershipContainerElement.innerHTML =
        window.cartDrawerSettings.cart_drawer_member_message;
    }
  }
}
customElements.define("cart-drawer", cartDrawer);


class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);


  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.carouselElement = this.element.querySelector("[data-swiper-settings]");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
    if (this.options["numberOfSlides"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.onImagesReady = this.createObserver.bind(this);
      this.element.addEventListener("swiper:slide-changed", this.onImagesReady);

      if (this.carousel.swiperElement) {
        this.carousel.swiperElement.on("reachBeginning", () => {
          if (this.carousel.swiperElement.params.rewind && this.carousel.swiperElement.params.autoplay) {
            this.carousel.swiperElement.autoplay.stop();
          }
        })
      }

      this.createObserver();
    } else {
      this.createObserver();
    }
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  handleIntersect(entries) {
    var _this = this;
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (_this.options["numberOfSlides"] > 1) {
          _this.changeImageQuality();
        } else {
          _this.changeImageQuality(true);
        }
        _this.observer.unobserve(_this);
      }
    });
  }
  changeImageQuality(singleItem) {


    // Get the current breakpoint.
    const breakpoint = responsive.getCurrentBreakpoint();

    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers =
        Array.from(this.element.querySelectorAll(".image__element")).slice(0, 2);

    } else {


      const currentIndex = this.carousel.swiperElement.activeIndex;

      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(
        cellElement.querySelectorAll(".image__element")).slice(0, 2);



    }



    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    // Determine which image to reveal based on the current breakpoint.
    let imageToReveal;
    if (
      breakpoint === "pocket" ||
      breakpoint === "phone" ||
      breakpoint === "tablet"
    ) {
      imageToReveal = imageContainers[0];
    } else {
      if (imageContainers.length == 2) {
        imageToReveal = imageContainers[1];
      } else {
        imageToReveal = imageContainers[0];
      }
    }


    // If the image to reveal is not found or has already been loaded, return.
    if (!imageToReveal || imageToReveal.dataset.loadedImage === "true") {
      return;
    }



    if (imageToReveal.dataset.src) {
      // Replace the image URL with a higher quality version.
      const replaceUrl = imageToReveal.dataset.src.replace(
        "{width}x",
        "width=2600"
      );
      imageToReveal.src = replaceUrl;
      setTimeout(() => {
        imageToReveal.dataset.loadedImage = "true";
      }, 400);

    }
  }
}
customElements.define("banner-hero", Banner);


class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector("[data-scrollable]");
    this.announcementElement = document.querySelector(".announcement-bar--sticky");
    this.headerTransparent = false;


    if (this.options.sticky) {
      this.toggleSticky();
    } else if (this.announcementElement) {
      this.adjustToStickyAnn();
    }
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );

    this.updateVisibleHeight();
    this.bindEvents();
    this.menuOverlapHandler();
  }



  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector(".header-menu-items"),
      overlapping = false,
      menuWrapper = this.element.querySelector(".header--Wrapper"),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll(".header-main-links");
      desiredHeight.forEach((item) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove("mt-m");
      menuItems.classList.remove("mainMenu--Overlapping");
      menuWrapper.querySelector(".header-main-menu-items").prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add("mt-m");
      menuItems.classList.add("mainMenu--Overlapping");
      menuItems.closest(".header").appendChild(menuItems);
    }
    document.documentElement.style.setProperty(
      "--header-height",
      _this.element.clientHeight + "px"
    );
    menuItems.style.opacity = 1;
  }

  toggleSticky() {
    if (this.announcementElement) {
      this.element.parentElement.classList.add("header--sticky-with-ann");
    } else {
      this.element.parentElement.classList.add("header--sticky");
    }

    this.element.parentElement.classList.remove("Header--Transparent");
  }

  adjustToStickyAnn() {
    this.element.classList.add("header--not-sticky");
  }

  bindEvents() {
    const _this = this;
    document.addEventListener("shopify:section:load", function () {
      _this.menuOverlapHandlerListener();
    });
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    window.addEventListener("resize", this.menuOverlapHandlerListener);
    this.toggleColorListener = this.toggleColor.bind(this);

    if (this.options.transparent || this.options.sticky) {
      this.toggleColorListener = this.toggleColor.bind(this);
      scrollListener.addScrollListener(this, this.toggleColorListener);
    }

    window.addEventListener("scroll", this.toggleColorListener);
    window.addEventListener("scroll", this.toggleTopBarListener);

    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-haspopup='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-haspopup='true']",
      this.openMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "mouseenter",
      '[aria-singlemenu="false]',
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on(
      "focusin",
      '[aria-singleMenu="false"], .header-main-links',
      this.closeMenu.bind(this),
      true
    );

    this.delegateElement.on("keydown", onEscape((event) => {
      this.closeMenu(event, event.target);
    }))

    window.addEventListener("scroll", this.updateVisibleHeight.bind(this));
    window.addEventListener("resize", this.updateVisibleHeight.bind(this));
  }
  updateVisibleHeight() {
    setTimeout(() => {
      const rect = this.element.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // Calculate the visible height
      let visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);


      // Ensure the visibleHeight is never negative
      visibleHeight = Math.max(visibleHeight, 0);
      // Update the height of header with the visible height
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `${visibleHeight}px`
      );

      document.documentElement.style.setProperty(
        "--header-height-fixed",
        document.querySelector("#header").offsetHeight + "px"
      );
    }, 550);

  }
  toggleTopBar() {
    let current = window.scrollY;
    let annBar = document.querySelector(".announcement-bar");
    let element_height = this.element.offsetHeight;

    if ((element_height + annBar.offsetHeight) * 2 < current) {
      this.element.parentElement.classList.add("header--fixed-top-bar");
    }

    if (current <= annBar.offsetHeight) {
      this.element.parentElement.classList.remove("header--fixed-top-bar");
    }

    if (
      this.prevOffset < current &&
      current >= annBar.offsetHeight + this.element.offsetHeight
    ) {
      this.element.parentElement.classList.add("header--hide");
      document.documentElement.style.setProperty(
        "--header-dynamic-height",
        `0px`
      );
    } else {
      this.element.parentElement.classList.remove("header--hide");
      this.updateVisibleHeight();
    }

    this.prevOffset = current;
  }
  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",

      `${document.querySelector("#header").offsetHeight}px`
    );
  }

  openMenu(event, target) {


    // Dispatch a custom event to indicate that the menu is being opened.

    this.element.dispatchEvent(new CustomEvent("menu:open", { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === "mouseenter" && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);

    if (this.element.classList.contains("Header--Transparent")) {
      this.element.classList.remove("Header--Transparent");
      this.headerTransparent = true;
    }

    target.setAttribute("aria-expanded", "true");

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter(
      (child) =>
        child !== target && child.getAttribute("aria-expanded") === "true"
    );
    siblings.forEach((item) => item.setAttribute("aria-expanded", "false"));

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(
      this.scrollableElement,
      bodyScrollLockOptions
    );
  }

  closeMenu(event, target) {
    if (event.type === "mouseleave" && target !== event.target) {
      return;
    }

    const openElement = this.element.querySelector('.header-menu-items [aria-expanded="true"]');
    if (!openElement) return;
    openElement.setAttribute("aria-expanded", "false");
    this.toggleColor();

    bodyScrollLock.enableBodyScroll(this.scrollableElement);
  }

  toggleColor() {
    if (window.pageYOffset > 25) {
      this.element.classList.add("header--scrolled");
    } else {
      this.element.classList.remove("header--scrolled");
    }
    if (this.options.transparent) {
      if (window.pageYOffset > 25 && this.options.sticky) {
        this.element.classList.remove("Header--Transparent");
      } else {
        this.element.classList.add("Header--Transparent");
      }
    }
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    const menuDrawer = this.element.querySelector(".Drawer--wrapper");

    new Drawer(menuDrawer);


    this.bindEvents();
  }
  bindEvents() {

  }

}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {

      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.classList.add('load_finished');

    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();


class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;
    this.delegateElement = new Delegate(this.element);

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const isMobile = responsive.matchesBreakpoint("pocket");

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }
    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";


    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        children: [
          "playToggle",
          "progressControl",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "CustomControlSpacer",
          "VolumePanel",
          "fullscreenToggle"

        ],
      },

      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == "html5") return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }




  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          this.videoPlayer.muted("true");

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.delegateElement = new Delegate(this);
    this.bindEvents();
    
    this.dropdowns = this.querySelectorAll(".Dropdown");
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.clearInput.bind(this)
    );
  }

  connectedCallback() {
    this.updateFooterHeight();
    window.addEventListener("load", this.updateFooterHeight);
    responsive.addResizeListener(this, this.updateFooterHeight);
    this.handleAccessibilityFooterButtons();
    if(responsive.matchesBreakpoint('lap_and_up')){
      this.dropdowns.forEach(dropdown => {
        dropdown.classList.add("do-not-close");
      })
    }
  }

  updateFooterHeight = () => {
    const footerHeight = this.offsetHeight + "px";
    document.documentElement.style.setProperty("--footer-dynamic-height", footerHeight);
    document.documentElement.style.setProperty("--footer-height", footerHeight);
  };

  clearInput() {
    const emailInput = this.querySelector(".input-placeholder");
    const errorSpan = this.querySelector("#footer__newsletter-email--error");
    const submitButton = this.querySelector(".footer__newsletter-submit-button");
    const clearButton = this.querySelector(".footer__newsletter-form--clear");
    const emailWrapper = this.querySelector(".footer__newsletter-form-inputs");

    if (emailInput) emailInput.value = "";
    if (emailInput) emailInput.classList.remove("footer__newsletter-input--error");
    if (errorSpan) errorSpan.style.display = "none";
    if (emailWrapper) emailWrapper.classList.remove("alert");

    if (submitButton) submitButton.style.display = "flex";
    if (clearButton) clearButton.style.display = "none";
  }

  handleAccessibilityFooterButtons(){
    const footerButtons = document.querySelectorAll('.footer__wrapper .Dropdown--Button');
    const footerContents = document.querySelectorAll('.footer__wrapper .Dropdown--Content');
    if(responsive.matchesBreakpoint('lap_and_up')){
      footerButtons.forEach(button => {
        button.setAttribute('aria-expanded', 'true');
      })
      footerContents.forEach(content => {
        content.setAttribute('aria-hidden', 'false');
      })
    }
  }
}

customElements.define("footer-component", FooterComponent);
class LRUCache {
  constructor(maxSize = 10) {
    this.maxSize = maxSize;
    this.cache = new Map();
  }

  get(key) {
    const item = this.cache.get(key);
    if (item) {
      // Move the accessed item to the end to mark it as most recently used.
      this.cache.delete(key);
      this.cache.set(key, item);
    }
    return item;
  }

  set(key, value) {
    // If the item already exists, delete it first to move it to the end.
    if (this.cache.has(key)) {
      this.cache.delete(key);
    } 
    // If the cache is full, remove the oldest item (the first one).
    else if (this.cache.size === this.maxSize) {
      this.cache.delete(this.cache.keys().next().value);
    }
    this.cache.set(key, value);
  }
}

// 2. We create our global cache using the new smart LRUCache class.
window.globalQuickLoadCache = new LRUCache(10);

class QuickLoad {
  constructor() {
    this.element = document.body;
    this.replaceClasses = ['section__product-module', 'product-info'];
    this.removeClasses = ['notify-me-popup', 'sale-banner'];
    this.ignoreSearchParams = false;

    
    this.delegateElement = new Delegate(this.element);

    this.bindEvents();
  }
  
  initializeCache(links) {
    this.reloadWithoutRefresh(null, '[data-action="handle-reload"]', links);
  }

  handleMouseOverPreload() {
    const target = event.target.href ? event.target : event.target.closest('[data-action="handle-reload"]');
    this.reloadWithoutRefresh(null, '[data-action="handle-reload"]', [target]);
  }

  bindEvents() {
    this.handleBackNavigationHandler = this.handleBackNavigation.bind(this);
    this.updateContentWithoutReloadHandler = this.updateContentWithoutReload.bind(this);
    this.updateContentSpecificHandler = this.updateContentSpecific.bind(this);
    this.bindHandleMouseOverPreload = this.handleMouseOverPreload.bind(this);

    window.addEventListener("popstate", this.handleBackNavigationHandler);
    
    this.delegateElement.on("click", '[data-action="handle-reload"]', this.updateContentWithoutReloadHandler);
    this.delegateElement.on("click", '[data-action="handle-reload-specific"][aria-expanded="false"]', this.updateContentSpecificHandler);
    this.delegateElement.on("mouseover", '[data-action="handle-reload"]', this.bindHandleMouseOverPreload);
  }
  
  destroy() {
    window.removeEventListener("popstate", this.handleBackNavigationHandler);
    this.delegateElement.off("click", '[data-action="handle-reload"]', this.updateContentWithoutReloadHandler);
    this.delegateElement.off("click", '[data-action="handle-reload-specific"][aria-expanded="false"]', this.updateContentSpecificHandler);
    this.delegateElement.off("mouseover", '[data-action="handle-reload"]', this.bindHandleMouseOverPreload);
  }

  async reloadWithoutRefresh(e, selector, links) {
    const fetchAndCacheContent = async (url) => {
      // Our new smart cache's `get` method handles checking for existence.
      if (window.globalQuickLoadCache.get(url)) {
        return console.log("link already exists");
      }

      try {
        const response = await fetch(url);
        
        if (response.ok) {
          const htmlText = await response.text();
          const parsedContent = new DOMParser().parseFromString(htmlText, 'text/html');
          
          return parsedContent;
        }
      } catch (error) {
        console.error(error);
        return null;
      }
    };

    const linksFound = links || Array.from(this.element.querySelectorAll(selector));
    if (linksFound.length === 0) return;

    const reloadLinks = linksFound.map((link) => this.getNormalizedURL(link.href, false, link));

    reloadLinks.forEach(link => {
      if (!window.globalQuickLoadCache.get(link)) {
        window.globalQuickLoadCache.set(link, fetchAndCacheContent(link));
      } else {
        console.log("link already exists");
      }
    }) 

    await Promise.all(reloadLinks.map(fetchAndCacheContent));
  }
  
  async updateContentSpecific(e) {
    e.preventDefault();
    const target = event.target;
    const clickedUrl = target.href;
    const url = this.getNormalizedURLWithoutSearch(clickedUrl);    

    try {
      const response = await fetch(url);
      if (response.ok) {
        const htmlText = await response.text();
        const htmlContent = new DOMParser().parseFromString(htmlText, 'text/html');
        // Always update the cache with the fresh content.

        window.globalQuickLoadCache.set(url, htmlContent);
        this._performDOMUpdate(htmlContent, clickedUrl, false);
        
      } else {
        window.location.href = clickedUrl;
      }
    } catch (error) {
      console.error(error);
      window.location.href = clickedUrl;
    }
  }

  updateContentWithoutReload(e, push = true) {
    e.preventDefault();
    const target = event.target;
    const clickedUrl = target.href;

    const url = this.getNormalizedURL(clickedUrl, false, target);

    // Use the smart `get` which will also mark this item as recently used.
    const htmlContent = window.globalQuickLoadCache.get(url);    
    if (!htmlContent || !this._performDOMUpdate(htmlContent, url, push)) window.location.href = url;
  }

  async _performDOMUpdate(htmlContent, clickedUrl, push) {
    const loader = document.querySelector(".pageLoader");
    loader?.classList.add("is-visible");

    selectedVariant = null;

    htmlContent = await htmlContent;
    if (!htmlContent) {
      loader?.classList.remove("is-visible");
      return null;
    }

    // SAVE scroll position before any DOM changes
    const scrollPosition = {
      x: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
      y: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    };

    sessionStorage.setItem('lastUrl', window.location.href);
    document.title = htmlContent.querySelector('[data-title]')?.dataset.title || document.title;
    
    const stateAction = push ? history.pushState : history.replaceState;
    stateAction.call(history, { quickload: true }, "", clickedUrl);
    
    this.removeClasses.forEach(className => {
      document.querySelector(`.${className}`)?.remove();
    });

    this.replaceClasses.forEach(className => {
      const existingSection = document.querySelector(`.${className}`);
      const newSection = htmlContent.querySelector(`.${className}`);
      if (existingSection && newSection) {        
        // HIDE the entire section to prevent any flicker
        existingSection.style.opacity = '0';
        existingSection.style.pointerEvents = 'none';
        
        existingSection.dispatchEvent(new CustomEvent('cleanup', { bubbles: true }));
        existingSection.innerHTML = newSection.innerHTML;
        for (const { name, value } of newSection.attributes) {
          existingSection.setAttribute(name, value);
        }
        
        this.updateSwiperNavigation();
        
        // SHOW section only after everything is ready
        requestAnimationFrame(() => {
          existingSection.style.opacity = '1';
          existingSection.style.pointerEvents = 'auto';
          
          // RESTORE scroll position after content is visible
          setTimeout(() => {
            window.scrollTo(scrollPosition.x, scrollPosition.y);
          }, 50);
          
          // Hide loader after content is fully visible (mobile only)
          if (responsive.matchesBreakpoint('pocket') && this.loader) {
            // Additional delay to ensure all variant updates are visually complete
            setTimeout(() => {
              this.loader.classList.remove('is-visible');
            }, 100);
          }
        });
      }
    });
    
    this.reinitializeScripts(htmlContent);
    loader?.classList.remove("is-visible");
  }

  // NEW: Update swiper navigation visibility based on slide count
  updateSwiperNavigation() {
    // Find all active swipers (not hidden)
    const activeSwipers = document.querySelectorAll('.swiper.pm__object-selector[aria-hidden="false"], .swiper.pm__option-selector[aria-hidden="false"]');
    
    activeSwipers.forEach(swiper => {
      // Count slides in this swiper
      const slides = swiper.querySelectorAll('.swiper-slide');
      const slideCount = slides.length;
      
      // Find navigation buttons for this swiper
      const navButtons = swiper.querySelectorAll('.swiper-button, .pm__conn-button--prev, .pm__conn-button--next');
      
      // Show buttons if 5+ slides, hide if less
      navButtons.forEach(button => {
        if (slideCount >= 5) {
          button.style.display = 'block';
        } else {
          button.style.display = 'none';
        }
      });
    });
  }

  reinitializeScripts(htmlContent) {
    if (window.jdgm && typeof jdgm.init === 'function') {
      jdgm.init();
    }
    if (document.querySelector('[data-recommendations]')) {
      document.body.dispatchEvent(new CustomEvent("recommendations:reload", {
        bubbles: true,
        detail: { productId: htmlContent.querySelector('.product-module')?.dataset.productId }
      }));
    }
    if (window.Shopify && typeof Shopify.PaymentButton.init === 'function') {
      Shopify.PaymentButton.init();
    }
    
    // Initialize variant handling scripts if they exist
    if (window.ProductForm && typeof ProductForm.init === 'function') {
      ProductForm.init();
    }
    
    // NEW: Initialize product images and 3D models
    this.reinitializeProductMedia();
    
    // Trigger any variant-related initialization
    document.body.dispatchEvent(new CustomEvent("product:loaded", {
      bubbles: true,
      detail: { source: 'quickload' }
    }));
  }

  // NEW: Reinitialize product images and 3D models
  reinitializeProductMedia() {
    // Shopify 3D model viewer
    if (window.Shopify && window.Shopify.loadFeatures) {
      const models = document.querySelectorAll('model-viewer, [data-shopify-model3d-id]');
      if (models.length > 0) {
        window.Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: () => {
              models.forEach(model => {
                if (model.setAttribute) {
                  model.setAttribute('data-js-focus-visible', '');
                }
              });
            }
          }
        ]);
      }
    }

    // Initialize any image zoom functionality
    if (window.PhotoSwipe && typeof window.initPhotoSwipe === 'function') {
      window.initPhotoSwipe();
    }

    // Initialize image galleries/carousels
    if (window.Swiper && document.querySelector('.product-images .swiper-container')) {
      // Reinitialize Swiper if it exists
      const swipers = document.querySelectorAll('.product-images .swiper-container');
      swipers.forEach(swiperEl => {
        if (swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
        }
        new window.Swiper(swiperEl, {
          // Add your swiper config here
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
      });
    }

    // Initialize any custom image/media scripts
    if (window.ProductMedia && typeof window.ProductMedia.init === 'function') {
      window.ProductMedia.init();
    }

    // Trigger media-specific events
    const productImages = document.querySelector('.product-images, .product-media, [data-product-images]');
    if (productImages) {
      productImages.dispatchEvent(new CustomEvent('media:loaded', { bubbles: true }));
      productImages.dispatchEvent(new CustomEvent('images:refresh', { bubbles: true }));
    }

    // Initialize any lightbox functionality
    if (window.GLightbox && typeof window.GLightbox === 'function') {
      window.GLightbox({
        selector: '.product-images a[data-lightbox]'
      });
    }

    // Custom 3D model initialization (if you have custom 3D viewer)
    const modelViewers = document.querySelectorAll('model-viewer, [data-3d-model]');
    modelViewers.forEach(viewer => {
      viewer.dispatchEvent(new CustomEvent('model:refresh', { bubbles: true }));
    });
  }

  getNormalizedURLWithoutSearch(url) {
    const urlObj = new URL(url);
    return urlObj.origin + urlObj.pathname; // Strips both search params & hash
  }

  getNormalizedURL(url, ignoreSearchParams, target) {
    const urlObj = new URL(url);

    const href = window.location.href;
    let searchParams = "";

    if (href.includes("/product") && window.location.search !== "" && !ignoreSearchParams) {
      const searchParamsHelper = new URLSearchParams(window.location.search);

      searchParamsHelper.delete("variant");

      const newVariantId = this.getNewVariantId(target);
      if (newVariantId) searchParamsHelper.append("variant", newVariantId);

      searchParams = searchParamsHelper.toString();
    }
    
    return urlObj.origin + urlObj.pathname + "?" + searchParams;
  }

  getNewVariantId(target) {
    const variantsString = target.dataset.variants;
    if (!variantsString) return null;

    const variants = JSON.parse(variantsString);

    const inputs = Array.from(document.querySelectorAll("variant-selects .pm__option-selector .pm__option-item input:checked"));
    const inputValues = inputs.map(input => input.value.trim().toLowerCase());
   
    const matchingVariants = variants.filter(v => {
      const opts = (v.options ?? [v.option1, v.option2, v.option3])
        .map(o => String(o).trim().toLowerCase());

      return inputValues.every((val, idx) => opts[idx] === val);
    });

    const variant = matchingVariants?.[0];    
    return variant?.id || null;
  }

  handleBackNavigation(e) {
    if (!e.state?.quickload) return;
    const url = this.getNormalizedURL(window.location.href);
    const htmlContent = window.globalQuickLoadCache.get(url);

    if (htmlContent) {
      this._performDOMUpdate(htmlContent, window.location.href, false);
    } else {
      window.location.reload();
    }
  }
}

class RevolutionSelectboxV2 {
  constructor(element, bodyScrollable, absolutePositioning, parentIdentifier, identifier) {
    if (!element) return;
    this.element = element;

    this.bodyScrollable = bodyScrollable;
    this.absolutePositioning = absolutePositioning;
    this.identifier = identifier;

    this.isOpen = false;

    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.selectedValueSpan = this.element.querySelector(".option-selector__selected-option");
    this.dropdown = this.element.querySelector(".option-selector__content-dropdown");
    if (!this.dropdown) return;
    this.button = this.element.querySelector(".option-selector__button");
    this.selectorParent = this.element.closest(`${parentIdentifier}`);

    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideBinder = this.onClickOutside.bind(this);

    this.delegateElement.on("click", '[data-action="toggle-selectbox"]', this.toggleDropdown.bind(this));
    this.delegateElement.on("click", '[data-action="handle-select"]', this.handleSelect.bind(this));
    this.delegateBody.on("selectbox:close", this.closeDropdown.bind(this));
  }

  onClickOutside(e) {
    const withinBoundaries = e.composedPath().includes(this.element);
    if (!withinBoundaries) {
      this.closeDropdown(e);
    }
  }

  handleSelect(e, target) {
    e.preventDefault();

    this.selectedValueSpan.innerHTML = target.innerHTML;
    this.dropdown.querySelector('.option-selector__option[selected="true"]').removeAttribute("selected");
    target.setAttribute("selected", "true");

    this.element.dispatchEvent(
      new CustomEvent("selectbox:change", {
        detail: {
          selectedValue: target.dataset.id || null,
          identifier: this.identifier || null,
        },
        bubbles: true
      })
    );

    this.closeDropdown();
  }

  initSelectbox() {
    const selectedValue = this.dropdown.querySelector('[selected="true"]');
    if (selectedValue) {
      this.selectedValueSpan.innerHTML = selectedValue.innerHTML;
    }

    if (this.absolutePositioning) {
      this.dropdown.classList.add('absolute');
    }

    this.animationOptions = {
      duration: 500,
      fill: "none",
      easing: "cubic-bezier(0.25, 1, 0.5, 1)"
    };
  }

  toggleDropdown(e) {
    e.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(e);
    } else {
      this.openDropdown(e);
    }
  }

  checkElementBottomDistance() {
    const distanceToBottom = window.innerHeight - this.button.getBoundingClientRect().bottom - 24;

    if (distanceToBottom < this.dropdown.offsetHeight) {
      this.dropdown.classList.remove('from-top');
      this.dropdown.classList.add('from-bottom');
    } else {
      this.dropdown.classList.remove('from-bottom');
      this.dropdown.classList.add('from-top');
    }
  }

  setAnimationSettings() {
    const originalStyles = {
      position: this.dropdown.style.position,
      visibility: this.dropdown.style.visibility,
      display: this.dropdown.style.display,
      pointerEvents: this.dropdown.style.pointerEvents,
      height: this.dropdown.style.height,
    };

    this.dropdown.style.position = "absolute";
    this.dropdown.style.visibility = "hidden";
    this.dropdown.style.display = "flex";
    this.dropdown.style.pointerEvents = "none";
    this.dropdown.style.height = "auto";

    const dropdownHeight = this.dropdown.offsetHeight;

    Object.keys(originalStyles).forEach((key) => {
      this.dropdown.style[key] = originalStyles[key];
    });

    this.expand = [
      { height: "0" },
      { height: dropdownHeight + "px" },
    ];

    this.retract = [
      { height: dropdownHeight + "px" },
      { height: "0" },
    ];
  }


  openDropdown(e) {
    e.preventDefault();

    if (this.isOpen) return;

    this.button.style.minWidth = 'fit-content';
    this.button.style.minWidth = this.button.getBoundingClientRect().width + 'px'

    this.element.dispatchEvent(new CustomEvent('selectbox:close', { detail: this.bodyScrollable, bubbles: true }));

    this.delegateBody.on("click", "body", this.onClickOutsideBinder);
    if (this.bodyScrollable) this.onScroll = scrollListener.addScrollListener(this, this.closeDropdown.bind(this));

    this.dropdown.setAttribute("aria-hidden", false);

    if (this.absolutePositioning) {
      this.checkElementBottomDistance();
    } else {
      this.setAnimationSettings();
    }

    requestAnimationFrame(() => {
      this.dropdown.setAttribute("aria-expanded", true)

      this.dropdown.style.width = this.button.getBoundingClientRect().width + 'px';
      if (!this.absolutePositioning) {
        this.animation = this.dropdown.animate(this.expand, this.animationOptions);
      }

      // If the body shouldn't be scrollable, disable body scroll
      if (!this.bodyScrollable) {
        const focus = this.element.querySelector('[data-scrollable]');
        bodyScrollLock.clearAllBodyScrollLocks();
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      }
    });

    // If there are multiple dropdowns on the same level, 
    if (this.selectorParent) {
      this.selectorParent.style.zIndex = '10';
    }

    if (this.selectorParent) {
      if (!this.absolutePositioning) {
        this.animation?.finished.then(() => {
          this.selectorParent.style.zIndex = '';
        });

        this.animation = null;
      } else {
        this.element.addEventListener("animationend", () => {
          this.selectorParent.style.zIndex = '';
        }, { once: true });
      }
    }

    trapFocus(this.dropdown);
    this.isOpen = true;
  }

  closeDropdown() {
    if (!this.isOpen) return;

    this.delegateBody.off("click", "body", this.onClickOutsideBinder);
    if (this.bodyScrollable) this.onScroll?.removeScrollListener() && (this.onScroll = null);

    this.button.style.minWidth = 'fit-content';
    this.button.style.minWidth = this.button.getBoundingClientRect().width + 'px';
    this.dropdown.style.width = this.button.getBoundingClientRect().width + 'px';

    if (this.selectorParent) {
      this.selectorParent.style.zIndex = '';
    }

    this.dropdown.setAttribute("aria-expanded", false)

    if (!this.absolutePositioning) {
      const animation = this.dropdown.animate(this.retract, this.animationOptions);

      animation.finished.then(() => {
        this.dropdown.setAttribute("aria-hidden", true);
        this.isOpen = false;
      });
    } else {
      this.element.addEventListener("animationend", () => {
        this.dropdown.setAttribute("aria-hidden", true);
        this.isOpen = false;
      }, { once: true });
    }

    if (!this.bodyScrollable) {
      bodyScrollLock.clearAllBodyScrollLocks();
    }

    removeTrapFocus(this.mainDropdownContent);
  }
}

let activeSlide = null;
let first = true;

class ProductElement extends HTMLElement {
  static DESKTOP_WIDTH = 1025;

  constructor() {
    super();
    this.element = this;
    this.observerTop = null;
    this.observerBottom = null;
    this.stickyObserver = null;
    this.footerObserver = null;
    this.stickyAtcForm = null;
    this.observerATCForm = null;
    this.atcPixelToWatch = null;
    this.isMobile = null;
    this.isDesktop = false;
    this.isPdpV2 = false;
  }

  connectedCallback() {
    this.isPdpV2 = this.getAttribute('data-pdp-v2') === 'true' || false;
    this.isDesktop = window.innerWidth > ProductElement.DESKTOP_WIDTH || false;
    this.changeImageQuality();
    this.atcPixelToWatch = this.element.querySelector('#atc-pixel-to-watch');
    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector('.pm__main-swiper');
    this.carouselElementThumbs =
      this.element.querySelector('.pm__thumb-swiper');
    this.swipers = this.element.querySelectorAll(
      '.pm__information .swiper:not(.pm__connected-swiper)',
    );
    this.descElement = this.element.querySelector('.pm__description-text');
    this.nextElement = this.descElement?.nextElementSibling;
    this.productForm = this.element.querySelector('[data-product-form]');
    if (this.carouselElement) {
      this.options = JSON.parse(
        this.carouselElement?.getAttribute('data-section-settings'),
      );
    }

    this.stickyAtc = this.element.querySelector('.pm__atc-form--sticky');
    this.stickyAtcForm = this.element.querySelector('.pm__atc-form');
    this.fixedAtc = this.element.querySelector('.pm__sticky-atc');
    this.annBar = document.querySelector('.announcement-bar--sticky');
    if (this.fixedAtc) {
      this.fixedInfo = this.fixedAtc.querySelector('.pm__sticy-product-info');
      this.fixedContainer = this.fixedAtc.querySelector(
        '.pm__sticky-atc-container',
      );
    }
    this.additionalProductSwiper = this.element.querySelector(
      '.pm__additional-product-swiper',
    );
    this.header = document.getElementById('header');
    this.footer = document.querySelector('footer-component');

    const initCarousel = !this.isPdpV2 ? true : !this.isDesktop;
    document.documentElement.style.setProperty('--sticky-atc-height', `0px`);

    if (
      (this.options?.slides_number > 1 || this.options?.hide_media) &&
      initCarousel
    ) {
      if (this.carouselElementThumbs) {
        this.carousel = new RevolutionSwiper(
          this.carouselElement,
          this.carouselElementThumbs,
        );
      } else {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    this.swipers.forEach((carousel) => new RevolutionSwiper(carousel));

    this.element
      .querySelectorAll('.pm__connected-swiper')
      .forEach((swiperElement) => {
        new RevolutionSwiper(swiperElement);
        if (activeSlide) swiperElement.swiper.slideTo(activeSlide, 0);
        swiperElement.swiper.on('slideChange', () => {
          activeSlide = swiperElement.swiper.activeIndex;
        });
        swiperElement.swiper.on('reachEnd', () => {
          setTimeout(() => {
            activeSlide = swiperElement.swiper.slides.length - 1;
          }, 200);
        });
        setTimeout(() => {
          swiperElement.classList.add('btn-transition');
        }, 100);
      });

    if (this.options?.zoom) {
      this.revolutionZoom = new RevolutionImageZoom(
        this.element,
        this.carouselElement,
      );
    }

    if (this.productForm) new AddToCart(this.productForm);
    if (this.additionalProductSwiper)
      new AddToCart(this.additionalProductSwiper);

    const replaceElements = [
      'section__product-module',
      'shopify-section__breadcrumbs',
    ];

    this.quickLoad = new QuickLoad(this.element, replaceElements, null, true);

    // Defer cache initialization until after the current render cycle
    /*setTimeout(() => {
      this.quickLoad.initializeCache();
    }, 0);*/

    if (!first) {
      if (this.element.querySelector('[data-action="handle-reload"]'))
        this.quickLoad.reloadWithoutRefresh(null);
    }
    
    first = false;

    const materialsDrawer = this.element.querySelector('#pm__materials-drawer');
    this.initMaterialsDrawer(materialsDrawer);

    this.sizeGuideDrawer = this.element.querySelector('#pm__size-guide-drawer');
    this.initSizeGuideDrawer();

    this.deliveryInfoDrawer = this.element.querySelector(
      '#pm__delivery_info-drawer',
    );
    this.initDeliveryInfoDrawer();

    if (this.descElement && responsive.matchesBreakpoint('lap_and_up'))
      this.setHeight();

    this.bindEvents();
    this.onScroll();
    this.setRecentlyViewed();
  }

  disconnectedCallback() {
    this.quickLoad.destroy();
    this.observerTop?.disconnect();
    this.observerBottom?.disconnect();

    if (this.stickyObserver) {
      this.stickyObserver.disconnect();
    }

    if (this.footerObserver) {
      this.footerObserver.disconnect();
    }

    if (this.observerATCForm) {
      this.observerATCForm.disconnect();
    }
  }

  bindEvents() {
    // window.addEventListener("scroll", this.onScroll.bind(this), { passive: true });
    this.onScroll();

    if (this.descElement && responsive.matchesBreakpoint('lap_and_up'))
      window.addEventListener('wheel', this.onDescriptionScroll.bind(this), {
        passive: false,
      });

    if (this.sizeGuideDrawer)
      this.delegateElement.on(
        'selectbox:change',
        this.toggleContainer.bind(this),
      );
    if (this.stickyAtc)
      window.addEventListener(
        'DOMContentLoaded',
        this.setStickyContent.bind(this),
      );
    if (this.descElement)
      window.addEventListener('DOMContentLoaded', this.setHeight.bind(this));
    if (this.productForm)
      this.delegateElement.on('click', '[data-action="add-to-cart-og"]', () =>
        this.productForm.querySelector('[data-action="add-to-cart"]')?.click(),
      );
    if (this.stickyAtc) this.initObserver();
  }

  setRecentlyViewed() {
    const maxProducts = 10;
    const productId = JSON.stringify(this.element.dataset.productId);
    if (!productId) return;
    let viewedProducts = JSON.parse(
      localStorage.getItem('viewedProducts') || '[]',
    );

    viewedProducts = viewedProducts.filter((p) => p !== productId);
    // Add the new product at the beginning
    viewedProducts.unshift(productId);
    // Keep only the last 6 products
    if (viewedProducts.length > maxProducts) {
      viewedProducts = viewedProducts.slice(0, maxProducts);
    }

    localStorage.setItem('viewedProducts', JSON.stringify(viewedProducts));
  }

  initObserver() {
    const observeATCPixelWatch = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.stickyAtc.classList.remove('pm__atc-form--fixed');
          }

          if (entry.boundingClientRect.top < 0) {
            if (!entry.isIntersecting) {
              this.stickyAtc.classList.add('pm__atc-form--fixed');
            }
          }
        });
      },
      {
        threshold: [0, 1],
      },
    );

    observeATCPixelWatch.observe(this.atcPixelToWatch);
  }

  initDeliveryInfoDrawer() {
    if (!this.deliveryInfoDrawer) return;

    new Drawer(this.deliveryInfoDrawer);
  }

  initSizeGuideDrawer() {
    if (!this.sizeGuideDrawer) return;

    this.allDimensions =
      this.sizeGuideDrawer.querySelectorAll('.pm__dimension');
    new Drawer(this.sizeGuideDrawer);
    new RevolutionSelectboxV2(
      this.sizeGuideDrawer.querySelector(
        '.pm__dimension-togglers .option-selector',
      ),
      true,
      true,
      null,
      'unit',
    );
  }

  initMaterialsDrawer(materialsDrawer) {
    if (materialsDrawer) {
      this.drawerMainCarousel = materialsDrawer.querySelector(
        '.pm__material-swiper',
      );
      this.drawerThumbCarousel =
        materialsDrawer.querySelector('.pm__label-swiper');

      // Function to initialize Swiper
      const initializeSwiper = () => {
        setTimeout(() => {
          this.drawerCarousel = new RevolutionSwiper(
            this.drawerMainCarousel,
            this.drawerThumbCarousel,
          );
          if (
            this.drawerThumbCarousel.parentElement.querySelectorAll(
              '.swiper-button-lock',
            ).length < 2
          ) {
            this.drawerThumbCarousel.parentElement.classList.add('small');
            setTimeout(() => {
              this.drawerThumbCarousel.swiper.update();
            }, 100);
          }
        }, 100);
      };

      // MutationObserver to detect when the slides are added to the carousel
      const observer = new MutationObserver((mutationsList, observer) => {
        let slidesAdded = false;

        mutationsList.forEach((mutation) => {
          // Check if new slides have been added to both carousels
          if (mutation.type === 'childList') {
            if (
              mutation.target === this.drawerMainCarousel.firstElementChild ||
              mutation.target === this.drawerThumbCarousel.firstElementChild
            ) {
              slidesAdded = true;
            }
          }
        });

        // If both carousels have slides added, initialize Swiper
        if (slidesAdded) {
          initializeSwiper();
          observer.disconnect(); // Disconnect observer once it's initialized
        }
      });

      // Set observer options to observe child nodes being added to both carousels
      observer.observe(this.drawerMainCarousel.firstElementChild, {
        childList: true,
        subtree: true,
      });

      observer.observe(this.drawerThumbCarousel.firstElementChild, {
        childList: true,
        subtree: true,
      });

      materialsDrawer
        .querySelectorAll('.pm__material')
        .forEach((slide) =>
          this.drawerMainCarousel.firstElementChild.appendChild(slide),
        );
      materialsDrawer
        .querySelectorAll('.pm__material-type')
        .forEach((slide) =>
          this.drawerThumbCarousel.firstElementChild.appendChild(slide),
        );

      this.element
        .querySelectorAll(
          '.pm__toggle-drawer[data-toggle-id="pm__materials-drawer"]',
        )
        .forEach((element, index) => (element.dataset.index = index));

      new Drawer(materialsDrawer, {
        onOpen: (e) => {
          this.drawerCarousel.selectCell(e.target.dataset.index);
        },
      });
    }
  }

  toggleContainer(e) {
    if (!e.detail || !e.detail.identifier || e.detail.identifier !== 'unit')
      return;
    const id = e.detail.selectedValue;

    this.allDimensions.forEach((container) => {
      if (container.dataset.id === id) {
        container.setAttribute('aria-hidden', false);
      } else {
        container.setAttribute('aria-hidden', true);
      }
    });
  }

  setHeight() {
    this.originalHeight = this.descElement.offsetHeight;
    this.newHeight = this.originalHeight;
  }

  setStickyContent() {
    if (!this.stickyAtc) return;
    this.setStickyHeight();

    const selectorLabels = document.querySelectorAll(
      'variant-selects .pm__selector-label',
    );
    if (selectorLabels.length > 1) {
      const stickyDetails = this.fixedInfo.querySelector('.pm__sticky-details');
      stickyDetails
        .querySelectorAll('.pm__selector-label')
        .forEach((label) => label.remove());
      selectorLabels.forEach((label) => {
        const clonedLabel = label.cloneNode(true);
        stickyDetails.appendChild(clonedLabel);
      });
    }
  }

  setStickyHeight() {
    if (!this.fixedAtc) return;

    this.fixedAtc.style.visibility = 'hidden';
    this.fixedAtc.style.pointerEvents = 'none';

    const show = this.fixedAtc.classList.contains('show');
    if (!show) this.fixedAtc.classList.add('show');
    const attrValue = this.fixedAtc.getAttribute('aria-hidden');
    this.fixedAtc.setAttribute('aria-hidden', false);

    document.documentElement.style.setProperty(
      '--sticky-atc-height',
      `${this.fixedAtc.offsetHeight}px`,
    );

    if (!show) this.fixedAtc.classList.remove('show');
    this.fixedAtc.setAttribute('aria-hidden', attrValue);

    this.fixedAtc.style.visibility = '';
    this.fixedAtc.style.pointerEvents = '';
  }

  onDescriptionScroll(e) {
    if (!this.marginReached && window.scrollY == 0) {
      e.preventDefault();
    }

    const scrollAmount = e.deltaY;
    this.newHeight = Math.min(
      this.newHeight - scrollAmount,
      this.originalHeight,
    );

    this.descElement.style.height = Math.max(this.newHeight, 0) + 'px';
    const marginTop = this.newHeight < 0 ? Math.max(this.newHeight, -48) : 0;
    this.nextElement.style.marginTop = `${marginTop}px`;

    if (marginTop === -48) {
      this.marginReached = true;
    } else {
      this.marginReached = false;
    }
  }

  onScroll() {
    if (!this.stickyAtc) return;

    const annBarHeight = this.annBar ? this.annBar.offsetHeight : 0;
    const headerHeight = this.header.offsetHeight;

    // Observer for stickyAtc - triggers when it leaves viewport
    const stickyObserver = new IntersectionObserver(
      (entries) => {
        const showFixed = !entries[0].isIntersecting;

        if (showFixed && !this.fixedAtc.classList.contains('show')) {
          //  this.fixedAtc.classList.add('show');
          if (responsive.matchesBreakpoint('lap_and_up')) {
            this.fixedAtc.classList.add('show');
            requestAnimationFrame(() => {
              this.fixedAtc.offsetHeight;
              this.fixedInfo.setAttribute('aria-hidden', false);
              this.fixedContainer.style.visibility = 'visible';
            });
          }
        } else if (!showFixed && this.fixedAtc.classList.contains('show')) {
          if (responsive.matchesBreakpoint('lap_and_up')) {
            this.fixedContainer.style.visibility = 'hidden';
            this.fixedInfo.setAttribute('aria-hidden', true);
            this.fixedInfo.addEventListener(
              'transitionend',
              () => {
                if (!showFixed && this.fixedAtc.classList.contains('show')) {
                  this.fixedAtc.classList.remove('show');
                }
              },
              { once: true },
            );
          } else {
            this.fixedAtc.classList.remove('show');
          }
        }
      },
      {
        threshold: 0,
        rootMargin: `-${headerHeight + annBarHeight}px 0px 0px 0px`,
      },
    );

    // Observer for footer - hides fixed ATC when footer is visible
    const footerObserver = new IntersectionObserver(
      (entries) => {
        const hideFixed = entries[0].isIntersecting;

        if (hideFixed) {
          this.fixedAtc.setAttribute('aria-hidden', true);
        } else {
          this.fixedAtc.setAttribute('aria-hidden', false);
        }
      },
      {
        threshold: 0,
        rootMargin: `-${
          headerHeight + this.fixedAtc.offsetHeight + annBarHeight
        }px 0px 0px 0px`,
      },
    );

    // Start observing
    stickyObserver.observe(this.stickyAtc);
    footerObserver.observe(this.footer);

    // Store observers for cleanup in disconnectedCallback
    this.stickyObserver = stickyObserver;
    this.footerObserver = footerObserver;
  }

  changeImageQuality() {
    var imagesToReveal = null;
    imagesToReveal = this.element.querySelectorAll('.preload-image');

    imagesToReveal.forEach((image) => {
      if (image !== null) {
        const replaceUrl = image.getAttribute('data-primary-src');
        image.src = replaceUrl;
      }
    });
  }
}
customElements.define('product-component', ProductElement);

let selectedVariant = null;
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.isPdpV2 = false;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.init();
    this.setOptions();
    this.bindEvents();

    this.onVariantChange();
    this.materialsPresent = this.loadMaterials();
    this.checkDataMaterial();

    this.initDesignYourOwn();
    this.doubleCheckBackrest();
  }

  init() {
    const settingsElement = this.element.querySelector('[data-settings]');
    if (settingsElement) {
      this.targetVariants = JSON.parse(settingsElement.dataset.settings);
      this.variantOptionSelector = settingsElement.closest('.pm__variant-option');
    }

    const dataElement = this.element.querySelector("[data-bag-variants]");
    if (dataElement) {
      this.bagVariants = JSON.parse(dataElement.dataset.bagVariants);
    }

    this.pigmentTemplate = this.element.querySelector("[data-pigment]");
    if (this.pigmentTemplate) {
      this.pigmentData = JSON.parse(this.pigmentTemplate.dataset.pigment);
    }

    this.baseCoatId = this.element.querySelector("[data-base-coat]")?.dataset.baseCoat;

    const inputs = document.querySelectorAll('.pm__property-input');
    this.inputMap = Array.from(inputs).map(input => {
      return {
        element: input,
        customIds: JSON.parse(input.dataset.customIds).map(Number)
      }
    });

    this.atcButton = document.querySelector(".pm__atc-button--main");
    this.notifyButtons = document.querySelectorAll(".pm__notify-button");
    this.stickyButton = document.querySelector(".pm__sticky-button");
    this.notifyMeEnabled = document.querySelector("notify-me-popup");
    this.baseCoatId = this.element.querySelector("[data-base-coat]")?.dataset.baseCoat;
    this.productModule = this.element.closest('product-component');
    this.isPdpV2 = this.productModule?.getAttribute('data-pdp-v2') === 'true' || false;
    this.indicatorString = document.querySelector('.pm__indicator .pm__indicator-string .delivery-time');
    this.futureTimeDiv = document.querySelector('#variant-delivery-data');
    if (this.futureTimeDiv) {
      this.futureTime = JSON.parse(this.futureTimeDiv.textContent);
    }
    this.priceContainer = document.querySelector('.pm__price-info');
    this.studioViewer = this.productModule.querySelector('studio-viewer');
    this.productSwiper = this.productModule.carouselElement;
    if (this.productSwiper) {
      this.studioViewerOverlay = this.productSwiper.querySelector('.studio-viewer-overlay');
      this.presetMaterialsElem = this.productModule.querySelector('#preset-materials');
      this.mediaJsonElem = this.productSwiper.querySelector("#media-json");
      this.productThumbSwiper = this.productModule.carouselElementThumbs;
      if (this.mediaJsonElem) {
        this.mediaJson = JSON.parse(this.mediaJsonElem.textContent);
      }
    }

    if (this.presetMaterialsElem) this.presetMaterials = JSON.parse(this.presetMaterialsElem.textContent);
    this.first = true;

    if (this.priceContainer) {
      this.saleLabel = this.priceContainer.querySelector('.pm__sale-label');
      this.comparePrice = this.priceContainer.querySelector('.pm__compare-price');
      this.realPrice = this.priceContainer.querySelector('.pm__regular-price');
      this.lowestPrice = this.priceContainer.querySelector('.pm__lowest-price');
    }
  }

  disconnectedCallback() {
    this.delegateBody?.destroy();
    this.delegateElement?.destroy();
    this.studioViewer?.removeEventListener("loaded", this.setMaterialsBinder);
  }

  initDesignYourOwn() {    
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.forEach((value, key) => {
      if (key.includes("model")) {
        this.selectMaterial(key, value);
      }
    })
  }

  selectMaterial(key, value) {
    const [model, slot, subSlot] = String(key).split(".");
    if (model !== "model" || !slot || !subSlot) return;    

    const objectSelector = this.element.querySelector(`.pm__object-selector[data-slot="${slot}"][data-sub-slot="${subSlot}"]`);
    const objectInput = objectSelector?.querySelector(`.pm__option-input[data-material="${value}"]:not(:checked)`);

    if (objectInput) return objectInput.click();

    const checkedObjectInput = objectSelector?.querySelector(`.pm__option-input[data-material="${value}"]:checked`);
    if (!checkedObjectInput) return;

    const dummyEvent = new Event("dummy:event", { bubbles: true });
    Object.defineProperty(dummyEvent, "target", { writable: false, value: checkedObjectInput });
    this.updateOriginalLabel(dummyEvent);
  }

  doubleCheckBackrest() {
    const backrestInputs = this.element.querySelectorAll('.pm__form-property-input[name="properties[Backrest]"]');
    const noBackrestSelected = this.element.querySelector('.pm__option-input[data-id="nobackrest"]:checked');

    if (backrestInputs.length === 0 || !noBackrestSelected) return;

    backrestInputs.forEach(input => input.value = "");
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    this.delegateElement.on(
      "change",
      '[data-action="select-variant"]',
      this.onVariantChange.bind(this)
    ); 

    this.delegateElement.on(
      "keydown",
      '[data-action="select-variant"]',
      onEnter((event) => {
        const target = event.target.closest('[data-action="select-variant"]');
        if (target) {
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      })
    );
    
    
    this.setMaterialsBinder = this.setMaterials.bind(this);
    if (this.studioViewer) this.studioViewer.addEventListener("loaded", this.setMaterialsBinder);

    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.delegateElement.on("mouseenter", '[data-label]', this.updateOptionValue.bind(this), true);
      this.delegateElement.on("mouseleave", '[data-label]', this.resetOptionValue.bind(this), true);
    }
  }

  getModelParamsFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const modelParams = {};

    // Loop through all URL parameters and find the ones with 'model'
    urlParams.forEach((value, key) => {
      if (key.includes('model')) {
        modelParams[key] = value;
      }
    });

    return modelParams;
  }

  checkDataMaterial() {
    this.element.classList.add('disable-transition');
    const modelParams = this.getModelParamsFromURL();

    // For each model parameter, search for matching data-material attributes
    for (const [key, value] of Object.entries(modelParams)) {
      const input = document.querySelector(`[data-material="${value}"]`);
      if (input) {
        input.checked = true;
        const variantSelector = input.closest('.pm__variant-selector');
        if (variantSelector) {
          const paramInputs = variantSelector.querySelectorAll('.pm__form-property-input');
          paramInputs.forEach(param => param.value = input.value);
        }
      }
    }

    requestAnimationFrame(() => this.element.classList.remove('disable-transition'));
  }

  updateOptionValue(event, targetElement) {
    clearTimeout(this.resetTimer);

    const parentElement = targetElement.closest('.pm__selector');
    this.labelElement = parentElement.querySelector('.pm__hover-title');
    if (!this.labelElement || event.target.tagName.toLowerCase() === 'img') return;
    const selectedLabel = targetElement.dataset.label;

    if (targetElement.closest('.pm__object-selector') && parentElement.querySelector('.pm__option-selector')) {
      this.resetOptionValue(event, targetElement, 0);
      const labelParts = this.labelElement.textContent.split('|');
      this.labelElement.textContent = `${labelParts[0]} | ${selectedLabel}`;
    } else if (targetElement.closest('.pm__option-selector') && parentElement.querySelector('.pm__object-selector')) {
      this.resetOptionValue(event, targetElement, 0);
      const option = targetElement.previousElementSibling.dataset.option;
      const secondPartElem = parentElement.querySelector(`.pm__object-selector[data-option="${option}"]`);
      if (secondPartElem) {
        const secondPart = secondPartElem.querySelector('input:checked').dataset.label;
        this.labelElement.textContent = `${selectedLabel} | ${secondPart || ""}`;
      } else {
        this.labelElement.textContent = selectedLabel || "";
      }
    } else {
      this.labelElement.textContent = selectedLabel || "";
    }
  }

  resetOptionValue(e, target, delay = 150) {
    const label = target.closest('.pm__selector').querySelector('.pm__hover-title');
    if (!label || e.target.tagName.toLowerCase() === 'img') return;

    if (delay == 0) {
      label.textContent = label.dataset.originalLabel || "";
      return;
    }

    this.resetTimer = setTimeout(() => {
      label.textContent = label.dataset.originalLabel || "";
    }, delay);
  }

  updateOriginalLabel(event) {
    if (!event) {
      this.element.querySelectorAll('.pm__option-input:checked').forEach(input =>
        document.querySelector(`.option-selector__option[data-id="${input.dataset.id}"]`)?.click()
      );
      return;
    }

    const selectedValue = event.target.dataset.label;
    const selectedOption = event.target.dataset.option;
    const parentElement = event.target.closest('.pm__variant-selector');
    const labelElement = parentElement.querySelector('.pm__hover-title');

    document.querySelector(`.option-selector__option[data-id="${event.target.dataset.id}"]`)?.click();

    if (!labelElement) return;

    if (event.target.closest('.pm__object-selector') && parentElement.querySelector('.pm__option-selector')) {
      const optionSelectorValue = parentElement
        .querySelector('.pm__option-selector :checked')
        .value;

      labelElement.textContent = `${optionSelectorValue} | ${selectedValue}`;
      labelElement.dataset.originalLabel = `${optionSelectorValue} | ${selectedValue}`;

      const inputs = parentElement.querySelectorAll('.pm__form-property-input');
      inputs.forEach(input => input.value = selectedValue);
    } else if (event.target.closest('.pm__option-selector') && parentElement.querySelector('.pm__object-selector')) {
      this.toggleObjectSelector(parentElement, selectedOption);

      const objectSelector = parentElement.querySelector('.pm__object-selector[aria-hidden="false"] :checked');

      if (objectSelector) {
        const objectSelectorValue = objectSelector.dataset.label;
        labelElement.textContent = `${selectedValue} | ${objectSelectorValue}`;
        labelElement.dataset.originalLabel = `${selectedValue} | ${objectSelectorValue}`;
      } else {
        labelElement.textContent = selectedValue;
        labelElement.dataset.originalLabel = selectedValue;
      }
    } else {
      labelElement.textContent = selectedValue;
      labelElement.dataset.originalLabel = selectedValue;
    }
  }

  async loadMaterials() {
    if (!this.studioViewer) return;

    const apiDomain = this.studioViewer.getAttribute('api-domain');
    const canvasId = this.studioViewer.id;

    try {
      const data = await fetch(`${apiDomain}/canvases/public/${canvasId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const canvas = await data.json();
      if (!data.ok) throw Error();

      this.nodeNames = canvas.nodeNames;
      this.canvasSlotsMaterials = canvas.canvasSlotsMaterials || [];
      this.canvasSlotsTags = canvas.canvasSlotsTags || [];

      return true;
    } catch (error) {
      if (!this.productSwiper) return;
      const carouselElement = this.productSwiper;
      const thumbCarouselElement = this.productModule.carouselElementThumbs;

      if (thumbCarouselElement && thumbCarouselElement.swiper) {
        thumbCarouselElement.swiper.removeSlide(0);
      }
      if (carouselElement && carouselElement.swiper) {
        carouselElement.swiper.removeSlide(0);
        carouselElement.swiper.setTranslate(0);
        carouselElement.swiper.slideTo(0);
      }

      console.error(`Possibly wrong Studio3D Canvas ID or API domain. ${error.message}`);
    }
  }

  findCanvasId() {
    if (!this.ids) {
      const idsScript = this.productSwiper.querySelector('#canvas-ids');
      if (idsScript) {
        this.ids = JSON.parse(idsScript.textContent);
      } else {
        return;
      }
    }
    return Object.keys(this.ids).find(key => this.ids[key].includes(selectedVariant?.id.toString())) || Object.keys(this.ids)[0];
  }

  renderViewer(canvasId) {
    if (canvasId == this.studioViewer.id) return;
    this.studioViewerOverlay.classList.remove('hide');
    this.studioViewer.id = canvasId;
  }

  initStudioViewer() {
    if (this.customized) return;
    this.customized = true;

    const shadowRoot = this.studioViewer.shadowRoot;
    if (shadowRoot) {
      const modelViewerStyle = this.productSwiper?.querySelector('#model-viewer-style');
      if (modelViewerStyle) {
        shadowRoot.appendChild(modelViewerStyle.cloneNode(true));
      }

      const arButton = shadowRoot.querySelector('.ar-button');
      const pmAr = this.productSwiper?.querySelector('.pm__ar');
      if (arButton && pmAr) {
        arButton.appendChild(pmAr.cloneNode(true));
        arButton.setAttribute('aria-label', 'View in AR');
      }

      const measureButton = shadowRoot.querySelector('.measure-button');
      const pmRuler = this.productSwiper?.querySelector('.pm__ruler');
      if (measureButton && pmRuler) {
        measureButton.appendChild(pmRuler.cloneNode(true));
        measureButton.setAttribute('aria-label', 'Measure button');
      }
    }

    this.initObserver();

  }

  

  initObserver() {
    this.studioObserver = new MutationObserver(() => {
      const imgSrc = this.studioViewer.screenShotPlaceholder.src;
      if (imgSrc.includes("blob")) {
        modelImgSrc = imgSrc;
      }
    });
    this.studioObserver.observe(this.studioViewer.screenShotPlaceholder, { attributes: true, attributeFilter: ['src'] });
  }

  async setMaterials() {
    this.newCanvas = this.studioViewer.id;

    if (this.materialsPresent instanceof Promise) {
      this.materialsPresent = await this.materialsPresent;
    }

    if (this.materialCanvas !== this.newCanvas) {
      await this.loadMaterials();
      this.materialCanvas = this.studioViewer.id;
    }

    this.initStudioViewer();

    const urlParams = new URLSearchParams(window.location.search);

    let promises = [];
    if (this.presetMaterials) {
      // Process presetMaterials first and prioritize them
      const presetPromises = this.presetMaterials.map(({ slot, tag_slot, material }) => {
        return this.applyMaterial(slot, tag_slot, material);
      });

      // Create a set of unique slot and tag_slot combinations from presetMaterials
      const presetSlots = new Set(this.presetMaterials.map(({ slot, tag_slot }) => `${slot}.${tag_slot}`));

      // Process urlParams, but exclude those that already exist in presetMaterials
      const urlParamsPromises = Array.from(urlParams.entries()).map(([paramKey, materialName]) => {
        if (!paramKey.startsWith('model.')) {
          return;
        }

        const [slotName, tagName] = paramKey.split('.').slice(1);
        const key = `${slotName}.${tagName}`;

        // Only apply material from urlParams if it doesn't exist in presetMaterials
        if (!presetSlots.has(key)) {
          return this.applyMaterial(slotName, tagName, materialName);
        }
      }).filter(Boolean);  // Filter out any undefined values (where the condition didn't match)

      // Combine both preset promises and urlParams promises
      promises = [...presetPromises, ...urlParamsPromises];
    } else {
      // If no presetMaterials, just handle urlParams as before
      promises = Array.from(urlParams.entries()).map(([paramKey, materialName]) => {
        if (!paramKey.startsWith('model.')) {
          return;
        }

        const [slotName, tagName] = paramKey.split('.').slice(1);

        return this.applyMaterial(slotName, tagName, materialName);
      });
    }

    // Wait for all promises to resolve (no need for try-catch here since applyMaterial has it)
    await Promise.all(promises);

    // Hide the overlay after all materials are applied
    setTimeout(() => {
      if (!this.studioViewerOverlay.classList.contains('hide')) {
        this.studioViewerOverlay.classList.add('hide');
      }
    }, 10);
  }

  updateMaterials(target) {
    if (this.materialsPresent instanceof Promise) {
      return;
    }

    const materialName = target.dataset.material;
    if (!materialName) return;

    const selector = target.closest('.pm__object-selector') || target.closest('.pm__option-selector');
    const tagName = selector.dataset.subSlot;
    const slotName = selector.dataset.slot;

    if (!slotName) return;
    const urlParams = new URLSearchParams(window.location.search);

    const baseParamKey = `model.${slotName}`;
    const fullParamKey = tagName ? `${baseParamKey}.${tagName}` : baseParamKey;

    for (const [key] of urlParams.entries()) {
      if (key.includes(baseParamKey)) {
        urlParams.delete(key);
      }
    }

    urlParams.set(fullParamKey, materialName);

    history.replaceState(null, '', `${window.location.pathname}?${urlParams.toString()}`);

    this.applyMaterial(slotName, tagName, materialName);
  }

  async applyMaterial(slotName, tagName, materialName) {
    try {
      if (!tagName) {
        const targetIndex = this.nodeNames.indexOf(slotName);
        const filteredMaterials = this.canvasSlotsMaterials.filter((obj, index) => {
          return obj => index === targetIndex
        });

        const matchingMaterial = filteredMaterials.find(obj => obj.material.name.trim() === materialName.trim());
        await this.studioViewer.setMaterial(matchingMaterial.material.id, matchingMaterial.index);
      } else {
        const targetIndex = this.nodeNames.indexOf(slotName);
        const matchingTagSlot = this.canvasSlotsTags.find((obj) => {
          return obj.tag.name.trim() === tagName.trim();
        });
        if (!matchingTagSlot) return;
        const matchingMaterial = matchingTagSlot.materials.find(obj => obj.name.trim() === materialName.trim());
        await this.studioViewer.setMaterial(matchingMaterial.id, targetIndex);
      }
    } catch (error) {
      console.error(`Studio Viewer didn't load properly. Possibly metaobject variable names don't match the Studio3D variable names. Error: ${error.message}`);
    }
  }

  toggleObjectSelector(parent, option) {
    const toHide = parent.querySelector('.pm__object-selector[aria-hidden="false"]');
    const toShow = parent.querySelector(`.pm__object-selector[data-option="${option}"]`);

    if ((toHide || toShow) && toHide != toShow) {
      if (toShow) {
        const selectedInput = toShow.querySelector('.pm__option-input:checked');
        this.updateMaterials(selectedInput);
        toShow.setAttribute('aria-hidden', false);

        const inputs = parent.querySelectorAll('.pm__form-property-input');
        inputs.forEach(input => input.value = selectedInput.value);
      } else {
        const inputs = parent.querySelectorAll('.pm__form-property-input');
        inputs.forEach(input => input.value = '');
      }
      if (toHide) {
        toHide.setAttribute('aria-hidden', true);
      } else {
        const selectedInput = toShow.querySelector('.pm__option-input:checked');
        const inputs = parent.querySelectorAll('.pm__form-property-input');
        inputs.forEach(input => input.value = selectedInput.value);
      }
    }
  }

  setOptions() {    
    if (!selectedVariant) return;
    
    selectedVariant?.options.forEach(optionValue => {
      const matchingInput = this.querySelector(`input[value="${optionValue}"]`);      

      if (matchingInput) {
        matchingInput.checked = true;
      }
    });
  }

  reloadSelectedVariant() {
    this.updateOptions();
    this.updateMasterId();
  }

  onQuantityChange() {
    this.reloadSelectedVariant();
    this.toggleAddButton();
  }

  onVariantChange(e) {
    const targetEl = e?.target;
    if (targetEl?.dataset?.isConnectedProduct == 'true') {
      this.updateConnectedProductData(targetEl);
      this.updateFeaturedMedia();
    }

    this.updateOriginalLabel(e);
    this.reloadSelectedVariant();

    if (this.mediaJson) {
      this.isPdpV2 ? this.updateMediaV2() : this.updateMedia();
    }
    
    this.toggleAddButton();
    this.togglePriceEl();
    if (e && e.target) this.updateCanvases(e.target);
    if (e && e.target) this.updateMaterials(e.target);
    this.sendVariantGTMEvent();
    this.updatePrices();
    this.updateFeaturedImage();
    this.updateURL();
    this.updateVariantInput();
    this.toggleInputs();
    this.productIndicator();
    this.updateStickyDetails();
  }

  updateCanvases(canvasIdOrNode) {
    let canvasId = null;
  
    if (typeof canvasIdOrNode === 'string') {
      canvasId = canvasIdOrNode;
    } else if (canvasIdOrNode && canvasIdOrNode.dataset && canvasIdOrNode.dataset.canvasId) {
      canvasId = canvasIdOrNode.dataset.canvasId;
    }
  
    if (!canvasId) return;
  
    const studioViewers = document.querySelectorAll('studio-viewer');
    if (!studioViewers.length) return;
    
    studioViewers.forEach(viewer => {
      if (viewer.dataset.canvasId === canvasId) return;

      viewer.id = canvasId;
      viewer.dataset.canvasId = canvasId;
    });
  }

  isSameMedia(previous, current) {
    return previous.length === current.length && previous.every((value, index) => value === current[index]);
  }

  sortMediaSelectorsByOptionOrder(selectors) {
    return selectors.sort((a, b) => {
      const aIndex = parseInt(a.dataset.mediaFilenamePosition);
      const bIndex = parseInt(b.dataset.mediaFilenamePosition);
      return (!aIndex ? Infinity : aIndex) - (!bIndex ? Infinity : bIndex);
    });
  }

  updateMediaV2() {
    // Get all selectors and sort them
    const selectors = Array.from(document.querySelectorAll('.pm__selector.size-selector-container'));
    const sortedSelectors = this.sortMediaSelectorsByOptionOrder(selectors);
    
    let selectedOptions = [];
    sortedSelectors.forEach(selector => {
      let node = selector.querySelector('input:checked');
      
      if (node) {
        let nodeVariantItemIndex = node.dataset.variantItemIndex;
        const nodeSubOptionIndex = node.dataset.variantSuboptionIndex;
        const hideMaterial = node.dataset.isHideMaterial === 'true';

        if (nodeVariantItemIndex === undefined) nodeVariantItemIndex = 'all';
        if (hideMaterial) nodeVariantItemIndex = ''; 

        if (nodeSubOptionIndex) selectedOptions.push(nodeSubOptionIndex);
        if (nodeVariantItemIndex) selectedOptions.push(nodeVariantItemIndex);
      }
    });

    this.getAndPopulateMatchingMedia(selectedOptions);
  }

  updateMedia() {
    const selectors = this.element.querySelectorAll('.pm__object-selector[aria-hidden="false"], .pm__option-selector[aria-hidden="false"], .pm__connected-items');
    
    let selectedOptions = [];
    selectors.forEach(selector => {
      let node = selector.querySelector('input:checked');
      
      if (node) {
        const nodeParent = node.parentElement;
        selectedOptions.push(Array.prototype.indexOf.call(Array.from(nodeParent.parentNode.children), nodeParent) + 1);
      } else {
        node = selector.querySelector('.pm__selector-item--selected[data-parameters]');
        if (node) {
          selectedOptions.push(Array.prototype.indexOf.call(Array.from(node.parentNode.children), node) + 1);
        }
      }
    });

    this.getAndPopulateMatchingMedia(selectedOptions);
  }

  getAndPopulateMatchingMedia(selectedOptions) {
    try {
      const matchingMedia = this.mediaJson?.filter(filename => {
        const baseFilename = filename.split('.')[0].replace('-thumb', '');

        let firstPart;
        if (baseFilename.includes('-')) {
          const filenameParts = baseFilename.split('-');
          firstPart = filenameParts[0];
        } else {
          firstPart = baseFilename;
        }

        const baseFilenameParts = firstPart.split('_');

        if (baseFilenameParts.length !== selectedOptions.length) {
          return false;
        }

        for (let i = 0; i < baseFilenameParts.length; i++) {
          if (baseFilenameParts[i] !== 'all' && baseFilenameParts[i] !== String(selectedOptions[i])) {
            return false;
          }
        }

        return true;
      });

      if (this.previousMatchingMedia && this.isSameMedia(this.previousMatchingMedia, matchingMedia)) {
        return;
      }

      const imageTypes = ['webp', 'jpg', 'jpeg', 'png', 'gif'];
      const videoTypes = ['mp4', 'webm', 'mov', 'avi'];

      const matchingImages = matchingMedia.filter(filename => {
        const fileExtension = filename.split('.').pop().toLowerCase();
        return imageTypes.includes(fileExtension);
      });

      const matchingVideos = matchingMedia.filter(filename => {
        const fileExtension = filename.split('.').pop().toLowerCase();
        return videoTypes.includes(fileExtension);
      });


      let sortedImages = this.sortMediaArray(matchingImages);
      const sortedVideos = this.sortMediaArray(matchingVideos);

      const matchingThumbs = sortedImages.filter(filename => filename.includes('thumb'));
      sortedImages = sortedImages.filter(filename => !filename.includes('thumb'));

      // Dispatch the custom event
      this.dispatchEvent(new CustomEvent('dyo-media:change', {
        detail: {
          mediaUrl: this.mediaJsonElem.dataset.url,
          mediaList: sortedImages,
        },
        bubbles: true,
        composed: true,
      }));

      this.populateSwiper(sortedImages, sortedVideos, matchingThumbs);

      this.previousMatchingMedia = matchingMedia;
    } catch (error) {
      console.error("Error parsing media filenames JSON:", error);
      return [];
    }
  }

  isDesktopViewport() {
    return window.innerWidth > 1025;
  }
  
  shouldInitializeCarousel() {
    return !this.isPdpV2 || !this.isDesktopViewport();
  }
  
  reinitializeMediaSwiper(carouselElement, thumbCarouselElement=null) {
    // Prevent re-initialization if already initialized
    if (!carouselElement || carouselElement.classList.contains('swiper-initialized')) return;
  
    if (!this.shouldInitializeCarousel()) return;
  
    if (carouselElement) {
      new RevolutionSwiper(carouselElement, thumbCarouselElement);
    } else {
      new RevolutionSwiper(carouselElement);
    }
  }

  removeMediaSlidesByClass(wrapper, className) {
    wrapper?.querySelectorAll(`.${className}`).forEach(slide => slide.remove());
  }

  createMediaSlide(template, mediaItem, slideClass='') {
    const templateContent = template.content;
    const slide = templateContent.querySelector('.swiper-slide').cloneNode(true);

    // Remove all known dynamic/media classes, then add the desired one
    if (slideClass) {
      slide.classList.remove('swiper-slide--dynamic', 'swiper-slide--media');
      slide.classList.add(slideClass);
    }

    const imgElement = slide.querySelector('.pm__product-slider-image');
    const imagePosition = mediaItem.position;
    const mediaUrl = mediaItem.src;

    imgElement.parentElement.dataset.imagePosition = imagePosition;
    imgElement.src = mediaUrl;
    imgElement.dataset.originalSrc = mediaUrl;

    if (mediaItem.alt) imgElement.alt = mediaItem.alt;

    imgElement.onload = () => {
      imgElement.dataset.maxWidth = imgElement.naturalWidth;
      imgElement.dataset.maxHeight = imgElement.naturalHeight;
    };

    if (imagePosition <= 4) {
      slide.classList.remove('span-third');
      slide.classList.add('span-half');
    }

    return slide;
  }

  populateSwiper(images, videos, thumbImages, mediaBaseUrl = this.mediaJsonElem.dataset.url, productSwiper = this.productSwiper, productThumbSwiper = this.productThumbSwiper) {
    this.reinitializeMediaSwiper(productSwiper, productThumbSwiper);

    const videoTemplate = productSwiper?.querySelector('#video-template');
    const imageTemplate = productSwiper?.querySelector('#image-template');
    const thumbImageTemplate = productSwiper?.querySelector('#thumb-image-template');
    let firstVideoProcessed = false;
    
    // Remove dynamic slides
    this.removeMediaSlidesByClass(productSwiper, 'swiper-slide--dynamic');
    this.removeMediaSlidesByClass(productThumbSwiper, 'swiper-slide--dynamic');

    let imagePosition = -1;
    if (productSwiper) {
      const existingImageElements = productSwiper.querySelectorAll('[data-image-position]');
      imagePosition = existingImageElements.length ? existingImageElements.length - 1 : -1;
    }

    const addSlide = (fileName, isVideo = false) => {
      const mediaUrl = mediaBaseUrl + fileName;

      if (isVideo) {
        const videoTemplateContent = videoTemplate.content;

        if (!firstVideoProcessed) {
          var link = videoTemplateContent.querySelector('link');

          if (link) {
            document.head.appendChild(link);
          }

          firstVideoProcessed = true;
        }

        const mainSlide = videoTemplateContent.querySelector('.swiper-slide');

        const randomId = Math.random().toString(36).substring(2, 10);

        const videoComponentSettings = mainSlide.querySelector('video-component');
        let sectionSettings = videoComponentSettings.getAttribute('data-section-settings');
        sectionSettings = sectionSettings.replace(/random_id/g, randomId);
        sectionSettings = sectionSettings.replace(/video_url/g, mediaUrl);
        videoComponentSettings.setAttribute('data-section-settings', sectionSettings);

        const insideTemplate = videoTemplateContent.querySelector('template').content;
        const videoElement = insideTemplate.querySelector('.video-js');
        videoElement.id = videoElement.id.replace('random_id', randomId);

        this.appendSlideItem(mainSlide.cloneNode(true), productSwiper);
        
        const baseFileName = fileName.split('.').slice(0, -1).join('.');
        const matchingThumb = thumbImages.find(thumb => {
          const thumbBaseName = thumb.split('.').slice(0, -1).join('.').replace('-thumb', '');
          return thumbBaseName === baseFileName;
        });

        if (matchingThumb) {
          const thumbUrl = mediaBaseUrl + matchingThumb;
          const thumbTemplateContent = thumbImageTemplate.content;
          const thumbSlide = thumbTemplateContent.querySelector('.swiper-slide').cloneNode(true);
          const thumbImg = thumbSlide.querySelector('.pm__thumb-image');
          thumbImg.src = thumbUrl;
          thumbImg.setAttribute('aria-hidden', 'true');
          thumbImg.onload = () => {
            thumbImg.setAttribute('aria-hidden', 'false');
          };

          this.appendSlideItem(thumbSlide, productThumbSwiper);
        } else {
          const thumbTemplateContent = thumbImageTemplate.content;
          const thumbSlide = thumbTemplateContent.querySelector('.swiper-slide').cloneNode(true);
          thumbSlide.querySelector('.pm__thumb-image').remove();

          const svg = '<svg viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" data-name="video-icon" id="video-icon"><title/><path d="M64,128a64,64,0,1,1,64-64A64.07,64.07,0,0,1,64,128ZM64,4a60,60,0,1,0,60,60A60.07,60.07,0,0,0,64,4Z"/><path d="M42,97a2,2,0,0,1-2-2V33a2,2,0,0,1,3-1.74l55.11,31a2,2,0,0,1,0,3.48L43,96.74A2,2,0,0,1,42,97Zm2-60.58V91.58L93,64Z"/></svg>';
          thumbSlide.innerHTML = svg;

          this.appendSlideItem(thumbSlide, productThumbSwiper);
        }
      } else {
        if (thumbImageTemplate) {
          const thumbTemplateContent = thumbImageTemplate.content;
          const thumbSlide = thumbTemplateContent.querySelector('.swiper-slide').cloneNode(true);

          const thumbImg = thumbSlide.querySelector('.pm__thumb-image');
          thumbImg.src = mediaUrl;

          thumbImg.setAttribute('aria-hidden', 'true');
          thumbImg.onload = () => {
            thumbImg.setAttribute('aria-hidden', 'false');
          };

          this.appendSlideItem(thumbSlide, productThumbSwiper);
        }

        if (imageTemplate) {
          const mainSlide = this.createMediaSlide(imageTemplate, { src: mediaUrl, position: imagePosition++ });
          this.appendSlideItem(mainSlide, productSwiper);
        }
      }
    }

    images.forEach(imageFilename => {
      addSlide(imageFilename);
    });

    videos.forEach(videoFilename => {
      addSlide(videoFilename, true);
    });

    if (productThumbSwiper && productThumbSwiper.swiper) {
      productThumbSwiper.swiper.update();
    }

    if (productSwiper && productSwiper.swiper) {
      productSwiper.swiper.update();
    }
  }

  appendSlideItem(slideItem, productSwiper = this.productSwiper) {
    if (productSwiper?.swiper) {
      productSwiper?.swiper?.appendSlide(slideItem);
    } else {
      const productSwiperWrapper = productSwiper?.querySelector('.swiper-wrapper');
      if (productSwiperWrapper) {
        productSwiperWrapper.appendChild(slideItem);
      }
    }
  }

  sortMediaArray(mediaArray) {
    return mediaArray.sort((a, b) => {
      const aComponents = a.split('-');
      const bComponents = b.split('-');

      // Compare base parts
      const baseComparison = aComponents[0].localeCompare(bComponents[0]);
      if (baseComparison !== 0) return baseComparison;

      // Compare thumb vs non-thumb
      const aHasThumb = a.includes("-thumb");
      const bHasThumb = b.includes("-thumb");
      if (aHasThumb !== bHasThumb) return aHasThumb ? 1 : -1;

      // Extract numeric parts based on format
      const aNumStr = aHasThumb ? (aComponents[2]?.split('.')[0] || '0') : (aComponents[1]?.split('.')[0] || '0');
      const bNumStr = bHasThumb ? (bComponents[2]?.split('.')[0] || '0') : (bComponents[1]?.split('.')[0] || '0');

      // Compare numeric parts
      return parseInt(aNumStr, 10) - parseInt(bNumStr, 10);
    });
  }

  sendVariantGTMEvent() {
    document.dispatchEvent(
      new CustomEvent("variant:changed:gtm", {
        bubbles: true,
        detail: {
          title: selectedVariant?.title,
          sku: selectedVariant?.sku,
          price: selectedVariant?.price,
        }
      })
    );
  }

  updateStickyDetails() {
    this.productModule.setStickyContent();
  }

  toggleInputs() {
    this.inputMap.forEach(({ element, customIds }) => {
      if (customIds.includes(selectedVariant?.id)) {
        element.parentElement.setAttribute('aria-hidden', 'false');
        element.parentElement.querySelectorAll('.pm__property-input-hidden').forEach(input => input.disabled = false);
      } else {
        element.parentElement.setAttribute('aria-hidden', 'true');
        element.parentElement.querySelectorAll('.pm__property-input-hidden').forEach(input => input.disabled = true);
      }
    });
  }

  updatePrices() {

    if (!this.priceContainer) return;

    this.saleLabel = this.priceContainer.querySelector('.pm__sale-label');
    this.comparePrice = this.priceContainer.querySelector('.pm__compare-price');
    this.realPrice = this.priceContainer.querySelector('.pm__regular-price');
    this.lowestPrice = this.priceContainer.querySelector('.pm__lowest-price');    

    if (selectedVariant?.compare_at_price) {
      const comparePrice = Shopify.formatMoney(selectedVariant?.compare_at_price, window.theme.moneyFormat);
      this.comparePrice.textContent = comparePrice;
      this.comparePrice.setAttribute('aria-hidden', 'false');
      this.saleLabel.setAttribute('aria-hidden', 'false');
    } else {
      this.comparePrice.setAttribute('aria-hidden', 'true');
      this.saleLabel.setAttribute('aria-hidden', 'true');
    }

    const realPrice = Shopify.formatMoney(selectedVariant?.price, window.theme.moneyFormat);
    this.realPrice.textContent = realPrice;

    const lowestPrices = this.lowestPrice.dataset.lowestPrices;
    if (!lowestPrices || lowestPrices.trim() === '') return;

    const lowestPrice = JSON.parse(lowestPrices)[selectedVariant?.id];
    if (lowestPrice) {
      this.lowestPrice.querySelector('span').textContent = Shopify.formatMoney(lowestPrice, window.theme.moneyFormat);
      this.lowestPrice.setAttribute('aria-hidden', 'false');
    } else {
      this.lowestPrice.setAttribute('aria-hidden', 'true');
    }
  }

  productIndicator() {
    if (!this.futureTime) return;
    if (!this.indicatorString) return;

    const parent = this.indicatorString.closest('.pm__indicator');

    const variant = this.futureTime[selectedVariant?.id];
    if (variant) {
      if (variant.show_delivery) {
        document.querySelectorAll('.production-time').forEach(span => span.style.display = 'none');
        document.querySelectorAll('.delivery-time').forEach(span => span.style.display = '');
        parent.classList.add('delivery');

        if (variant.in_stock) {
          this.indicatorString.textContent = window.variantStrings.inStock;
          parent.classList.add('green');
          parent.classList.remove('gray');
        } else {
          this.indicatorString.textContent = window.variantStrings.outOfStock;
          parent.classList.add('gray');
          parent.classList.remove('green');
        }
      } else {
        document.querySelectorAll('.delivery-time').forEach(span => span.style.display = 'none');
        document.querySelectorAll('.production-time').forEach(span => span.style.display = '');
        parent.classList.remove('green');
        parent.classList.remove('delivery');
        parent.classList.add('gray');
      }
    }
  }

  updateOptions(options=[]) {
    if (Array.isArray(options) && options.length > 0) {
      // Force set options
      this.options = options;
      return null;
    }

    // this is where they set options to get the value
    this.options = Array.from(
      document.querySelectorAll(
        '.pm__option-selector:not(.not-variant, [aria-hidden="true"]) .pm__option-input:checked'
      ),
      (select) => {
        const forceValue = select.getAttribute('data-force-value') || null;
        const variantOptionName = select.getAttribute('data-variant-option-name') || null;
        const optionName = forceValue ?? variantOptionName;

        if(optionName) {
          return optionName;
        }

        return select.value
      }
    );
  }

  areEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return arr1.every((element) => arr2.includes(element));
    }

    const count = {};
    for (let val of arr1) {
      count[val] = (count[val] || 0) + 1;
    }

    for (let val of arr2) {
      if (!count[val]) return false;
      count[val]--;
    }

    return true;
  };

  areArraysEqual(arrayOne, arrayTwo) {
    if (arrayOne.length !== arrayTwo.length) {
      return arrayOne.every((element) => arrayTwo.includes(element));
    }

    const sortedArrayOne = arrayOne.slice().sort();
    const sortedArrayTwo = arrayTwo.slice().sort();

    return sortedArrayOne.every(
      (value, index) => value === sortedArrayTwo[index]
    );
  }

  normalizeOption(value) {
    return value
      .toLowerCase()
      .replace(/\s+/g, ' ') // collapse multiple spaces
      .trim();
  }

  handleize(str) {
    return str
      .toLowerCase()
      .normalize('NFD') // Decompose combined characters (e.g., 'é' to 'e' + accent)
      .replace(/[\u0300-\u036f]/g, '') // Remove the separated accent marks
      .replace(/[^a-z0-9 -]/g, '') // Remove all non-alphanumeric characters except spaces and hyphens
      .trim() // Remove leading/trailing whitespace
      .replace(/\s+/g, '-') // Replace one or more spaces with a single hyphen
      .replace(/-+/g, '-'); // Replace multiple hyphens with a single hyphen
  }

  updateConnectedProductData(targetEl) {
    const optionValue = this.handleize(targetEl.dataset?.optionValue);

    // Find the media JSON element for the selected variant or fallback to default
    const mediaJsonElement = document.querySelector(`#media-json-${optionValue}`) || this.productSwiper.querySelector("#media-json");
    if (mediaJsonElement) {
      this.mediaJsonElem = mediaJsonElement;
      this.mediaJson = JSON.parse(mediaJsonElement.textContent);
    }

    // Find the product data element for the selected option
    const productDataEl = document.querySelector(`[data-variant="${optionValue}"]`);
    if (productDataEl) {
      const parsedProductData = JSON.parse(productDataEl.textContent);
      this.productData = Array.isArray(parsedProductData) ? parsedProductData[0] : parsedProductData;
    
      if (this.productData?.variants) {
        this.variantData = this.productData.variants;
      }
    }
  }

  updateMasterId() {
    const normalizedSelectedOptions = this.options.map(opt =>
      opt ? this.normalizeOption(opt) : ''
    );

    selectedVariant = this.getVariantData().find((variant) => {
      const normalizedVariantOptions = variant.options.map(opt =>
        opt ? this.normalizeOption(opt) : ''
      );

       if (this.areEqual(normalizedSelectedOptions, normalizedVariantOptions)) {
         return true;
       }
    });

    if(document.querySelector('[data-current-sku]')) {
      const currentSkuField = document.querySelector('[data-current-sku]');
      const appendCurrentVariantData = `
            <div data-sv-title>${selectedVariant?.title}</div>
            <div data-sv-sku>${selectedVariant?.sku}</div>
            <div data-sv-public-title>${selectedVariant?.public_title}</div>
          `;

      currentSkuField.innerHTML = appendCurrentVariantData;
    }
   
    // if no variant is found, avoid errors downstream
    if (!selectedVariant) {
      console.warn('No matching variant found for options:', this.options);
      return;
    }
  
    const canvasId = this.findCanvasId();
    if (canvasId) this.renderViewer(canvasId, true);
  }

  updateFeaturedMedia() {
    const product = this.productData;

    if (!product) return;

    const imageTemplate = this.productSwiper.querySelector('#image-template');

    const swiperWrapper = this.productSwiper.querySelector('.swiper-wrapper');
    if (!swiperWrapper || !product?.media) return;
  
    // Remove all slides with class 'swiper-slide--media'
    this.removeMediaSlidesByClass(swiperWrapper, 'swiper-slide--media');
    this.removeMediaSlidesByClass(this.productSwiper, 'swiper-slide--dynamic');
    this.removeMediaSlidesByClass(this.productThumbSwiper, 'swiper-slide--dynamic');
  
    product.media.forEach(mediaItem => {
      const slide = this.createMediaSlide(imageTemplate, mediaItem, 'swiper-slide--media');
      this.appendSlideItem(slide);
    });
  }
  

  updateFeaturedImage() {
    if (!selectedVariant) return;
    if (!selectedVariant?.featured_media) return;

    const newMedia = selectedVariant?.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {    
    if (!selectedVariant) return;

    const url = new URL(window.location);

    url.searchParams.set("variant", selectedVariant?.id);
    window.history.replaceState({}, "", url.toString());
  }

  updateVariantInput(newId = selectedVariant?.id) {
    const productForms = document.querySelectorAll('.pm__atc-form');
    productForms.forEach(form => {
      const input = form.querySelector('input[name="id"][data-original]');
      input.value = newId;
      input.dataset.id = newId;
    })
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelectorAll('.pm__atc-button--main'),
      addButtonInner = document.querySelectorAll(
        '.pm__atc-button--main .ButtonText'
      ),
      buyPriceElements = document.querySelectorAll('.js-buy-price'),
      atcPriceElements = document.querySelectorAll('.js-atc-price'),
      quantityEl = document.querySelector('.pm__quantity-input'),
      altButtons = document.querySelectorAll('.pm__alt-atc-button');

    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (selectedVariant?.available == false) {
      addButton.forEach(button => button.setAttribute("disabled", "disabled"));
      addButtonInner.forEach((btn) => {
        btn.innerHTML = window.variantStrings.soldOut;
      });
      altButtons.forEach(button => button.setAttribute("disabled", ""));
    } else {
      altButtons.forEach(button => button.removeAttribute("disabled"));
      addButton.forEach(button => button.removeAttribute("disabled"));
      if (window.variantInfo && window.variantInfo.show_price) {
        var priceElement =
          "<span class='pm__atc-price u-pb1' data-la-dn-price> - " +
          Shopify.formatMoney(
            selectedVariant?.price * quantity,
            window.theme.moneyFormat
          ) +
          "</span>";
      } else {
        var priceElement = "";
      }

     addButtonInner?.forEach((btn) => {
        const isBuyButton = btn.getAttribute('data-buy-button') === 'true';
        if (isBuyButton) {
          btn.innerHTML = window.variantStrings.addToCartRichText + priceElement;
        } else {
          btn.innerHTML = window.variantStrings.addToCart + priceElement;
        }
      });
    }
  }

  togglePriceEl(){
    let priceElements = document.querySelectorAll('.pm__regular-price');
    priceElements.forEach((priceEl) => {
      priceEl.textContent = Shopify.formatMoney(
        selectedVariant?.price,
        window.theme.moneyFormat
      );
    })

    let comparePrices = document.querySelectorAll('.pm__compare-price');
    comparePrices.forEach((comparePrice) => {
      if(selectedVariant?.compare_at_price > 0){
        comparePrice.textContent = Shopify.formatMoney(
        selectedVariant?.compare_at_price,
        window.theme.moneyFormat
        ); 
      } else {
        comparePrice.textContent = '';
      }
      
    })
  }

  getVariantData(variants=[]) {
    if (variants.length > 0) {
      this.variantData = variants;
    } else if (!this.variantData) {
      this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }

    return this.variantData;
  }



}
customElements.define("variant-selects", VariantSelects);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    new AddToCart(this.element);

    this.searchInputElement = this.element.querySelector('[name="q"]');

    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector('.search-input__clear');
    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    this.headerTransparent = false;
    this.carouselElements = this.element.querySelectorAll(".search-swiper");
    if (this.carouselElements) {
      this.carouselElements.forEach((carouselElement) => {
        this.carousel = new RevolutionSwiper(carouselElement);
      })
    }
    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.element.classList.remove("Drawer--wrapper", "Drawer--Left");
    }

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.element.querySelector('.search-header').offsetHeight + 48}px`
    );


    this.bindEvents();
  }


  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
    this.delegateBody.on("keydown", onEscape(this.closeSearch.bind(this)));

  }

  initCarousel() {
    const carousel = this.searchResultsElement.querySelector(
      "[data-swiper-settings]"
    );
    if (carousel) {
      this.newCarousel = new RevolutionSwiper(carousel);
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    event.preventDefault();


    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch();
      return;
    }


    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );
    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    // Check if search element exists
    if (!this.element) {
      console.error('Search element not found');
      return;
    }

    this.element.style.display = "block";

    // Show search element and page overlay
    requestAnimationFrame(() => {
      const search = document.querySelector("#quickSearch");
      if (search) {
        search.setAttribute("aria-hidden", false);
        search.setAttribute("aria-expanded", true);
      }
    });


    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.pageOverlayElement.style.top = 'calc(var(--header-dynamic-height) + var(--announcement-dynamic-height))';
    }
    this.pageOverlayElement.classList.add("is-visible");

    // Disable scrolling on body
    bodyScrollLock.disableBodyScroll(
      this.element.querySelector('[data-scrollable]'),
      bodyScrollLockOptions
    );
    document.body.classList.add("scrollLock");


    // Focus on search input element after delay
    setTimeout(() => {
      if (this.searchInputElement) {
        this.searchInputElement.focus();
      }
    }, 200);


    if (document.querySelector('.Header--Transparent')) {
      setTimeout(() => {
        const header = document.body.querySelector("#header");
        if (header) {
          header.classList.remove("Header--Transparent");
        }
      }, 15);
      this.headerTransparent = true;
    }


    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
  }

  closeSearch() {
    event.preventDefault();

    if (!this.isOpen) {
      return;
    }

    this.element.setAttribute('aria-hidden', true);
    this.element.setAttribute('aria-expanded', false);

    this.handleSearchCloseBinder = this.handleSearchClose.bind(this);
    this.element.addEventListener('transitionend', this.handleSearchCloseBinder);

    this.pageOverlayElement.classList.remove("is-visible");

    this.isOpen = false;
  }

  handleSearchClose(e) {

    if (this.headerTransparent && this.headerTransparent) {
      document.body
        .querySelector("#header")
        .classList.add("Header--Transparent");
    }

    if (e.propertyName === 'opacity') {
      document.body.classList.remove("scrollLock");
      bodyScrollLock.enableBodyScroll(this.element.querySelector('[data-scrollable]'), bodyScrollLockOptions);
      this.element.style.display = 'none';
      if (responsive.matchesBreakpoint('lap_and_up')) {
        this.pageOverlayElement.removeAttribute('style');
      }
      this.element.removeEventListener('transitionend', this.handleSearchCloseBinder);
    }
  }



  async onInput(event) {
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target?.value || "";
    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute('aria-hidden', 'false');

    if (event.target.getAttribute("data-value") && this.lastInputValue === "") {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".searchInput");

      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
    } else {
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        this.getRecentSearches();
        return;
      }
    }

    try {
      const response = await fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.lastInputValue)}&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,tag,body,author,vendor,variants.sku&section_id=search-predictive`);

      if (!response.ok) {
        throw new Error(response.status);

      }

      const text = await response.text();
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-predictive').innerHTML;

      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      const div = document.createElement('div');
      div.innerHTML = resultsMarkup;

      const suggestedQueries = div.querySelector('template');
      const currentSuggestedQueries = this.element.querySelector('.search__predictive-query');
      const currentRecentQueris = this.element.querySelector('.search--recentResults');


      this.searchResultsElement.innerHTML = resultsMarkup;
      
      this.initCarousel();

      if (suggestedQueries) {
        if (currentRecentQueris) {
          currentRecentQueris.innerHTML = '';
        }

        if (currentSuggestedQueries) {
          currentSuggestedQueries.innerHTML = '';
        }
        this.element.querySelector(
          ".search--recentResults"
        ).innerHTML = suggestedQueries
          .content.firstElementChild.innerHTML;
        this.updateCarousel();
      } else {
        this.getRecentSearches();
      }


      this.searchResultsElement.style.opacity = 1;

      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }
    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }

      throw error;
    }

  }

  updateCarousel() {
    const querySwiper = this.element.querySelector("#predictive-search__recent-searches");
    if (querySwiper) {
      new RevolutionSwiper(querySwiper);
    }
  }

  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    const currentSuggestedQueries = this.element.querySelector('.predictiveSearch--queries');
    if (currentSuggestedQueries) currentSuggestedQueries.remove();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");


    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
    setTimeout(() => {
      if (this.searchInputElement) {
        this.searchInputElement.focus();
      }
    }, 200);
    this.clearSearchButton.setAttribute('aria-hidden', 'true');
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) { }
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let elementToAdd = this.element.querySelector(
      ".search--recentResults"
    );
    if (items.length > 0) {
      items.forEach((id) => {
        appendString =
          appendString +
          "<div role='option' tabIndex='0' class='recent-search__item u-p4 swiper-slide' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</div>";
      });

      elementToAdd.innerHTML = appendString;
      this.updateCarousel();
    } else if (this.querySelector('#predictive-search__recent-searches')) {
      this.querySelector('#predictive-search__recent-searches').style.display = "none";
    }
  }

}
customElements.define("search-bar", SearchBar);

class TermsAndConditions extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.stickyLinksTopPadding = this.stickyLinksTopPadding.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if (!isMobile) document.addEventListener("scroll", this.stickyLinksTopPadding);
    document.documentElement.style.setProperty(
      "--tc_menu-height-fixed",
      document.querySelector(".tc__menu-button").offsetHeight + "px"
    );
  }

  stickyLinksTopPadding() {
    const linkList = this.element.querySelector(".tc-layout-wrapper__linklist");
    if (linkList) {
      const isSticky = linkList.getBoundingClientRect().top === 0;

      if (isSticky) {
        linkList.style.paddingTop = "1.5rem";
      } else {
        linkList.style.paddingTop = "0rem";
      }
    }
  }
}

customElements.define("terms-and-conditions", TermsAndConditions);


class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

  }


  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }

  }
}

customElements.define("contact-section", ContactSection);




class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    if (!this.hasAttribute("available")) return;
    this.fetchAvailability(this.dataset.variantId);
  }

  fetchAvailability(variantId) {
    const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=helper-pickup`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector(".shopify-section");
        this.renderPreview(sectionInnerHTML);
      })
      .catch((e) => {
        this.renderError();
      });
  }

  renderError() { }

  renderPreview(sectionInnerHTML) {
    this.element.innerHTML = "";

    this.element.appendChild(
      sectionInnerHTML.querySelector(".LocalPickup_--Wrapper")
    );
    if (sectionInnerHTML.querySelector("#LocalPickup")) {
      this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
      new Drawer(this.element.querySelector("#LocalPickup"));
    }
  }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.textarea = this.element.querySelector("textarea");
    this.button = this.element.querySelector(".CartNote--Submit");
    this.noteSucess = this.element.querySelector(".cartNote--Success");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action='update-note']",
      this.updateNote.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action='edit-note']",
      this.editNote.bind(this)
    );
  }
  editNote() {
    this.textarea.removeAttribute("disabled");
    this.button.innerText = window.cartStrings.enter_note;
    this.button.setAttribute("data-action", "update-note");
    this.textarea.focus();
    this.noteSucess.style.visibility = "hidden";
    this.noteSucess.style.opacity = "0";
  }

  updateNote() {
    var _this = this;
    this.value = this.textarea.value;

    fetch(window.routes.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify({ note: this.value }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (_this.value == "") {
          return;
        }
        _this.textarea.setAttribute("disabled", "disabled");
        _this.button.innerText = window.cartStrings.note_change;
        _this.button.setAttribute("data-action", "edit-note");
        _this.noteSucess.style.visibility = "visible";
        _this.noteSucess.style.opacity = "1";
      }
    });
  }
}

customElements.define("cart-note", CartNote);


class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }

    if (window.location.href.indexOf("customer_posted=true#popupForm") > -1) {
      this.options.delay = 0;
      this.openNewsletter();
      sessionStorage.setItem('newsletter-success', 'true');
    }
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;
    if (this.options.scroll_amount > 0) {
      this.myScrollListener = scrollListener.addScrollListener(this, this.scrollListener);
    } else {
      this.openNewsletter();
    }

  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  onTransitionEnd(event) {
    if (event.propertyName === "right") {
      if (this.element.getAttribute("aria-hidden") === "true") {
        setTimeout(() => {
          this.element.style.display = "none";
          document.body.classList.remove("scrollLock");
          this.pageOverlayElement.classList.remove("is-visible");
          bodyScrollLock.enableBodyScroll(this.element);

          this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);
          this.element.removeEventListener("transitionend", this.onTransitionEnd.bind(this));
        }, 50);
      }
    }
  }

  openNewsletter() {
    if (sessionStorage.getItem('newsletter-success') === 'true' && !this.options.edit_mode) return;
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }

    setTimeout(() => {
      this.element.style.display = "block";

      requestAnimationFrame(() => {
        this.element.setAttribute("aria-hidden", "false");
      });

      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    this.element.addEventListener("transitionend", this.onTransitionEnd.bind(this));
    this.element.setAttribute("aria-hidden", true);

    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
  };
}

customElements.define("newsletter-popup", NewsletterPopup);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);


  }

  connectedCallback() {
    this.drawer = new Drawer(this.element.querySelector("#accountDrawer"), {
      onOpen: () => {
        const inputToFocus = this.element.querySelector("[aria-visible='true'] .input-placeholder--first");
        if (inputToFocus) {
          inputToFocus.setAttribute("readonly", "readonly");
          inputToFocus.focus();
          inputToFocus.removeAttribute("readonly");
        }
      }
    });

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on("click", '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on("click", '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on("click", '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on("click", '[data-action="submit-recovery"]', this.accountRecover.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-login"]', this.accountInputSubmit.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-reg"]', this.accountInputSubmitReg.bind(this));
    this.delegateElement.on("keypress", '[data-action="submit-input-forgot-pass"]', this.accountInputSubmitForgot.bind(this));
  }

  accountInputSubmit(e) {
    if (e.key === "Enter") this.submitLogin(e);
  }

  accountInputSubmitReg(e) {
    if (e.key === "Enter") this.submitRegistration(e);
  }

  accountInputSubmitForgot(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.accountRecover(e);
    }
  }

  async accountRecover(event) {
    event.preventDefault();
    const recoverEndpoint = `${window.routes.localeRootUrl}/account/recover`;
    const requestBody = {
      email: this.element.querySelector("#RecoverEmail").value,
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loader = event.target.closest("form").querySelector(".itemLoader");
    loader.classList.add("is-visible");

    try {
      const response = await fetch(recoverEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = responseText;
      const recoverError = this.element.querySelector("#recover_form .drawer__errors");
      const recoverSuccess = this.element.querySelector("#recover_form .account__form-success-msg");
      if (responseText.includes("account__recover-email-error")) {

        recoverSuccess.classList.remove("is-visible");
        recoverError.innerHTML = "";
        recoverError.innerHTML = tempDiv.querySelector("#account__recover-email-error").innerHTML;
        recoverError.classList.add("is-visible");
      } else if (responseText.includes("account__form-success-msg")) {

        recoverError.classList.remove("is-visible");
        recoverSuccess.innerHTML = "";
        recoverSuccess.innerHTML = tempDiv.querySelector("#account__form-success-msg").innerHTML;
        recoverSuccess.classList.add("is-visible");


      }

      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the recovery request:", error);
    }
  }

  async submitRegistration(event) {
    event.preventDefault();
    const registrationEndpoint = `${window.routes.localeRootUrl}/account`;
    const requestBody = {
      customer: {
        first_name: this.element.querySelector("#RegisterForm-FirstName").value,
        last_name: this.element.querySelector("#RegisterForm-LastName").value,
        email: this.element.querySelector("#RegisterForm-email").value,
        password: this.element.querySelector("#RegisterForm-password").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loader = event.target.closest("form").querySelector(".itemLoader");

    loader.classList.add("is-visible");

    try {
      const response = await fetch(registrationEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();
      const registerEmailError = this.element.querySelector("#RegisterForm-email-error");
      const registerPasswordError = this.element.querySelector("#RegisterForm-password-error");
      const generalError = this.element.querySelector('#register .drawer__errors');

      if (responseText.indexOf("registerErrors") !== -1) {
        console.error("Error occurred during registration.");
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;

        const emailErrorElement = tempDiv.querySelector("#RegisterForm-email-error");

        if (emailErrorElement) {

          registerEmailError.setAttribute("aria-hidden", "false");
          registerEmailError.innerHTML = "";

          registerEmailError.innerHTML = emailErrorElement.innerHTML;
          this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "true");
        } else {
          this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "false");
          registerEmailError.setAttribute("aria-hidden", "true");
        }

        const passwordErrorElement = tempDiv.querySelector("#RegisterForm-password-error");
        if (passwordErrorElement) {
          registerPasswordError.setAttribute("aria-hidden", "false");
          registerPasswordError.style.display = "block";
          registerPasswordError.innerHTML = "";
          registerPasswordError.innerHTML = tempDiv.querySelector("#RegisterForm-password-error").innerHTML;
          this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "true");
        } else {
          registerPasswordError.setAttribute("aria-hidden", "true");
          this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "false");
        }

        const generalErrorNew = tempDiv.querySelector("#account__register-email-error");
        if (generalErrorNew) {

          generalError.setAttribute("aria-hidden", "false");
          generalError.style.display = "block";
          generalError.innerHTML = "";
          generalError.innerHTML = generalErrorNew.innerHTML;
        }

      } else {
        registerPasswordError.setAttribute("aria-hidden", "true");
        this.element.querySelector("#RegisterForm-email").setAttribute("aria-invalid", "false");
        this.element.querySelector("#RegisterForm-password").setAttribute("aria-invalid", "false");
        registerEmailError.setAttribute("aria-hidden", "true");
        location.href = window.routes.account_url;
      }

      loader.classList.remove("is-visible");

    } catch (error) {
      console.error("An error occurred during the registration request:", error);
    }
  }

  async submitLogin(event) {
    event.preventDefault();
    const loginEndpoint = `${window.routes.localeRootUrl}/account/login`;
    const requestBody = {
      customer: {
        email: this.element.querySelector("#CustomerEmail").value,
        password: this.element.querySelector("#CustomerPassword").value,
      },
    };

    if (window.hcaptcha) {
      const captchaToken = await window.hcaptcha.execute(null, { async: true });
      requestBody["h-captcha-response"] = captchaToken.response;
    }

    const loader = event.target.closest("form").querySelector(".itemLoader");

    loader.classList.add("is-visible");

    try {
      const response = await fetch(loginEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const responseText = await response.text();

      if (responseText.includes("loginError")) {
        const loginError = this.element.querySelector("#login .drawer__errors");
        loginError.innerHTML = "";
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = responseText;
        loginError.innerHTML =
          tempDiv.querySelector(".AlertError").innerHTML;
        loginError.classList.add("is-visible");
      } else {
        location.href = window.routes.account_url;
      }

      loader.classList.remove("is-visible");
    } catch (error) {
      console.error("An error occurred during the login request:", error);
    }
  }

  toggleTab(event) {
    event.preventDefault();
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll(".accountDrawer--Tab");
    const allContent = this.element.querySelectorAll(".drawer__account-content");

    allTabs.forEach((tab) => tab.setAttribute("aria-expanded", "false"));
    allContent.forEach((content) => content.setAttribute("aria-visible", "false"));

    event.target.setAttribute("aria-expanded", "true");
    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute("aria-visible", "true");
    }
  }

  toggleRecovery(event) {
    event.preventDefault();
    const id = event.target.dataset.id;
    if (id === "recover") {
      this.element.querySelector("#recover_form").setAttribute("aria-visible", "true");
      this.element.querySelector("#login").setAttribute("aria-visible", "false");
      trapFocus(this.element.querySelector("#recover_form"));
    } else {
      this.element.querySelector("#recover_form").setAttribute("aria-visible", "false");
      this.element.querySelector("#login").setAttribute("aria-visible", "true");
      trapFocus(this.element.querySelector("#login"));
    }
  }
}

customElements.define("account-handler", AccountHandler);


let alreadyExits = false;
class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    if (!alreadyExits) {

      new Popup(this.element, true);
      alreadyExits = true;
    }
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class ArticleComments extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.articleWrapper = this.element.querySelector(".article-comments__main-container");
    this.showLessButton = this.element.querySelector(".article-comments__show-less-button");
    this.commentForm = this.element.querySelector("#comment_form");

    if (this.commentForm) {
      this.commentForm.addEventListener("submit", (event) => {
        this.customSubmit(event);
      });
    }

    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="load-more"]',
      this.loadMore.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="open-comment-form"]',
      this.openForm.bind(this)
    );

    this.delegateElement.on(
      "click",
      '[data-action="show-less"]',
      this.showLess.bind(this)
    );

    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );
  }

  toggleButton() {
    this.buttonState = true;

    var allRequiredFields = this.element.querySelectorAll("[data-state='required']");

    allRequiredFields.forEach((item) => {
      if (item.type === "checkbox" && !item.checked) {
        this.buttonState = false;
      } else if (item.type !== "checkbox" && item.value.trim() === "") {
        this.buttonState = false;
      }
    });

    if (this.buttonState === true) {
      this.element.querySelector(".article-comments__submit-button").removeAttribute("disabled");
    } else {
      this.element.querySelector(".article-comments__submit-button").setAttribute("disabled", true);
    }
  }

  loadMore(event, target) {
    event.preventDefault();
    const dataHref = target.getAttribute("data-href");

    if (!dataHref) {
      console.error("Data href attribute is missing.");
      return;
    }

    fetch(`${window.routes.localeRootUrl}${dataHref}`, {
      credentials: "same-origin",
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Network response was not ok: ${response.statusText}`
          );
        }
        return response.text();
      })
      .then((htmlData) => {
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(htmlData, "text/html");

        const newComments = htmlDocument.querySelectorAll(".article-comments__comment");

        const commentsContainer = this.element.querySelector(".article-comments__main-container");
        commentsContainer.append(...newComments);
        new RevolutionAnimation(this.element);

        const newLoadMoreElement = htmlDocument.querySelector("[data-href]");
        const currentLoadMoreElement = this.element.querySelector(
          ".article-comments__load-more-button"
        );

        if (newLoadMoreElement) {
          const newHref = newLoadMoreElement.dataset.href;
          if (currentLoadMoreElement) {
            currentLoadMoreElement.dataset.href = newHref;
            // Move the load more button to the end of the container         
            commentsContainer.appendChild(currentLoadMoreElement);
            commentsContainer.appendChild(this.showLessButton);
          }
        } else {
          currentLoadMoreElement?.remove();
          commentsContainer.appendChild(this.showLessButton);
          this.showLessButton.classList.remove('hidden');
        }
      })
      .catch((error) => {
        console.error("Failed to load more comments:", error);
      });
  }

  openForm(event) {
    event.preventDefault();
    this.commentForm.classList.remove('hidden');
    const formRect = this.commentForm.getBoundingClientRect();
    const scrollOffset = 100;

    window.scrollTo({
      top: formRect.top + window.scrollY - scrollOffset,
      behavior: 'smooth'
    });
  }


  customSubmit(event) {
    event.preventDefault();
    const titleInput = this.commentForm.querySelector('[name="comment[title]"]');
    const textarea = this.commentForm.querySelector('textarea');
    textarea.style.color = 'transparent';

    if (titleInput && textarea) {
      const titleValue = titleInput.value.trim();
      const existingText = textarea.value;

      textarea.value = `[title] ${titleValue} [title]\n\n${existingText}`;
    }
  }


  showLess(event, target) {
    event.preventDefault();
    const firstPageUrl = target.dataset.firstPageUrl;

    fetch(`${window.routes.localeRootUrl}${firstPageUrl}`, {
      credentials: "same-origin",
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Network response was not ok: ${response.statusText}`
          );
        }
        return response.text();
      })
      .then((htmlData) => {
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(htmlData, "text/html");

        const firstPageComments = htmlDocument.querySelectorAll(".article-comments__comment");
        const commentsContainer = this.element.querySelector(".article-comments__main-container");
        commentsContainer.querySelectorAll(".article-comments__comment").forEach(comment => comment.remove());
        commentsContainer.prepend(...firstPageComments);
        new RevolutionAnimation(this.element);
        this.showLessButton.classList.add('hidden');
        const loadMoreButton = htmlDocument.querySelector(".article-comments__load-more-button");
        if (loadMoreButton) {
          commentsContainer.appendChild(loadMoreButton);
        }

        const containerRect = this.element.getBoundingClientRect();
        const scrollOffset = 100;

        window.scrollTo({
          top: containerRect.top + window.scrollY - scrollOffset,
          behavior: 'smooth'
        });
      })
      .catch((error) => {
        console.error("Failed to load first page comments:", error);
      });
  }

}
customElements.define("article-comments", ArticleComments);
class InfiniteScroll {
  constructor(container, paginationElement, restoreState) {

    if (
      !document.querySelector(container) ||
      !document.querySelector(paginationElement)
    )
      return;


    this.containerSelector = container;
    this.paginationElementSelector = paginationElement;
    this.restoreState = restoreState;
    this.treshold = 650;
    this.domDelegate = new Delegate(document.body);
    this.mainContainer = document.querySelector(this.containerSelector);
    this.loadType = this.mainContainer.dataset.load;
    this.running = false;
    this.bindEvents();

    const pageAccessedByReload =
      (window.performance.navigation &&
        window.performance.navigation.type === 1) ||
      window.performance
        .getEntriesByType("navigation")
        .map((nav) => nav.type)
        .includes("reload");

    if (
      this.restoreState &&
      sessionStorage.getItem("pageState") > 1 &&
      window.location.href === sessionStorage.getItem("pageStateURL") &&
      !pageAccessedByReload
    ) {
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.initObserver();
    }
  }

  initObserver() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      observerOptions
    );
    this.observer.observe(this.mainContainer);
  }

  bindEvents() {
    this.handleClickBinder = this.handleClick.bind(this);
    this.handleScrollBinder = this.handleScroll.bind(this);



    if (this.restoreState) {
      window.addEventListener(
        "beforeunload",
        this.rememberCurrentState.bind(this)
      );
    }
  }

  rememberCurrentState() {
    const scrollPositionY = window.scrollY;
    const currentUrl = window.location.href;
    const currentPage = document.querySelector(this.paginationElementSelector)?.dataset.page;

    sessionStorage.setItem("pageState", currentPage);
    sessionStorage.setItem("pageStateURL", currentUrl);
    sessionStorage.setItem("pageStateScroll", scrollPositionY);
  }

  initialize() {
    if (this.loadType === "scroll") {
      this.scrollListener = scrollListener.addScrollListener(
        this,
        this.handleScrollBinder
      );
    } else {

      this.domDelegate.on(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  destroy() {
    if (this.loadType === "scroll") {
      this.scrollListener?.removeScrollListener();
    } else {
      this.domDelegate.off(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (this.running === false) {
          this.initialize();
          this.running = true;
        }
      } else {
        this.running = false;
        this.destroy();
      }
    });
  }

  handleScroll() {
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;

    const top =
      this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom =
      this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  handleClick(e) {
    e.preventDefault();
    e.target
      .closest("a")
      .querySelector(".itemLoader")
      .classList.add("is-visible");

    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );


    if (!this.paginationElement) return;
    this.nextPageLinkElement = this.paginationElement.querySelector("a");

    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;
      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];
    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem("pageState"));
      for (let i = 2; i <= limit; i++) {
        let url;

        // Build the URL based on the condition
        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(
          fetch(url, {
            credentials: "same-origin",
            method: "GET",
          })
        );
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(
        fetch(url, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    }

    return promises;
  }

  async renderData(promises, restoreContent) {


    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(
        responses.map((response) => response.text())
      );
      let isLastPromise = false;
      contents.forEach((content, index) => {
        isLastPromise = index === contents.length - 1;

        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error("Error fetching or parsing data:", error);
    }
  }

  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const contentToAdd = doc.querySelector(this.containerSelector);

    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (this.paginationElement) {
      this.paginationElement.remove();
    }

    this.mainContainer.insertAdjacentHTML("beforeend", contentToAdd.innerHTML);

    if (this.mainContainer.classList.contains('blog__article-wrapper')) {
      const articleContents = this.mainContainer.querySelectorAll('.blog__article-content');
      if (articleContents) {
        articleContents.forEach(content => {
          const lineHeight = parseFloat(window.getComputedStyle(content).lineHeight);
          const elementHeight = content.clientHeight;
          if (lineHeight && elementHeight && Math.round(elementHeight / lineHeight) === 3) {
            content.classList.add('has-overflow');
          }
        });
      }
    }

    if (lastPromise) {
      this.initialize();
    }

    if (lastPromise && restoreContent) {
      this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );

  }

  restoreScroll() {
    const scrollPosition = parseInt(sessionStorage.getItem("pageStateScroll"));

    if (scrollPosition) {
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }
}

class BlogSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    new InfiniteScroll('#blog__articles-wrapper', '#infinite-scroll', this.element.dataset.search === 'true' ? false : true);
  }
}

customElements.define("blog-section", BlogSection);

class UspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.placeholderImages = this.querySelectorAll(".usp-block .image__container");

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const swiper = this.element.querySelector(".usp-section__swiper");
      if (!swiper.classList.contains("usp-section__grid-view") && responsive.matchesBreakpoint('pocket')) {
        new RevolutionSwiper(swiper);
       // this.scrollbarResize();
      }
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }


  connectedCallback() {
    this.placeholderImages.forEach((placeholder) => {
      let shouldRemove = false; // Flag to track if we should remove the parent

      // Loop through each child
      Array.from(placeholder.children).forEach(child => {
        if (child.classList.contains("image__placeholder")) {
          shouldRemove = true;
        }
      });

      // If any child had the class, remove the parent element
      if (shouldRemove) {
        placeholder.remove();
      }
    });


  }



}

customElements.define("usp-section", UspSection);

class faqSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.searchInput = this.element.querySelector(".faq--search");
    this.termsBlocks = document.querySelectorAll(".faq__block");
    this.noResultsElement = document.querySelector("#faq__results--none");
    this.tabElement = this.element.querySelector('[data-action="handle-tab-click"]');
    this.bindEvents();
    
    document.documentElement.style.setProperty(
      "--faq_menu-height-fixed",
      44+ "px"
    );
  

    if(this.tabElement){
      this.tabElement.classList.add('is-active');
    }


    this.initializeTabs();
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleStickyScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  bindEvents() {
    this.onInputListener = debounce(this.handleSearch.bind(this), 350);

    this.delegateElement.on("click", '[data-action="handle-tab-click"]', this.handleTabClick.bind(this));
    this.handleScrollListener = this.handleScroll.bind(this);
    scrollListener.addScrollListener(this, this.handleScrollListener);

    this.delegateElement.on(
      "keyup",
      '[data-action="search-string"]',
      this.onInputListener
    );

    this.delegateElement.on("click", '.faq-search[data-action="toggle-dropdown"]', this.handleClear.bind(this));


  }

  initializeTabs() {
    if (this.element.querySelector('.faq__block[aria-hidden="true"]')) {
      // We're in PDP mode, so initialize the first tab and block
      const firstTab = this.element.querySelector('.linklist--tab');
      const firstBlock = this.element.querySelector('.faq__block');
      
      if (firstTab && firstBlock) {
        firstTab.classList.add('is-active');
        firstBlock.setAttribute('aria-hidden','false');
      }
    }
  }
  handleStickyScroll(){
    const isIphone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
    if(!isIphone) return;

    const stickyTrigger = document.querySelector('.faq__menu-buttons');
    const targetToFix = document.querySelector('.faq-topic__dropdown-content');
    const targetToFix2 = document.querySelector('.faq-search__dropdown-content');

    const triggerRect = stickyTrigger.getBoundingClientRect();
   
  if (triggerRect.top <= 73 ) {
    targetToFix.classList.add('fixed');
    targetToFix2.classList.add('fixed');
  } else {
    targetToFix.classList.remove('fixed');
    targetToFix2.classList.remove('fixed');
  }
  }

  handleClear(){
    if(this.searchInput)
      this.searchInput.value = "";
  }



  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();
    const noResultsContainer = this.querySelector(".faq__no-results__terms");
    const isPdpMode = this.element.querySelector('.faq__block[aria-hidden="true"]') !== null;
  
    let hasMatch = false;
  
    this.termsBlocks.forEach((block) => {
      const headingElem = block.querySelector('.faq__block-header');
      let title = ''; // default fallback

      if (headingElem) {
        title = headingElem.textContent.toLowerCase();
      }

      const questions = block.querySelectorAll(".faq-section_content");
      let blockMatch = false;
      
      if (title && title.includes(searchTerm)) {
        // If the heading matches, display all content in this block
        if (isPdpMode) {
          block.setAttribute('aria-hidden','false');
        } else {
          block.classList.remove("is-hidden");
        }
        questions.forEach((content) => content.classList.remove("is-hidden"));
        blockMatch = true;
      } else {
        // If only `faq__block-content` matches
        questions.forEach((questionWrapper) => {
          const questionText = questionWrapper.textContent.toLowerCase();
          if (questionText.includes(searchTerm)) {
            questionWrapper.classList.remove("is-hidden");
            blockMatch = true;
          } else {
            questionWrapper.classList.add("is-hidden");
          }
        });
  
        // Show or hide the block based on matching content
        if (blockMatch) {
          if (isPdpMode) {
            block.setAttribute('aria-hidden','false');
          } else {
            block.classList.remove("is-hidden");
          }
        } else {
          if (isPdpMode) {
            block.setAttribute('aria-hidden', 'true');
          } else {
            block.classList.add("is-hidden");
          }
        }
      }
  
      if (blockMatch) hasMatch = true;
    });
  
    // Display 'no results' message if nothing matched and Reset visibility if search input is empty
    if (searchTerm === "" || !hasMatch) {
      // Reset question visibility for all blocks
      this.termsBlocks.forEach((block) => {
        block.querySelectorAll(".faq-section_content").forEach((content) =>
          content.classList.remove("is-hidden")
        );
      });
      
      if (isPdpMode) {
        if (searchTerm === "" || !hasMatch) {
          // Search is cleared in PDP mode - show only the first block
          this.termsBlocks.forEach((block, index) => {
            if (index === 0) {
              block.setAttribute('aria-hidden','false');
            } else {
              block.setAttribute('aria-hidden', 'true');
            }
          });
          
          // Reset tabs - activate only the first tab
          const allTabs = this.element.querySelectorAll(".linklist--tab");
          allTabs.forEach((tab, index) => {
            if (index === 0) {
              tab.classList.add("is-active");
            } else {
              tab.classList.remove("is-active");
            }
          });
        } else {
          // No results found in PDP mode - hide all blocks
          this.termsBlocks.forEach((block) => {
            block.setAttribute('aria-hidden', 'true');
          });
        }
      } else {
        // Regular mode - show all blocks
        this.termsBlocks.forEach((block) => {
          block.classList.remove("is-hidden");
        });
      }
      
      this.noResultsElement.classList.toggle("is-hidden", searchTerm === "" || hasMatch);
      noResultsContainer.textContent = `"${searchTerm}"`;
    } else {
      this.noResultsElement.classList.add("is-hidden");
      
      // In PDP mode, when showing search results, deactivate all tabs since we're showing multiple blocks
      if (isPdpMode) {
        const allTabs = this.element.querySelectorAll(".linklist--tab");
        allTabs.forEach(tab => tab.classList.remove("is-active"));
      }
    }
  }

  handleTabClick(event, target) {
    event.preventDefault();

    this.noResultsElement.classList.add("is-hidden");
  
    const targetId = target.getAttribute('href').substring(1);
    const isPdpMode = this.element.querySelector('.faq__block[aria-hidden="true"]') !== null;
  
    if (isPdpMode) {
      // PDP mode: show/hide blocks instead of scrolling
      const newUrl = `${window.location.pathname}#${targetId}`;
      history.pushState(null, null, newUrl);
  
      const otherTabs = this.element.querySelectorAll(".linklist--tab");
      const allBlocks = this.element.querySelectorAll(".faq__block");
      const targetElement = this.element.querySelector(`#${targetId}`);
  
      if (!target.classList.contains("is-active")) {
        // Remove active class from all tabs
        otherTabs.forEach(tab => {
          tab.classList.remove("is-active");
        });
  
        // Hide all blocks
        allBlocks.forEach(block => {
          block.setAttribute('aria-hidden', 'true');
        });
  
        // Activate clicked tab and show corresponding block
        target.classList.add("is-active");
        if (targetElement) {
          targetElement.setAttribute('aria-hidden','false');
       
        }
      }
    } else {
      // Original mode: scroll to section
      const newUrl = `${window.location.pathname}#${targetId}`;
      history.pushState(null, null, newUrl);
  
      const otherTabs = this.element.querySelectorAll(".linklist--tab");
      if (!target.classList.contains("is-active")) {
        otherTabs.forEach(tab => {
          tab.classList.remove("is-active");
        });
  
        target.classList.add("is-active");
      }
  
      const targetElement = this.element.querySelector(`#${targetId}`);
      if (targetElement) {
        this.scrollToSection(targetElement);
      }
    }
  }

  scrollToSection(targetElement) {
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height-fixed')) || 0;
    const offset = headerHeight + 20;
    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }

  // Method to handle click events
  handleClick(event) {
    this.element.dataset.clicked = "true";
    const allLinks = this.element.querySelectorAll(".linklist--tab");
    allLinks.forEach((item) => {
      item.classList.remove("is-active");
    });
    event.target.classList.add("is-active");
    setTimeout(() => {
      this.element.dataset.clicked = "false";
    }, 200);
  }

  // Method to remove all link highlights
  removeAllLinks() {
    const linkedItems = this.element.querySelectorAll(".is-active");
    linkedItems.forEach((item) => {
      item.classList.remove("is-active");
    });
  }

  // Method to initialize the scroll observer
  initObserver() {
    window.addEventListener("scroll", this.handleScrollListener);
  }

  // Method to handle scroll events
  handleScroll() {
    if (this.element.dataset.clicked == "true") return;
    const faqSubheaders = this.element.querySelectorAll(".faq__block--heading");
    const threshold = 200;

    faqSubheaders.forEach((faqSubheader) => {
      const distanceFromTop = Math.max(
        0,
        faqSubheader.getBoundingClientRect().top
      );
      if (distanceFromTop <= threshold && distanceFromTop > 0) {
        this.removeAllLinks();
        const faqSection = faqSubheader.closest(".faq__block").id;
        const anchorElements = this.element.querySelectorAll(
          `a[href="#${faqSection}"]`
        );

        anchorElements.forEach((item) => {
          item.classList.add("is-active");

        });
      }
    });
  }

}

customElements.define("faq-section", faqSection);


class productCard extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="link-click"]', this.goToPage.bind(this));

    this.element.addEventListener('focusin', () => {
      this.element.classList.add('is-focused');
    });

    this.element.addEventListener('focusout', () => {
      // Delay to allow focus to shift to another child
      setTimeout(() => {
        if (!this.element.contains(document.activeElement)) {
          this.element.classList.remove('is-focused');
        }
      }, 0);
    });
  }

  goToPage() {
    event.preventDefault();
    const url = event.target.dataset.href;
    window.location.href = url;
  }
}


customElements.define("product-card", productCard);

class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    new AddToCart(this.element);
    this.observer = null; // Intersection Observer instance
  }

  connectedCallback() {
    this.setupIntersectionObserver(); // Delay fetching data until user is near

    this.carouselElement = this.element.querySelector(".pc__carousels .swiper");
    this.carouselElementThumbs = this.element.querySelector(".pc__collections");
    if (this.carouselElement) {
      new RevolutionSwiper(this.carouselElement);
      this.carouselElement.swiper.update();
      new swiperSlider(this.carouselElement.swiper, this.carouselElement);
    }

    if (!this.dataset.recommendations && this.carouselElementThumbs) {
      new RevolutionSwiper(this.carouselElementThumbs);
    }
    this.bindEvents();
  }

  setupIntersectionObserver() {
    if (!("IntersectionObserver" in window)) {
      this.fetchDataOnView(); // Fallback for browsers without Intersection Observer
      return;
    }

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.fetchDataOnView();
          observer.disconnect(); // Stop observing after loading
        }
      });
    }, { rootMargin: "200px" }); // Start loading when user is ~200px near

    this.observer.observe(this.element);
  }

  fetchDataOnView() {
    if (this.dataset.recommendations === "true") {
      const recommendationsPromise = this.fetchData(this.dataset.url, '#recommendations .swiper-slide', 'recommendations');
      const recentPromise = this.fetchData(
        `${window.routes.localeRootUrl}/search?view=recently&type=product&q=${this.getRecentProductsQuery()}`,
        '.recent__item',
        'recent'
      );

      Promise.all([recommendationsPromise, recentPromise])
        .then(() => {
          this.element.style.visibility = 'visible';
        })
        .catch(error => {
          console.error("Error loading product recommendations or recent products:", error);
          this.element.style.visibility = 'visible'; // Ensure visibility even if fetch fails
        });
    } else {
      this.element.style.visibility = 'visible';
      document.dispatchEvent(new CustomEvent('update-favorites'));
    }
  }

  bindEvents() {
    this.delegateElement.on("click", "[data-action='toggle-tab']", this.toggleTab.bind(this));
  }

  async fetchData(url, selector, type) {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Error fetching data: ${response.status}`);
      const data = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const fetchedProducts = Array.from(doc.querySelectorAll(selector));

      this.appendContent(fetchedProducts, type);
    } catch (error) {
      console.error(`Failed to fetch data from ${url}:`, error);
    }
  }

  appendContent(products, type) {

    const container = this.element.querySelector(`#${type} .swiper-wrapper`);


    if (products.length > 0) {
      products.forEach(product => {
        container.appendChild(product);
      });
    } else {
      container.parentElement.remove();
      const button = this.element.querySelector(`[data-collection='${type}']`);
      if (button) button.remove();

      const buttonSecond = this.element.querySelector('.pc__collection');
      if (buttonSecond) buttonSecond.setAttribute('aria-expanded', 'true');
      const containerSecond = this.element.querySelector('.pc__carousel');
      if (containerSecond) {
        containerSecond.classList.remove('is-hidden');
        containerSecond.setAttribute('aria-hidden', 'false');
      }

      if (!containerSecond.hasAttribute("slider-initialized")) {
        new RevolutionSwiper(containerSecond);
      }



      document.dispatchEvent(new CustomEvent('update-favorites'));
    }
  }

  getRecentProductsQuery() {
    const viewedProducts = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
    const currentProduct = this.element.dataset.productid;
    return viewedProducts.filter(item => item !== currentProduct).map(id => `id:${id}`).join(' OR ');
  }

  openTab(target) {
    const currentlyOpen = this.element.querySelector("[aria-expanded='true']");
    if (currentlyOpen) this.closeTab(currentlyOpen.dataset.collection);

    target.setAttribute("aria-expanded", "true");
    const toggleElement = this.element.querySelector(`#${target.dataset.collection}`);
    if (toggleElement) {
      toggleElement.classList.remove("is-hidden");
      if (!toggleElement.hasAttribute("slider-initialized")) {
        new RevolutionSwiper(toggleElement);
        toggleElement.setAttribute("slider-initialized", true);
      }
      requestAnimationFrame(() => toggleElement.setAttribute("aria-hidden", "false"));
    }
  }

  closeTab(target) {
    const toggleElement = this.element.querySelector(`#${target}`);
    if (toggleElement) {
      toggleElement.setAttribute("aria-hidden", "true");
      requestAnimationFrame(() => toggleElement.classList.add("is-hidden"));
      const button = this.element.querySelector(`[data-collection='${target}']`);
      if (button) button.setAttribute("aria-expanded", "false");
    }
  }

  toggleTab(event) {
    const target = event.target;
    const targetCollection = target.dataset.collection;
    const toggleElement = this.element.querySelector(`#${targetCollection}`);
    if (!toggleElement) return;
    if (target.getAttribute("aria-expanded") === "true") return;
    this.openTab(target);
  }
}

customElements.define("product-carousel", ProductCarousel);




class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateBody = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
    this.element.querySelectorAll('.RevolutionSelectbox').forEach(box => new RevolutionSelectbox(box));

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on("change:countrySelector", this.updateLanguageOptions.bind(this));
    this.delegateElement.on('keydown', '[data-action="select-language"]', this.selectLanguage.bind(this));
    this.delegateElement.on(
      'keydown',
      '[data-action="select-language"]',
      onEnter(this.selectLanguage.bind(this))
    );
    this.delegateElement.on(
      'keydown',
      '.language-option',
      onEnter(event => {
        event.target.querySelector("input").checked = true;
      })
    );
    
  }

  selectLanguage(e, target) {
    if (e.key === 'Enter') {
      target.previousElementSibling.checked = true;
    }
  }

  updateLanguageOptions(e) {
    const languagesJSON = e.detail.languages;
    const languages = JSON.parse(languagesJSON);
    const languageOptionsContainer = this.element.querySelector(".language-options");
    const selectedLanguageInput = this.element.querySelector("#selected-language");
    if (!languages) return;

    languageOptionsContainer.innerHTML = "";
    languageOptionsContainer.appendChild(selectedLanguageInput);
    languages.forEach(language => {
      const label = document.createElement("label");
      const span_1 = document.createElement("span");
      const span_2 = document.createElement("span");
      const parentSpan = document.createElement("span");
      parentSpan.classList.add('language-option__label');
      span_1.classList.add('checkmark', 'Svg--checkbox-square-solid');
      span_2.classList.add('checkmark', 'Svg--checkbox-square');
      const checkmark_1 = `<svg class="svg__dot-circle " width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.99998 6.11111C10.7691 6.11111 11.521 6.33919 12.1605 6.76651C12.8001 7.19383 13.2985 7.80119 13.5928 8.51179C13.8872 9.22239 13.9642 10.0043 13.8141 10.7587C13.6641 11.5131 13.2937 12.206 12.7498 12.7499C12.206 13.2937 11.513 13.6641 10.7587 13.8142C10.0043 13.9642 9.22237 13.8872 8.51176 13.5929C7.80116 13.2985 7.1938 12.8001 6.76648 12.1606C6.33917 11.521 6.11109 10.7692 6.11109 10C6.11109 8.96861 6.52081 7.97945 7.25012 7.25014C7.97943 6.52084 8.96858 6.11111 9.99998 6.11111Z"></path>
        <path d="M9.99998 18.8889C8.24192 18.8889 6.52334 18.3676 5.06157 17.3908C3.5998 16.4141 2.46049 15.0259 1.78771 13.4016C1.11494 11.7774 0.938906 9.99014 1.28189 8.26587C1.62487 6.54159 2.47145 4.95774 3.71458 3.71461C4.95772 2.47148 6.54157 1.62489 8.26584 1.28191C9.99012 0.938932 11.7774 1.11496 13.4016 1.78774C15.0258 2.46052 16.4141 3.59983 17.3908 5.0616C18.3675 6.52337 18.8889 8.24195 18.8889 10C18.8889 12.3575 17.9524 14.6184 16.2854 16.2854C14.6184 17.9524 12.3575 18.8889 9.99998 18.8889ZM9.99998 2.22223C8.46168 2.22223 6.95792 2.67838 5.67888 3.53302C4.39983 4.38765 3.40293 5.60237 2.81425 7.02358C2.22557 8.44478 2.07154 10.0086 2.37165 11.5174C2.67175 13.0261 3.41252 14.412 4.50026 15.4997C5.588 16.5875 6.97387 17.3282 8.48261 17.6283C9.99135 17.9284 11.5552 17.7744 12.9764 17.1857C14.3976 16.5971 15.6123 15.6002 16.467 14.3211C17.3216 13.0421 17.7778 11.5383 17.7778 10C17.7778 7.93721 16.9583 5.9589 15.4997 4.50028C14.0411 3.04167 12.0628 2.22223 9.99998 2.22223Z"></path>
      </svg>`;
      const checkmark_2 = `<svg class="svg__circle " width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.11108 10C1.11108 5.0908 5.09078 1.11111 9.99997 1.11111C14.9092 1.11111 18.8889 5.0908 18.8889 10C18.8889 14.9092 14.9092 18.8889 9.99997 18.8889C5.09078 18.8889 1.11108 14.9092 1.11108 10ZM2.38093 10C2.38093 14.2079 5.79209 17.619 9.99997 17.619C12.0207 17.619 13.9586 16.8163 15.3875 15.3875C16.8163 13.9586 17.619 12.0207 17.619 10C17.619 5.79212 14.2079 2.38095 9.99997 2.38095C5.79209 2.38095 2.38093 5.79212 2.38093 10Z"></path>
      </svg>`;
      span_2.innerHTML = checkmark_2;
      span_1.innerHTML = checkmark_1;
      parentSpan.appendChild(span_1);
      parentSpan.appendChild(span_2);

      label.classList.add("language-option", 'u-p4');
      label.setAttribute('tabindex', '0');

      const input = document.createElement("input");
      input.type = "radio";
      input.classList.add("language-selector__radio");
      input.name = "language_code";
      input.value = language.iso;
      input.style.display = "none";

      if (language.iso == selectedLanguageInput.value) {
        input.checked = true;
        selectedLanguageInput.value = language.iso;
      }


      label.appendChild(input);
      label.appendChild(parentSpan);
      label.appendChild(document.createTextNode(language.name));


      languageOptionsContainer.appendChild(label);
    });
  }
}
customElements.define("localization-modal", LocalizationModal);


class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.searchTypes = [
      { id: "collection__main-grid", type: "product" },
      { id: "collection__main-grid-articles", type: "article" },
    ];
  }

  connectedCallback() {
    this.filterBar = this.element.querySelector(".collection__header");
    this.loadType = this.element.dataset.load;

    new AddToCart(this.element);
    this.delegateElement = new Delegate(this.element);

    this.bindEvents();
    this.initialize();
  }

  initialize() {
    if (this.loadType === "scroll") {
      this.bindObservers();
    } else {
      this.delegateElement.on("click", '[data-action="load-initial"]', this.handleClick.bind(this));
    }

    if (window.location.pathname.includes('/view/article-primary')) {
      this.toggleGridBasedOnUrl();
    }
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="toggle-collection"]', this.toggleGrid.bind(this));
    window.addEventListener("popstate", this.toggleGridBasedOnUrl.bind(this));
  }

  bindObservers() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25,
    };

    this.searchTypes.forEach((searchType) => {
      const container = document.getElementById(searchType.id);
      const paginationElement = container.querySelector(".infinite-scroll");
      if (!container || !paginationElement) return;

      // Select the second-to-last child
      const children = container.children;
      const target = children[children.length - 2];

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paginationElement.remove();
            observer.unobserve(target);

            this.fetchSearchType(searchType.id, searchType.type);
          }
        });
      }, observerOptions);

      observer.observe(target);
    });
  }

  async handleClick(e) {
    e.preventDefault();
    e.target.querySelector(".itemLoader").classList.add("is-visible");
    const paginationElement = e.target.parentElement;

    const matchingObject = this.searchTypes.find(
      (item) => item.type === paginationElement.dataset.type
    );
    await this.fetchSearchType(matchingObject.id, matchingObject.type);

    paginationElement.remove();
  }

  async fetchSearchType(gridContainerId, type) {
    let path = window.location.pathname;

    for (const searchType of this.searchTypes) {
      const pattern = `/view/${searchType.type}s`;
      if (path.includes(pattern)) {
        path = path.replace(pattern, "");
        break;
      }
    }

    const currentUrl = new URL(window.location.href);

    if (type === "article") {
      const paramsToRemove = [];

      for (const param of currentUrl.searchParams.keys()) {
        if (param.startsWith("filter")) {
          paramsToRemove.push(param);
        }
      }

      for (const param of paramsToRemove) {
        currentUrl.searchParams.delete(param);
      }
    }

    currentUrl.searchParams.delete("type");
    currentUrl.searchParams.delete("page");

    currentUrl.searchParams.set("type", type);
    currentUrl.searchParams.set("page", "2");

    const updatedUrl = `${path}?${currentUrl.searchParams.toString()}`;

    await this.renderSectionFromFetch(updatedUrl, gridContainerId);
  }

  async renderSectionFromFetch(url, gridContainerId) {
    try {
      const response = await fetch(url);
      const html = await response.text();

      this.renderGrid(html, gridContainerId);
    } catch (error) {
      console.error("Error fetching section on main search:", error);
    }
  }

  renderGrid(html, gridContainerId) {
    const newGridContent = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById(gridContainerId);
    if (!newGridContent) return;

    const gridContainer = document.getElementById(gridContainerId);
    gridContainer.insertAdjacentHTML("beforeend", newGridContent.innerHTML);
    new RevolutionAnimation(gridContainer);

    const newPaginationElement =
      newGridContent.querySelector(".infinite-scroll");
    document.dispatchEvent(new CustomEvent('update-favorites'));
    if (!newPaginationElement) return;
    new InfiniteScroll(`#${gridContainerId}`, `#${newPaginationElement.id}`);
  }

  toggleGrid(e) {
    const target = e.target.closest('[data-action="toggle-collection"]');
    const id = target.getAttribute("aria-controls");

    this.updatePath(id);

    /*     if (this.filterBar) {
          id.includes("product")
            ? this.filterBar.setAttribute("aria-hidden", "false")
            : this.filterBar.setAttribute("aria-hidden", "true");
        } */

    const gridsToHide = this.element.querySelectorAll(
      '.collection__grid[aria-hidden="false"]'
    );
    const gridToShow = this.element.querySelector(`#${id}`);

    gridsToHide.forEach((grid) => grid.setAttribute("aria-hidden", "true"));
    gridToShow.setAttribute("aria-hidden", "false");
  }

  toggleGridBasedOnUrl() {
    if (window.location.pathname.includes('/view/article-primary')) {
      this.element.querySelector('[aria-controls="collection-article"]')?.click();
    } else {
      this.element.querySelector('[aria-controls="collection-product"]')?.click();
    }
  }

  // Depending on where user refreshes, show them the type of results they were on before refreshing
  updatePath(id) {
    const url = new URL(window.location.href);
    const pathname = url.pathname;
    let updatedPathname = pathname;

    if (id.includes('article') && pathname.includes('/search') && !pathname.includes('/view/article-primary') && !window.location.href.includes("filter")) {
      updatedPathname = pathname.replace('/search', '/search/view/article-primary');
      window.history.replaceState({}, '', updatedPathname + url.search);
    } else if (!id.includes('article') && pathname.includes('/view/article-primary')) {
      updatedPathname = pathname.replace('/view/article-primary', '');
      window.history.replaceState({}, '', updatedPathname + url.search);
    }
  }
}
customElements.define("search-component", MainSearch);

class TextAnimation extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.textContainers = [];
    this.observers = [];
    this.animationTimeout = null;
    this.delegateBody = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
  }

  connectedCallback() {
    // Use a regular class selector to find inner elements
    this.textContainers = this.querySelectorAll(
      ".quote-section__animated-text"
    );
    this.init();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "mouseout",
      this.resetAndAnimate.bind(this)
    );
  }

  init() {
    this.textContainers.forEach((container) => {
      if (container) {
        this.initObserver(container);
      }
    });
  }

  initObserver(container) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.activateAnimation(container);
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    observer.observe(container);
    this.observers.push(observer);
  }

  activateAnimation(container) {
    const text =
      container.getAttribute("data-original-text") ||
      container.textContent.trim();
    container.setAttribute("data-original-text", text);
    container.innerHTML = "";

    const paragraph = document.createElement("p");
    container.appendChild(paragraph);

    const words = text.split(" ");
    words.forEach((word, wordIndex) => {
      const wordDiv = document.createElement("span");
      wordDiv.classList.add("word-wrapper");

      [...word].forEach((char) => {
        const span = document.createElement("span");
        span.textContent = char;
        span.style.color = "var(--secondary_grey)";
        span.classList.add("rte", "u-h5");
        wordDiv.appendChild(span);
      });

      paragraph.appendChild(wordDiv);
    });

    const letters = container.querySelectorAll(".word-wrapper span");
    letters.forEach((letter, index) => {
      setTimeout(() => {
        letter.style.transition = "color 0s ease";
        letter.style.color = "var(--primary_text)";
      }, index * 30);
    });

    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
    }


  }

  resetAndAnimate() {
    this.observers.forEach((observer) => observer.disconnect());
    this.textContainers.forEach((container) => {
      this.initObserver(container);
      this.activateAnimation(container);
    });
  }
}

customElements.define("text-animation", TextAnimation);



class CustomOne extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElem = new Delegate(this.element);
    this.containerRect = this.element.getBoundingClientRect();

    this.parseText();
    this.settings();
    this.bindEvents();
    this.handleScroll();
  }

  bindEvents() {
    window.addEventListener("scroll", this.handleScroll.bind(this));
  }

  settings() {
    this.keyframesFill = [{ color: "var(--primary_text)" }];

    this.keyframesReset = [{ color: "var(--secondary_grey)" }];

    this.options = {
      duration: 350,
      easing: "linear",
      fill: "forwards",
    };

    this.textBox = this.element.querySelector(".custom-one__text");
    this.letters = this.textBox.querySelectorAll(".custom-one__letter");

    this.scrollDistancePerLetter =
      (window.innerHeight - 600) / this.totalLetters;
  }

  handleScroll() {
    this.containerRect = this.element.getBoundingClientRect();
    const scrollPosition =
      window.innerHeight - 72 - this.textBox.getBoundingClientRect().top;

    this.letters.forEach((letter, index) => {
      const letterScrollPosition = index * this.scrollDistancePerLetter;
      if (letterScrollPosition <= scrollPosition) {
        letter.animate(this.keyframesFill, this.options);
      } else {
        letter.animate(this.keyframesReset, this.options);
      }
    });
  }

  parseText() {
    this.totalLetters = 0;
    this.element.querySelectorAll(".custom-one__text p").forEach((elem) => {
      var words = elem.textContent.split(" ");

      elem.innerHTML = words
        .map((word) => {
          var letters = word.split("");
          this.totalLetters += letters.length;
          letters = letters
            .map((letter) => {
              return (
                '<span class="custom-one__letter u-h5">' + letter + "</span>"
              );
            })
            .join("");
          return '<span class="custom-one__word">' + letters + " </span>";
        })
        .join(" ");
    });
  }
}
customElements.define("custom-one", CustomOne);




class BlogShowcaseSlider extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
  }
}

customElements.define("blog-showcase", BlogShowcaseSlider);

class CustomArticle extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    document.addEventListener('DOMContentLoaded', () => {
      this.applyTextFade();
    });
  }

  applyTextFade() {
    const articleContents = this.element.querySelectorAll('.blog__article-content');
    if (articleContents) {
      articleContents.forEach(content => {
        const lineHeight = parseFloat(window.getComputedStyle(content).lineHeight);
        const elementHeight = content.clientHeight;
        if (lineHeight && elementHeight && Math.round(elementHeight / lineHeight) === 3) {
          content.classList.add('has-overflow');
        }
      });
    }
  }
}

customElements.define("custom-article", CustomArticle);

class ProductDetail extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.isDesktop = new Responsive().matchesBreakpoint("lap_and_up");
    this.mainImgWrapper = this.element.querySelector(".product-detail__main-image-wrapper");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.featureButtons = this.mainImgWrapper.querySelectorAll(".feature-block__dot");
    this.contentForDrawer = this.element.querySelector("#product-detail__main-content-wrapper");
    this.drawer = document.querySelector("#product-detail__drawer")
    this.drawerContent = this.drawer.querySelector(".Drawer--Content")

    this.initDrawerAndCarousel();

    this.initScrollableContent();
    this.initFeatureButtons();
    this.initCarousel();
    this.bindEvents();
  }

  bindEvents() {
    this.delegate.on("click", "[data-action='select-slide']", this.handleDotClick.bind(this));
    this.delegate.on("keypress", "[data-action='select-slide']", this.handleDotKeypress.bind(this));
    this.carousel.swiperElement.on("slideChange", this.handleSlideChange.bind(this));
    this.delegateBody.on("product-detail__drawer:change-slide", this.handleDotClick.bind(this));
    this.delegateBody.on("product-detail__drawer:close", this.removeActiveButtons.bind(this));
  }

  initDrawerAndCarousel() {
    if (!this.isDesktop) {
      if (this.contentForDrawer && this.drawerContent) {
        const clonedContent = this.contentForDrawer.cloneNode(true);
        this.drawerContent.appendChild(clonedContent);
        new Drawer(this.drawer);
        let showContent = this.drawer.querySelector(".product-detail__main-content-wrapper");
        showContent?.setAttribute("aria-hidden", "false");

        this.carouselElement = this.drawer.querySelector(".swiper");
      }
    } else {
      this.carouselElement = this.element.querySelector(".swiper");
    }

    if (this.carouselElement) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }

  initScrollableContent() {
    this.element.querySelectorAll(".rich-text__block-wrapper").forEach(element => {
      element.setAttribute("data-scrollable", "true");
    });
  }

  initFeatureButtons() {
    this.featureButtons.forEach((button, index) => {
      button.setAttribute("data-index", index);
      if (!this.isDesktop) {
        button.setAttribute("data-action", "toggle-drawer")
      }
    });
  }

  initCarousel() {
    if (!this.isDesktop) return;
    const slides = [...this.carousel.swiperElement.slides];
    const openSlide = slides.find(slide => slide.getAttribute("data-is-open") === "true");
    const openSlideIndex = openSlide ? slides.indexOf(openSlide) : 0;

    this.carousel.swiperElement.slideToLoop(openSlideIndex);
    this.featureButtons.forEach((button, index) => {
      button.setAttribute("aria-selected", index === openSlideIndex ? "true" : "false");
    });
  }

  removeActiveButtons() {
    this.featureButtons.forEach((button) => {
      button.setAttribute("aria-selected", "false");
    });
  }

  handleDotClick(event) {
    let index;
    if (event.detail.buttonIndex) {
      index = Number(event.detail.buttonIndex);
    } else {
      index = Number(event.target.dataset.index);
    }

    if (!this.isDesktop) {
      this.carousel.swiperElement.slideToLoop(index, 0, false);
    } else {
      this.carousel.swiperElement.slideToLoop(index);
    }

    this.updateFeatureButtonState(index);
  }

  handleDotKeypress(event) {
    if (event.key.toLowerCase() === "enter") event.target.click();
  }

  handleSlideChange() {
    const index = this.carousel.swiperElement.realIndex;
    this.updateFeatureButtonState(index);
  }

  updateFeatureButtonState(activeIndex) {
    this.featureButtons.forEach((button, index) => {
      const isSelected = index === activeIndex;
      button.setAttribute("aria-selected", isSelected ? "true" : "false");
      button.tabIndex = isSelected ? -1 : 0;
    });
  }
}

customElements.define("product-detail-section", ProductDetail);

class PermalinkBuilder extends HTMLElement {
  constructor() {
    super();
    this.delegateElement = new Delegate(this);
  }

  connectedCallback() {
    this.marketHandle = this.dataset.marketHandle;
    this.generateBtn = this.querySelector('[data-action="generate"]');
    this.resetBtn = this.querySelector('[data-action="reset"]');
    this.resultWrapper = this.querySelector('#result-wrapper');
    this.generatedLink = this.querySelector('#generated-link');
    this.marketSelect = this.querySelector('#market-select');
    this.discountInput = this.querySelector('#discount-input');
    this.copyBtn = this.querySelector('[data-action="copy"]');
    this.copyFeedback = this.querySelector('#copy-feedback');
    this.errorMessage = this.querySelector('#error-message');
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on('click', '[data-action="generate"]', this.generateUrl.bind(this));
    this.delegateElement.on('click', '[data-action="copy"]', this.copyToClipboard.bind(this));
    this.delegateElement.on('click', '[data-action="reset"]', this.resetToken.bind(this));
    if (this.marketSelect) {
      this.marketSelect.addEventListener('change', this.onMarketChange.bind(this));
    }
  }

  onMarketChange(event) {
    const form = event.target.closest('form');
    if (form) form.submit();
  }

  async generateUrl() {
    this.setLoadingState(true);
    this.errorMessage.style.display = 'none';
    this.resultWrapper.style.display = 'none';

    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      if (!cart.token) throw new Error('Could not retrieve cart token.');

      const domain = window.location.origin;
      const cartToken = cart.token;
      const discountCode = this.discountInput.value.trim();

      // build URL with URL and URLSearchParams
      const url = new URL(`${domain}/checkouts/cn/${cartToken}`);
      if (discountCode) {
        url.searchParams.set('discount', discountCode);
      }

      const finalUrl = url.toString();
      this.generatedLink.href = finalUrl;
      this.generatedLink.textContent = finalUrl;
      this.resultWrapper.style.display = 'block';

    } catch (error) {
      this.errorMessage.textContent = error.message;
      this.errorMessage.style.display = 'block';
      console.error('Error creating link:', error);
    } finally {
      this.setLoadingState(false);
    }
  }

  async resetToken() {
    this.setResetLoadingState(true);
    this.errorMessage.style.display = 'none';

    try {
      // Delete the specified cookies
      this.deleteCookie('cart');
      this.deleteCookie('cart_currency');
      this.deleteCookie('cart_sig');

      // Refresh the page
      window.location.href = "/";

    } catch (error) {
      this.errorMessage.textContent = `Reset failed: ${error.message}`;
      this.errorMessage.style.display = 'block';
      console.error('Error resetting token:', error);
      this.setResetLoadingState(false);
    }
  }

  deleteCookie(name) {
    // Delete cookie for current path
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    
    // Delete cookie for root path (in case it was set there)
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
    
    // Delete cookie with domain prefix (covers subdomains)
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;
  }

  setLoadingState(isLoading) {
    const buttonText = this.generateBtn.querySelector('.button-text');
    const buttonLoader = this.generateBtn.querySelector('.button-loader');
    this.generateBtn.disabled = isLoading;
    if (buttonText && buttonLoader) {
      buttonText.style.display = isLoading ? 'none' : 'inline';
      buttonLoader.style.display = isLoading ? 'inline' : 'none';
    }
  }

  setResetLoadingState(isLoading) {
    const buttonText = this.resetBtn.querySelector('.button-text');
    const buttonLoader = this.resetBtn.querySelector('.button-loader');
    this.resetBtn.disabled = isLoading;
    if (buttonText && buttonLoader) {
      buttonText.style.display = isLoading ? 'none' : 'inline';
      buttonLoader.style.display = isLoading ? 'inline' : 'none';
    }
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.generatedLink.href).then(() => {
      this.copyFeedback.textContent = 'Copied!';
      this.copyBtn.textContent = 'Copied!';
      setTimeout(() => {
        this.copyFeedback.textContent = '';
        this.copyBtn.textContent = 'Copy';
      }, 2000);
    });
  }
}

if (!customElements.get('permalink-builder')) {
  customElements.define('permalink-builder', PermalinkBuilder);
}


/* ACCESSIBILITY FUNCTIONS */

function onEnter(callback){
  return function(event){
    if(event.key === 'Enter' || event.keyCode === 13) {
      callback(event);
   }
 }
}

function onEscape(callback) {
  return function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      callback(event);
    }
  }
}

function announceToLiveRegion(messageKey) {
  const liveRegion = document.getElementById('aria-live-region');
  if (!liveRegion) return;

  const message = liveRegion.dataset[messageKey]; // ✅ Correct usage

  if (!message){
    return;
  } 

  liveRegion.textContent = '';
  setTimeout(() => {
    liveRegion.textContent = message;
  }, 50);
}

